!(function (HawkSearchLoader, undefined) {
    var jQuery;
    (HawkSearchLoader.loadjQuery = HawkSearch.loadjQuery === undefined || HawkSearch.loadjQuery),
        (HawkSearchLoader.debugMode = HawkSearch.debugMode !== undefined && HawkSearch.debugMode),
        (HawkSearchLoader.disableAjax = HawkSearch.disableAjax !== undefined && HawkSearch.disableAjax),
        (HawkSearch.SuggesterGlobal = { qf: "", lookupURL: "", divName: "", lastVal: "", searching: !1, globalDiv: null, divFormatted: !1, focus: !1, defaultKeyword: [] }),
        (HawkSearch.GetQueryStringValue = (function (e) {
            if ("" == e) return {};
            for (var t = {}, i = 0; i < e.length; ++i) {
                var n = e[i].split("=");
                2 == n.length && (t[n[0]] = decodeURIComponent(n[1].replace(/\+/g, " ")));
            }
            return t;
        })(window.location.search.substr(1).split("&"))),
        (HawkSearch.getTrackingUrl = function () {
            return HawkSearch.TrackingUrl === undefined || "" === HawkSearch.TrackingUrl ? HawkSearch.BaseUrl : HawkSearch.TrackingUrl;
        }),
        (HawkSearch.getHawkUrl = function () {
            return HawkSearch.HawkUrl === undefined || "" === HawkSearch.HawkUrl ? HawkSearch.BaseUrl : HawkSearch.HawkUrl;
        }),
        (HawkSearch.getClientGuid = function () {
            return HawkSearch.ClientGuid !== undefined ? HawkSearch.ClientGuid : "";
        }),
        (HawkSearch.RecommendationContext = { visitId: "", visitorId: "", baseUrl: HawkSearch.getHawkUrl(), clientGuid: HawkSearch.getClientGuid(), enablePreview: !1, widgetUids: [], contextProperties: [], customProperties: [] }),
        (HawkSearch.EventBase = { version: "0.1a", event_type: "PageLoad" }),
        (HawkSearch.Tracking = {}),
        (HawkSearch.Tracking.eventQueue = []),
        (HawkSearch.Tracking.isReady = !1),
        (HawkSearch.Tracking.ready = function (e) {
            HawkSearch.Tracking.isReady ? e(HawkSearch.jQuery) : HawkSearch.Tracking.eventQueue.push(e);
        }),
        (HawkSearch.Tracking.setReady = function (e) {
            for (var t; (t = HawkSearch.Tracking.eventQueue.shift()); ) t(e);
            HawkSearch.Tracking.isReady = !0;
        }),
        (HawkSearch.Tracking.CurrentVersion = function () {
            return HawkSearch.jQuery("#hdnhawktrackingversion").val();
        }),
        (HawkSearch.Tracking.Version = { none: "none", v1: "v1", v2: "v2", v2AndSQL: "v2AndSQL" }),
        (HawkSearch.Tracking.writePageLoad = function (e) {
            HawkSearch.Tracking.ready(function () {
                e === undefined && (e = "");
                var t = HawkSearch.LilBro.Schema.PageLoad.PageType.itemDetails;
                switch (e.toLowerCase()) {
                    case "page":
                        t = HawkSearch.LilBro.Schema.PageLoad.PageType.landingPage;
                        break;
                    case "item":
                        t = HawkSearch.LilBro.Schema.PageLoad.PageType.itemDetails;
                        break;
                    case "cart":
                        t = HawkSearch.LilBro.Schema.PageLoad.PageType.shoppingCart;
                        break;
                    case "order":
                        t = HawkSearch.LilBro.Schema.PageLoad.PageType.orderConfirmation;
                        break;
                    case "custom":
                        t = HawkSearch.LilBro.Schema.PageLoad.PageType.custom;
                        break;
                    default:
                        t = HawkSearch.LilBro.Schema.PageLoad.PageType.itemDetails;
                }
                log("Tracking: write page load");
                var i = null;
                HawkSearch.Context && (i = HawkSearch.Context.keyValuePairs()),
                    (HawkSearch.Tracking.CurrentVersion() != HawkSearch.Tracking.Version.v2 && HawkSearch.Tracking.CurrentVersion() != HawkSearch.Tracking.Version.v2AndSql) ||
                        HawkSearch.lilBro.write({ event_type: "PageLoad", tracking_properties: JSON.stringify(i), page_type_id: t });
            });
        }),
        (HawkSearch.Tracking.writeSearchTracking = function (e) {
            HawkSearch.Tracking.ready(function (t) {
                var i = t;
                if (null != e && "" !== e) {
                    var n = HawkSearch.LilBro.Schema.Search.SearchType.Refinement;
                    0 === i("#hdnhawkquery").length &&
                        (i("<input>").attr({ type: "hidden", id: "hdnhawkquery", name: "hdnhawkquery" }).appendTo("body"),
                        i("#hdnhawkquery").val(HawkSearch.lilBro.event.createUUID()),
                        (n = HawkSearch.LilBro.Schema.Search.SearchType.Search)),
                        HawkSearch.getHashOrQueryVariable("mpp"),
                        HawkSearch.getHashOrQueryVariable("pg"),
                        HawkSearch.getHashOrQueryVariable("sort"),
                        HawkSearch.getHashOrQueryVariable("hawks");
                    var o = HawkSearch.getCustomUrl();
                    "/" == o && (o = ""), log("Tracking: write search type" + n), HawkSearch.lilBro.write({ event_type: "Search", tracking_id: e, query_id: i("#hdnhawkquery").val(), type_id: n, lpurl: o });
                }
            });
        }),
        (HawkSearch.Tracking.writeSearch = function () {
            HawkSearch.Tracking.ready(function (e) {
                var t = HawkSearch.lilBro.getTrackingId();
                null != t && HawkSearch.Tracking.writeSearchTracking(t);
            });
        }),
        (HawkSearch.Tracking.writeClick = function (e, t, i, n, o) {
            if ((log("Tracking: write click"), null != o)) {
                var s = s || jQuery,
                    a = s("#hdnhawkmpp").val(),
                    r = s("#hdnhawkpg").val();
                r > 1 && (t += a * (r - 1));
                var l = e.currentTarget.href,
                    c = escape(e.currentTarget.href.href).replace(/\+/g, "%2B");
                HawkSearch.lilBro.write({ url: l, event_type: "Click", tracking_id: o, element_no: t, mlt: !0 === i, unique_id: n, location: c, ev: e });
            }
        }),
        (HawkSearch.Tracking.writeBannerClick = function (e, t) {
            log("Tracking: banner click id:" + t), HawkSearch.lilBro.write({ event_type: "BannerClick", banner_id: t, tracking_id: HawkSearch.lilBro.getTrackingId() });
        }),
        (HawkSearch.Tracking.writeBannerImpression = function (e) {
            HawkSearch.Tracking.ready(function () {
                log("Tracking: banner impression id:" + e), HawkSearch.lilBro.write({ event_type: "BannerImpression", banner_id: e, tracking_id: HawkSearch.lilBro.getTrackingId() });
            });
        }),
        (HawkSearch.Tracking.writeSale = function (e, t, i, n, o, s) {
            HawkSearch.Tracking.ready(function () {
                log("Tracking: write sale"),
                    HawkSearch.lilBro.write({ event_type: "Sale", order_no: e, item_list: JSON.stringify(t), total: i, tax: o, currency: s, sub_total: n }, function () {
                        HawkSearch.lilBro.event.clearVisitId(), log("Tracking visit id clared after order.");
                    });
            });
        }),
        (HawkSearch.Tracking.writeAdd2Cart = function (e, t, i, n) {
            HawkSearch.Tracking.ready(function () {
                log("Tracking: write Add2Cart"), HawkSearch.lilBro.write({ event_type: "Add2Cart", unique_id: e, price: t, quantity: i, currency: n });
            });
        }),
        (HawkSearch.Tracking.writeAdd2CartMultiple = function (e) {
            if (!e) throw "Items list cannot be null.";
            if ("[object Array]" !== Object.prototype.toString.call(e)) throw "Items list has to be an array.";
            if (0 == e.length) throw "Items list cannot be empty.";
            HawkSearch.Tracking.ready(function () {
                log("Tracking: write Add2CartMultiple"), HawkSearch.lilBro.write({ event_type: "Add2CartMultiple", items_list: JSON.stringify(e) });
            });
        }),
        (HawkSearch.Tracking.writeRate = function (e, t) {
            if (!(t < 1 || t > 5)) {
                HawkSearch.Tracking.ready(function () {
                    log("Tracking: write Rate"), HawkSearch.lilBro.write({ event_type: "Rate", unique_id: e, value: t });
                });
            }
        }),
        (HawkSearch.Tracking.writeRecommendationClick = function (e, t, i, n) {
            HawkSearch.Tracking.ready(function () {
                log("Tracking: write RecommendationClick"), HawkSearch.lilBro.write({ event_type: "RecommendationClick", widget_guid: e, unique_id: t, item_index: i, request_id: n });
            });
        }),
        (HawkSearch.Tracking.writeAutoCompleteClick = function (e, t, i, n, o) {
            log("AutoComplete: item click id:" + n);
            HawkSearch.lilBro.write({ event_type: "AutoCompleteClick", url: o, suggest_type: i, name: n, keyword: e });
        }),
        (HawkSearch.Tracking.track = function (e, t) {
            var i = HawkSearch.Tracking;
            switch (e.toLowerCase()) {
                case "pageload":
                    return i.writePageLoad(t.pageType);
                case "search":
                    return i.writeSearch();
                case "searchtracking":
                    return i.writeSearchTracking(t.trackingId);
                case "click":
                    return i.writeClick(t.event, t.elementNo, t.mlt, t.uniqueId, t.trackingId);
                case "bannerclick":
                    return i.writeBannerClick(t.el, t.id);
                case "bannerimpression":
                    return i.writeBannerImpression(t.id);
                case "sale":
                    return i.writeSale(t.orderNo, t.itemList, t.total, t.subTotal, t.tax, t.currency);
                case "add2cart":
                    return i.writeAdd2Cart(t.uniqueId, t.price, t.quantity, t.currency);
                case "add2cartmultiple":
                    return i.writeAdd2CartMultiple(t);
                case "rate":
                    return i.writeRate(t.uniqueId, t.value);
                case "recommendationclick":
                    return i.writeRecommendationClick(t.widgetGuid, t.uniqueId, t.itemIndex, t.requestId);
                case "autocompleteclick":
                    return i.writeAutoCompleteClick(t.keyword, t.event, t.suggest_type, t.name, t.itemUrl);
            }
            throw "No such tracking event: " + e;
        }),
        (HawkSearch.Tracking.V1 = {}),
        (HawkSearch.Tracking.V1.bannerLink = function (e, t) {
            return (e.href = HawkSearch.getTrackingUrl() + "/banners.aspx?BannerId=" + t), (e.mousedown = ""), !0;
        }),
        (HawkSearch.Tracking.V1.autosuggestClick = function (e, t, i, n) {
            var o = "&keyword=" + encodeURIComponent(e) + "&name=" + encodeURIComponent(t) + "&type=" + n + "&url=" + encodeURIComponent(i),
                s = HawkSearch.BaseUrl + "?fn=ajax&f=GetAutoCompleteClick" + o,
                a = a || jQuery;
            // a.ajax({
            //     type: "GET",
            //     data: "",
            //     async: "false",
            //     contentType: "application/json; charset=utf-8",
            //     url: s,
            //     dataType: "jsonp",
            //     success: function (e) {
            //         "True" === a.parseJSON(e).success ? log("success added tracking autocomplete click") : log("failed added tracking autocomplete click");
            //     },
            //     error: function (e) {
            //         log(e);
            //     },
            // });
        }),
        (HawkSearch.Tracking.V1.link = function (e, t, i, n, o) {
            var s = HawkSearch.getTrackingUrl() + "/link.aspx?id=" + escape(t) + "&q=" + escape(e.currentTarget.href).replace(/\+/g, "%2B") + "&i=" + i + "&pk=" + n + "&mlt=" + o;
            return (e.currentTarget.href = s), !0;
        }),
        (HawkSearch.initLilBroSchema = function () {
            (this.LilBro = this.LilBro || {}),
                (this.LilBro.Schema = {}),
                (this.LilBro.Schema.version = "default"),
                (this.LilBro.Schema.key_map = {
                    version: 1,
                    timestamp: 2,
                    event_type: 3,
                    visitor_id: 4,
                    visit_id: 5,
                    mouse_x: 6,
                    mouse_y: 7,
                    viewport_width: 8,
                    viewport_height: 9,
                    scroll_x: 10,
                    scroll_y: 11,
                    element_id: 12,
                    element_id_from: 13,
                    element_class: 14,
                    element_class_from: 15,
                    element_name: 16,
                    element_tag: 17,
                    element_type: 18,
                    element_checked: 19,
                    element_value: 20,
                    element_x: 21,
                    element_y: 22,
                    browser: 23,
                    browser_version: 24,
                    operating_system: 25,
                    request_path: 26,
                    qs: 27,
                    tracking_id: 28,
                    unique_id: 29,
                    element_no: 30,
                    mlt: 31,
                    keyword: 32,
                    current_page: 33,
                    max_per_page: 34,
                    items_count: 35,
                    sorting: 36,
                    is_custom: 37,
                }),
                (this.LilBro.Schema.type_map = { PageLoad: 1, Search: 2, Click: 3, Add2Cart: 4, Rate: 5, Sale: 6, BannerClick: 7, BannerImpression: 8, Login: 9, RecommendationClick: 10, AutoCompleteClick: 11, Add2CartMultiple: 14 }),
                (this.LilBro.Schema.PageLoad = {}),
                (this.LilBro.Schema.PageLoad.version = "pl01a"),
                (this.LilBro.Schema.PageLoad.key_map = {
                    version: 1,
                    timestamp: 2,
                    event_type: 3,
                    visitor_id: 4,
                    visit_id: 5,
                    viewport_width: 6,
                    viewport_height: 7,
                    browser: 8,
                    browser_version: 9,
                    operating_system: 10,
                    request_path: 11,
                    qs: 12,
                    tracking_properties: 13,
                    page_type_id: 14,
                }),
                (this.LilBro.Schema.PageLoad.PageType = { itemDetails: 1, landingPage: 2, shoppingCart: 3, orderConfirmation: 4, custom: 5 }),
                (this.LilBro.Schema.Search = {}),
                (this.LilBro.Schema.Search.version = "ref01a"),
                (this.LilBro.Schema.Search.SearchType = { Search: 1, Refinement: 2 }),
                (this.LilBro.Schema.Search.key_map = {
                    version: 1,
                    timestamp: 2,
                    event_type: 3,
                    visitor_id: 4,
                    visit_id: 5,
                    viewport_width: 6,
                    viewport_height: 7,
                    browser: 8,
                    browser_version: 9,
                    operating_system: 10,
                    request_path: 11,
                    qs: 12,
                    tracking_id: 13,
                    query_id: 14,
                    type_id: 15,
                }),
                (this.LilBro.Schema.Click = {}),
                (this.LilBro.Schema.Click.version = "cli01a"),
                (this.LilBro.Schema.Click.key_map = {
                    version: 1,
                    timestamp: 2,
                    event_type: 3,
                    visitor_id: 4,
                    visit_id: 5,
                    mouse_x: 6,
                    mouse_y: 7,
                    viewport_width: 8,
                    viewport_height: 9,
                    scroll_x: 10,
                    scroll_y: 11,
                    element_id: 12,
                    element_id_from: 13,
                    element_class: 14,
                    element_class_from: 15,
                    element_name: 16,
                    element_tag: 17,
                    element_type: 18,
                    element_checked: 19,
                    element_value: 20,
                    element_x: 21,
                    element_y: 22,
                    browser: 23,
                    browser_version: 24,
                    operating_system: 25,
                    request_path: 26,
                    qs: 27,
                    tracking_id: 28,
                    unique_id: 29,
                    mlt: 30,
                    element_no: 31,
                    url: 32,
                }),
                (this.LilBro.Schema.Rate = {}),
                (this.LilBro.Schema.Rate.version = "rat01a"),
                (this.LilBro.Schema.Rate.key_map = { version: 1, timestamp: 2, event_type: 3, visitor_id: 4, visit_id: 5, value: 6, unique_id: 7 }),
                (this.LilBro.Schema.Sale = {}),
                (this.LilBro.Schema.Sale.version = "sal01a"),
                (this.LilBro.Schema.Sale.key_map = { version: 1, timestamp: 2, event_type: 3, visitor_id: 4, visit_id: 5, order_no: 6, item_list: 7, total: 8, tax: 9, currency: 10, sub_total: 11 }),
                (this.LilBro.Schema.Add2Cart = {}),
                (this.LilBro.Schema.Add2Cart.version = "a2c01a"),
                (this.LilBro.Schema.Add2Cart.key_map = { version: 1, timestamp: 2, event_type: 3, visitor_id: 4, visit_id: 5, unique_id: 6, price: 7, quantity: 8, currency: 9 }),
                (this.LilBro.Schema.BannerClick = {}),
                (this.LilBro.Schema.BannerClick.version = "banclk01a"),
                (this.LilBro.Schema.BannerClick.key_map = { version: 1, timestamp: 2, event_type: 3, visitor_id: 4, visit_id: 5, tracking_id: 6, banner_id: 7 }),
                (this.LilBro.Schema.BannerImpression = {}),
                (this.LilBro.Schema.BannerImpression.version = "banimp01a"),
                (this.LilBro.Schema.BannerImpression.key_map = { version: 1, timestamp: 2, event_type: 3, visitor_id: 4, visit_id: 5, tracking_id: 6, banner_id: 7 }),
                (this.LilBro.Schema.RecommendationClick = {}),
                (this.LilBro.Schema.RecommendationClick.version = "recClick01a"),
                (this.LilBro.Schema.RecommendationClick.key_map = { version: 1, timestamp: 2, event_type: 3, visitor_id: 4, visit_id: 5, widget_guid: 6, unique_id: 7, item_index: 8, request_id: 9 }),
                (this.LilBro.Schema.AutoCompleteClick = {}),
                (this.LilBro.Schema.AutoCompleteClick.version = "autoComplClick01a"),
                (this.LilBro.Schema.AutoCompleteClick.key_map = { version: 1, timestamp: 2, event_type: 3, visitor_id: 4, visit_id: 5, suggest_type: 6, url: 7, name: 8, keyword: 9 }),
                (this.LilBro.Schema.AutoCompleteClick.AutoCompleteType = { popular: 1, category: 2, product: 3, content: 4 }),
                (this.LilBro.Schema.Add2CartMultiple = { version: "a2cm01a", key_map: { version: 1, timestamp: 2, event_type: 3, visitor_id: 4, visit_id: 5, items_list: 6 } });
        }),
        (HawkSearch.LilBro = function (e) {
            HawkSearch.initLilBroSchema();
            var t = this,
                i = null;
            function n(e, i, n) {
                return function (o) {
                    o || (o = window.event);
                    var s = t._findTarget(o);
                    if ((t.event.fill({ type: e, event: o, target: s }), i))
                        try {
                            i(t.event);
                        } catch (e) {}
                    null == n || n || ((o.cancelBubble = !0), o.stopPropagation && o.stopPropagation()), t.event.write(), (t.event = t.freshEvent());
                };
            }
            (this.initialize = function (e) {
                if ((this.ensureBase64Encoding(), e && e.server)) {
                    (i = e.jQuery),
                        this.watch_container(e.element, e.watch_focus),
                        (this.freshEvent = function () {
                            var t = {};
                            if (e.event_base) for (var i in e.event_base) e.event_base.hasOwnProperty(i) && (t[i] = e.event_base[i]);
                            var n = e.event_type || e.event_base.event_type || "PageLoad";
                            return new HawkSearch.LilBro.Event({
                                base: t,
                                key_map: e.key_map || HawkSearch.LilBro.Schema[n].key_map || HawkSearch.LilBro.Schema.key_map,
                                type_map: e.type_map || HawkSearch.LilBro.Schema.type_map,
                                server: e.server,
                                ssl_server: e.ssl_server,
                                visit_id_cookie: e.visit_id_cookie || "visit_id",
                                visitor_id_cookie: e.visitor_id_cookie || "visitor_id",
                            });
                        });
                    try {
                        if (sessionStorage && sessionStorage.getItem("lilbrobug" + window.location.protocol)) {
                            var t = decodeURIComponent(sessionStorage.getItem("lilbrobug" + window.location.protocol)),
                                n = new Image();
                            (n.onload = function () {
                                sessionStorage.removeItem("lilbrobug" + window.location.protocol);
                            }),
                                (n.src = t);
                        }
                    } catch (e) {
                        log("ERROR: " + e);
                    }
                    (this.event = this.freshEvent()), (HawkSearch.RecommendationContext.visitorId = this.event.getVisitorId()), (HawkSearch.RecommendationContext.visitId = this.event.getVisitId());
                }
            }),
                (this.watch_container = function (e, t) {
                    e &&
                        (e.addEventListener
                            ? (e.addEventListener("click", n("click"), !1), t && (e.addEventListener("focusin", n("focusin"), !1), e.addEventListener("focusout", n("focusout"), !1)))
                            : (e.attachEvent("onclick", n("click"), !1), t && (e.attachEvent("onfocusin", n("focusin"), !1), e.attachEvent("onfocusout", n("focusout"), !1))));
                }),
                (this.watch = function (e) {
                    e && e.element && (e.element.addEventListener ? e.element.addEventListener("click", n("click", e.callback, e.bubble), !1) : e.element.attachEvent("onclick", n("click", e.callback, e.bubble), !1));
                }),
                (this.createObjectProps = function (e) {
                    var t = e._key_map;
                    for (var i in t) e._event.hasOwnProperty(i) || (e._event[i] = "");
                }),
                (this.write = function (i, n) {
                    var o = HawkSearch.LilBro.Schema[i.event_type],
                        s = e.key_map || o.key_map,
                        a = o.version || HawkSearch.LilBro.Schema.version;
                    (t.event._key_map = s), this.createObjectProps(t.event);
                    var r = i.ev;
                    !i.ev && window.event && (r = window.event);
                    var l = t._findTarget(r);
                    for (var c in (t.event.fill({ type: i.event_type, event: r, target: l, version: a }), i)) t.event.set(c, i[c]);
                    t.event.write(n), (t.event = t.freshEvent());
                }),
                (this._findTarget = function (e) {
                    var t = null;
                    return e && e.target ? (t = e.target) : e && e.srcElement && (t = e.srcElement), t && 3 == t.nodeType && (t = t.parentNode), t;
                }),
                (this.getTrackingId = function () {
                    return app.collection.TrackingId;
                    // return 0 == i("#hdnhawktrackingid").length || "" === i("#hdnhawktrackingid").val() ? null : i("#hdnhawktrackingid").val();
                }),
                (this.ensureBase64Encoding = function () {
                    !(function () {
                        function e(e) {
                            this.message = e;
                        }
                        var t = "undefined" != typeof exports ? exports : this,
                            i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                        (e.prototype = new Error()),
                            (e.prototype.name = "InvalidCharacterError"),
                            t.btoa ||
                                (t.btoa = function (t) {
                                    for (var n, o, s = String(t), a = 0, r = i, l = ""; s.charAt(0 | a) || ((r = "="), a % 1); l += r.charAt(63 & (n >> (8 - (a % 1) * 8)))) {
                                        if ((o = s.charCodeAt((a += 0.75))) > 255) throw new e("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
                                        n = (n << 8) | o;
                                    }
                                    return l;
                                }),
                            t.atob ||
                                (t.atob = function (t) {
                                    var n = String(t).replace(/=+$/, "");
                                    if (n.length % 4 == 1) throw new e("'atob' failed: The string to be decoded is not correctly encoded.");
                                    for (var o, s, a = 0, r = 0, l = ""; (s = n.charAt(r++)); ~s && ((o = a % 4 ? 64 * o + s : s), a++ % 4) ? (l += String.fromCharCode(255 & (o >> ((-2 * a) & 6)))) : 0) s = i.indexOf(s);
                                    return l;
                                });
                    })();
                }),
                this.initialize(e);
        }),
        (HawkSearch.LilBro.Event = function (e) {
            (this.initialize = function (e) {
                (this._event = e.base),
                    (this._key_map = e.key_map),
                    (this._type_map = e.type_map),
                    (this.server = e.server),
                    (this.ssl_server = e.ssl_server),
                    (this.visit_id_cookie = e.visit_id_cookie),
                    (this.visitor_id_cookie = e.visitor_id_cookie);
            }),
                (this.set = function (e, t) {
                    if (this._event.hasOwnProperty(e)) return (this._event[e] = t);
                }),
                (this.get = function (e) {
                    return this._event[e];
                }),
                (this.write = function (e) {
                    if (!(HawkSearch.GetQueryStringValue.expand !== undefined)) {
                        var t = [],
                            i = "";
                        for (var n in this._key_map) "event_type" === n ? ((t[this._key_map[n]] = this._type_map[this.get(n)] || 0), (i = t[this._key_map[n]])) : (t[this._key_map[n]] = this.get(n));
                        var o,
                            s = window.location.protocol,
                            a = JSON.stringify(HawkSearch.Context.Custom.keyValuePairs());
                        if (
                            ((o = "" !== HawkSearch.getClientGuid() ? "&cg=" + HawkSearch.getClientGuid() : "&bu=" + HawkSearch.getHawkUrl()),
                            HawkSearch.Tracking.CurrentVersion() == HawkSearch.Tracking.Version.v2 || HawkSearch.Tracking.CurrentVersion() == HawkSearch.Tracking.Version.v2AndSql)
                        ) {
                            var r = HawkSearch.getTrackingUrl() + "/hawk.png?t=" + encodeURIComponent(btoa(t.join(""))) + "&et=" + i + o + "&cd=" + encodeURIComponent(a) + "&" + this.randomHexBlocks(1);
                            log(r);
                            try {
                                sessionStorage && sessionStorage.setItem("lilbrobug" + s, encodeURIComponent(r));
                            } catch (e) {
                                log("Tracking: ERROR " + e);
                            }
                            var l = new Image();
                            (l.onload = function () {
                                log("Tracking sent. " + r);
                                try {
                                    sessionStorage.removeItem("lilbrobug" + s);
                                } catch (e) {
                                    log("Tracking: ERROR " + e);
                                }
                                e && e();
                            }),
                                (l.src = r);
                        }
                    }
                }),
                (this.fill = function (e) {
                    if ((e && e.version ? this.set("version", e.version) : this.set("version", HawkSearch.LilBro.Schema.version), e && e.type && this.set("event_type", e.type), e && e.event)) {
                        var t = "",
                            i = "";
                        e.event.pageX || e.event.pageY
                            ? ((t = e.event.pageX), (i = e.event.pageY))
                            : (e.event.clientX || e.event.clientY) &&
                              ((t = e.event.clientX + document.body.scrollLeft + document.documentElement.scrollLeft), (i = e.event.clientY + document.body.scrollTop + document.documentElement.scrollTop)),
                            this.set("mouse_x", t),
                            this.set("mouse_y", i);
                    }
                    this.set("viewport_width", document.documentElement.clientWidth), this.set("viewport_height", document.documentElement.clientHeight);
                    var n = 0,
                        o = 0;
                    if (
                        ("number" == typeof window.pageYOffset
                            ? ((n = window.pageXOffset), (o = window.pageYOffset))
                            : document.body && (document.body.scrollLeft || document.body.scrollTop)
                            ? ((n = document.body.scrollLeft), (o = document.body.scrollTop))
                            : document.documentElement && (document.documentElement.scrollLeft || document.documentElement.scrollTop) && ((n = document.documentElement.scrollLeft), (o = document.documentElement.scrollTop)),
                        this.set("scroll_x", n || 0),
                        this.set("scroll_y", o || 0),
                        e && e.target)
                    ) {
                        var s,
                            a,
                            r = e.target.id,
                            l = e.target.className,
                            c = !r,
                            h = !l;
                        if (!r || !l) {
                            var d = e.target;
                            (s = e.target.tagName), (a = e.target.tagName);
                            do {
                                if (((e.target = e.target.parentNode), null === e.target || e.target == undefined)) break;
                                !r && e.target.tagName && ((s = e.target.tagName + "/" + s), (r = e.target.id)), !l && e.target.tagName && ((a = e.target.tagName + "/" + a), (l = e.target.className));
                            } while ((!r || !l) && e.target.parentNode);
                            e.target = d;
                        }
                        this.set("element_id", r),
                            this.set("element_class", l),
                            r && c && this.set("element_id_from", s),
                            l && h && this.set("element_class_from", a),
                            this.set("element_name", e.target.name || ""),
                            this.set("element_tag", e.target.tagName || ""),
                            this.set("element_type", e.target.type || ""),
                            this.set("element_checked", e.target.checked ? 1 : ""),
                            e.target.type && "text" !== e.target.type.toLowerCase() && "password" !== e.target.type.toLowerCase() && this.set("element_value", e.target.value || "");
                        var u = 0,
                            p = 0;
                        for (d = e.target; e.target && !isNaN(e.target.offsetLeft) && !isNaN(e.target.offsetTop); )
                            (u += e.target.offsetLeft - e.target.scrollLeft), (p += e.target.offsetTop - e.target.scrollTop), (e.target = e.target.offsetParent);
                        (e.target = d), this.set("element_x", u), this.set("element_y", p);
                    }
                    HawkSearch.LilBro.BrowserDetect &&
                        (this.set("browser", HawkSearch.LilBro.BrowserDetect.browser), this.set("browser_version", HawkSearch.LilBro.BrowserDetect.version), this.set("operating_system", HawkSearch.LilBro.BrowserDetect.OS)),
                        this.set("request_path", window.location.pathname);
                    var f = new Date();
                    this.set("timestamp", f.getTime());
                    var m = this.getVisitorId(),
                        g = this.getVisitId();
                    this.set("visitor_id", m), this.set("visit_id", g), this.set("qs", encodeURIComponent(HawkSearch.getHash()));
                }),
                (this.getVisitorId = function () {
                    var e = this.getCookie(this.visitor_id_cookie);
                    return e || (e = this.createUUID()), this.setCookie(this.visitor_id_cookie, e, this.getVisitorExpiry()), e;
                }),
                (this.getVisitId = function () {
                    var e = this.getCookie(this.visit_id_cookie);
                    return e || (e = this.createUUID()), this.setCookie(this.visit_id_cookie, e, this.getVisitExpiry()), e;
                }),
                (this.clearVisitId = function () {
                    this.setCookie(this.visit_id_cookie, "", "Thu, 01 Jan 1970 00:00:01 GMT");
                }),
                (this.getVisitorExpiry = function () {
                    var e = new Date();
                    return e.setTime(e.getTime() + 31104e6), e.toGMTString();
                }),
                (this.getVisitExpiry = function () {
                    var e = new Date();
                    return e.setTime(e.getTime() + 144e5), e.toGMTString();
                }),
                (this.randomHexBlocks = function (e) {
                    e || (e = 4);
                    for (var t = "", i = 0; i < e; i++) t += parseInt(Math.random() * Math.pow(2, 32)).toString(16);
                    return t;
                }),
                (this.createUUID = function () {
                    for (var e = [], t = 0; t < 36; t++) e[t] = "0123456789abcdef".substr(Math.floor(16 * Math.random()), 1);
                    return (e[14] = "4"), (e[19] = "0123456789abcdef".substr((3 & e[19]) | 8, 1)), (e[8] = e[13] = e[18] = e[23] = "-"), e.join("");
                }),
                (this.setCookie = function (e, t, i) {
                    var n;
                    (n = i ? "; expires=" + i : ""), (document.cookie = e + "=" + t + n + "; path=/");
                }),
                (this.getCookie = function (e) {
                    for (var t = e + "=", i = document.cookie.split(";"), n = 0; n < i.length; n++) {
                        for (var o = i[n]; " " == o.charAt(0); ) o = o.substring(1, o.length);
                        if (0 == o.indexOf(t)) return o.substring(t.length, o.length);
                    }
                    return null;
                }),
                this.initialize(e);
        }),
        (HawkSearch.LilBro.BrowserDetect = {
            init: function () {
                (this.browser = this.searchString(this.dataBrowser) || "An unknown browser"),
                    (this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "an unknown version"),
                    (this.OS = this.searchString(this.dataOS) || "an unknown OS");
            },
            searchString: function (e) {
                for (var t = 0; t < e.length; t++) {
                    var i = e[t].string,
                        n = e[t].prop;
                    if (((this.versionSearchString = e[t].versionSearch || e[t].identity), i)) {
                        if (-1 != i.indexOf(e[t].subString)) return e[t].identity;
                    } else if (n) return e[t].identity;
                }
            },
            searchVersion: function (e) {
                var t = e.indexOf(this.versionSearchString);
                if (-1 != t) return parseFloat(e.substring(t + this.versionSearchString.length + 1));
            },
            dataBrowser: [
                { string: navigator.userAgent, subString: "BlackBerry", identity: "BlackBerry" },
                { string: navigator.userAgent, subString: "BB10", identity: "BlackBerry" },
                { string: navigator.userAgent, subString: "PlayBook", identity: "BlackBerry" },
                { string: navigator.userAgent, subString: "Chrome", identity: "Chrome" },
                { string: navigator.userAgent, subString: "OmniWeb", versionSearch: "OmniWeb/", identity: "OmniWeb" },
                { string: navigator.vendor, subString: "Apple", identity: "Safari", versionSearch: "Version" },
                { prop: window.opera, identity: "Opera", versionSearch: "Version" },
                { string: navigator.vendor, subString: "iCab", identity: "iCab" },
                { string: navigator.vendor, subString: "KDE", identity: "Konqueror" },
                { string: navigator.userAgent, subString: "Firefox", identity: "Firefox" },
                { string: navigator.vendor, subString: "Camino", identity: "Camino" },
                { string: navigator.userAgent, subString: "Netscape", identity: "Netscape" },
                { string: navigator.userAgent, subString: "MSIE", identity: "Explorer", versionSearch: "MSIE" },
                { string: navigator.userAgent, subString: "Gecko", identity: "Mozilla", versionSearch: "rv" },
                { string: navigator.userAgent, subString: "Mozilla", identity: "Netscape", versionSearch: "Mozilla" },
            ],
            dataOS: [
                { string: navigator.userAgent, subString: "iPhone", identity: "iPhone/iPod" },
                { string: navigator.userAgent, subString: "iPod", identity: "iPhone/iPod" },
                { string: navigator.userAgent, subString: "iPad", identity: "iPad" },
                { string: navigator.userAgent, subString: "BlackBerry", identity: "BlackBerry" },
                { string: navigator.userAgent, subString: "BB10", identity: "BlackBerry" },
                { string: navigator.userAgent, subString: "PlayBook", identity: "BlackBerry" },
                { string: navigator.userAgent, subString: "Android", identity: "Android" },
                { string: navigator.platform, subString: "Win", identity: "Windows" },
                { string: navigator.platform, subString: "Mac", identity: "Mac" },
                { string: navigator.platform, subString: "Linux", identity: "Linux" },
            ],
        });
    try {
        HawkSearch.LilBro.BrowserDetect.init();
    } catch (e) {}
    function log(e) {
        HawkSearchLoader.debugMode && window.console && console.log && console.log("HawkSearch: " + e);
    }
    if (
        HawkSearchLoader.loadjQuery
    ) {
        log("Loading jQuery/jQuery UI.");
        var head = document.getElementsByTagName("head")[0] || document.documentElement,
            script = "//ajax.googleapis.com/ajax/libs/jquery/3.1.1/jquery.min.js",
            jqScriptTag = document.createElement("script");
        (jqScriptTag.type = "text/javascript"), (jqScriptTag.src = script);
        var jqLoadDone = !1;
        (jqScriptTag.onload = jqScriptTag.onreadystatechange = function () {
            jqLoadDone ||
                (this.readyState && "loaded" !== this.readyState && "complete" !== this.readyState) ||
                ((jqLoadDone = !0), log("jQuery applied and ready"), jQueryLoaded(), (jqScriptTag.onload = jqScriptTag.onreadystatechange = null), head && jqScriptTag.parentNode && head.removeChild(jqScriptTag));
        }),
            head.insertBefore(jqScriptTag, head.firstChild);
    } else
        (jQuery = window.jQuery),
            (HawkSearch.loadPlugins = jQuery.extend(
                { jQueryUI: !0, slider: !0, wNumb: !0, matchHeights: !0, blockUI: !0, imagesLoaded: !0, jQueryCookie: !0, indexOf: !0, webUIPopover: !0, debounce: !0, slick: !0, numeric: !0, waitForImages: !0, alertify: !0 },
                HawkSearch.loadPlugins
            )),
            containedHawkSearchInitializer(jQuery);
    function jQueryLoaded() {
        log("Finalizing JS Component Binding"),
            log("Local jQuery version: " + (jQuery = window.jQuery.noConflict(!0)).fn.jquery),
            window.jQuery ? log("Global jQuery version: " + window.jQuery.fn.jquery) : (log("No Global jQuery present. Adding current jQuery"), (window.jQuery = jQuery)),
            (HawkSearch.loadPlugins = {
                jQueryUI: !0,
                slider: !0,
                wNumb: !0,
                matchHeights: !0,
                blockUI: !0,
                imagesLoaded: !0,
                jQueryCookie: !0,
                indexOf: !0,
                webUIPopover: !0,
                debounce: !0,
                slick: !0,
                numeric: !0,
                waitForImages: !0,
                alertify: !0,
            }),
            containedHawkSearchInitializer(jQuery);
    }
    function containedHawkSearchInitializer(e) {
        !(function (e, t) {
            (e.loadingtpl = '<img src="//manage.hawksearch.com/sites/shared/images/global/load.gif" style="margin:0 5px;vertical-align:middle;" />'),
                (e.loadtimer = null),
                (e.scroll = !1),
                (e.processing = !1),
                (e.getHash = function () {
                    var e = window.location.toString().split("#");
                    return e.length > 1 ? e[1] : window.location.search.substring(1);
                }),
                (e.lilBro = new e.LilBro({ server: e.getHawkUrl(), server_ssl: e.getHawkUrl() + ":443", watch_focus: !1, watch_click: !1, event_base: e.EventBase, qs: encodeURIComponent(e.getHash()), jQuery: t })),
                (e.jQuery = t),
                (e.normalizeHeights = function () {
                    var e = t("#hawkitemlist"),
                        i = t("#hawkbannertop, #hawkbannertopmobile"),
                        n = e.find(".itemWrapper"),
                        o = imagesLoaded(e);
                    o.on("always", function (t) {
                        log("Heights Normalize; No broken images"),
                            e.find(".itemWrapper .itemImage").matchHeights(),
                            e.find(".itemWrapper .itemTitle").matchHeights(),
                            i.find(".itemWrapper .itemImage").matchHeights(),
                            i.find(".itemWrapper .itemTitle").matchHeights(),
                            n.matchHeights({ extension: 3 });
                    }),
                        o.on("fail", function (e) {
                            log("Heights Normalize; Broken image(s)");
                        }),
                        o.on("progress", function (e, t) {
                            "broken" === (t.isLoaded ? "loaded" : "broken") && (log("Image Broken: " + t.img.src), (t.img.src = "/sites/shared/images/spacer.gif"), (t.img.className = "itemImage hawk-brokenImage"));
                        });
                }),
                (e.regTracking = function () {
                    log("Register Tracking"),
                        t(".hawk-bannerLink,.hawk-banner").each(function () {
                            var i = t(this).data("bannerid");
                            e.Tracking.writeBannerImpression(i);
                        });
                }),
                (e.regSmartBug = function () {
                    t("#aBug").click(function () {
                        return !(t("#divSmartBug > ul").children().length > 0) || (t("#divSmartBugEye").hide(), t("#divSmartBugPinning").hide(), t("#divSmartBug").toggle("fast"), !1);
                    }),
                        t("#aEye").click(function () {
                            return !(t("#divSmartBugEye > ul").children().length > 0) || (t("#divSmartBug").hide(), t("#divSmartBugPinning").hide(), t("#divSmartBugEye").toggle("fast"), !1);
                        }),
                        t("#aRefresh").off("click"),
                        t("#aRefresh").click(function () {
                            e.resetSearch();
                        }),
                        t("#divSmartBugEye .hawk-mutilbucket input[type=checkbox]").click(function (e) {
                            e.stopPropagation();
                        }),
                        t("#divSmartBugEye a.hawk-mutilbucket").click(function (e) {
                            e.preventDefault();
                            var i = t(this).find("input[type=checkbox]");
                            i.prop("checked", !i.prop("checked"));
                        }),
                        t("#hawkBtnApplayVisitorTarget").click(function () {
                            var e = t("#hawkHdnBucketUrl").val(),
                                i = [];
                            t("#divSmartBugEye .hawk-mutilbucket input[type=checkbox]:checked").each(function () {
                                i.push(t(this).data("hawkbucketid"));
                            }),
                                0 === t("#divSmartBugEye .hawk-mutilbucket input[type=checkbox]:checked").length && i.push(0),
                                (e = e.replace(/__bucket_ids__/i, i.join())),
                                (window.location.href = e);
                        }),
                        "undefined" != typeof HawkPreviewDateTime && HawkPreviewDateTime.registerPreviewDatetime();
                }),
                (e.resetSearch = function () {
                    t("#hdnhawkpg").val(1), "" !== window.location.hash && (window.location.hash += "&"), e.clearAllFacets();
                }),
                (e.getCustomUrl = function () {
                    var e = window.location.pathname;
                    return e.indexOf("/preview.aspx") >= 0 && (e = ""), e.indexOf("/search/") >= 0 && (e = ""), e.indexOf("/search") >= 0 && (e = ""), e;
                }),
                (e.IsExplainPopupOpen = !1),
                (e.getPinFunctionUrl = function (i, n) {
                    var o = t("#hdnhawkkeywordfield").val(),
                        s = e.getHashOrQueryVariable(o),
                        a = e.getCustomUrl(),
                        r = t("#hdnhawklp").val(),
                        l = t("#hdnhawkssfid").val(),
                        c = "undefined" != typeof smartbugDatetimepicker ? smartbugDatetimepicker.hawkDate : "";
                    return (
                        e.BaseUrl +
                        "/?fn=ajax&f=" +
                        i +
                        "&itemId=" +
                        encodeURIComponent(n) +
                        "&" +
                        o +
                        "=" +
                        s +
                        "&lp=" +
                        encodeURIComponent(r) +
                        "&lpurl=" +
                        encodeURIComponent(a) +
                        "&hawkb=" +
                        e.getHashOrQueryVariable("hawkb") +
                        "&hawkaid=" +
                        e.getHashOrQueryVariable("hawkaid") +
                        "&hawkp=" +
                        e.getHashOrQueryVariable("hawkp") +
                        "&HawkDate=" +
                        c +
                        "&ssfid=" +
                        encodeURIComponent(l)
                    );
                }),
                (e.addToTop = function (i, n) {
                    var o = e.getPinFunctionUrl("AddItemToTop", n);
                    t.ajax({
                        type: "GET",
                        async: !0,
                        context: i,
                        contentType: "application/json; charset=utf-8",
                        url: o,
                        dataType: "jsonp",
                        success: function () {
                            log("Added item to top");
                            var i = t(".grid_3[data-hawk-id='" + t(this).attr("primary-key") + "']");
                            i.addClass("hawk-itemPinned"),
                                i.find(".hawk-preview-info").append("<span class='hawkIcon-itemPinned'></span>"),
                                t(".itemWrapper.hawk-itemWrapper").removeClass("hawk-itemPinned hawk-preview-info"),
                                e.PopoverAction(t(this).parents(".popover"), "hide");
                        },
                        error: function (e) {
                            log("ERROR: Add item to top " + e);
                        },
                    });
                }),
                (e.unpinItem = function (i, n) {
                    var o = t("#hdnhawkkeywordfield").val(),
                        s = (e.getHashOrQueryVariable(o), e.getCustomUrl(), t("#hdnhawklp").val(), e.getPinFunctionUrl("UnpinItem", n));
                    t.ajax({
                        type: "GET",
                        async: !0,
                        contentType: "application/json; charset=utf-8",
                        url: s,
                        context: i,
                        dataType: "jsonp",
                        success: function () {
                            log("Unpin item");
                            var i = t(".grid_3[data-hawk-id='" + t(this).attr("primary-key") + "']");
                            i.removeClass("hawk-itemPinned"), i.find(".hawkIcon-itemPinned").remove(), e.PopoverAction(t(this).parents(".popover"), "hide");
                        },
                        error: function (e) {
                            log("ERROR: Unpin item " + e);
                        },
                    });
                }),
                (e.updatePinOrder = function (i) {
                    var n = e.getPinFunctionUrl("UpdateItemPinOrder", 0);
                    (n += "&itemList=" + encodeURIComponent(i)),
                        t.ajax({
                            type: "GET",
                            async: !0,
                            contentType: "application/json; charset=utf-8",
                            url: n,
                            dataType: "jsonp",
                            success: function () {
                                log("UpdateItemPinOrder");
                            },
                            error: function (e) {
                                log("ERROR: UpdateItemPinOrder " + e);
                            },
                        });
                }),
                (e.explain = function (i) {
                    if (!e.IsExplainPopupOpen) {
                        e.IsExplainPopupOpen = !0;
                        var n = t("#hdnhawkkeyword").val(),
                            o = t("#hdnhawkkeywordfield").val(),
                            s = e.getHashOrQueryVariable(o),
                            a = window.location.search.substring(1);
                        n.toLowerCase() != decodeURIComponent(s.toLowerCase().replace(/\+/g, " ")) && (a = a.replace(o + "=" + s, o + "=" + encodeURIComponent(n))),
                            ("" === a || ("" !== window.location.search.substring(1) && window.location.href.indexOf("#") > -1)) && (a = e.getHash());
                        var r = e.getCustomUrl(),
                            l = t("#hdnhawkcustom").val(),
                            c = e.BaseUrl + "/?" + a + "&ajax=1&json=1&docid=" + encodeURIComponent(i) + ("" != r ? "&lpurl=" + encodeURIComponent(r) : "") + ("" != l ? "&hawkcustom=" + encodeURIComponent(l) : "");
                        (c += "&hawkvisitorid=" + e.lilBro.event.getVisitorId()), t.ajax({ type: "GET", data: "", async: "false", contentType: "application/json; charset=utf-8", url: c, dataType: "jsonp", success: e.showAjaxPopup });
                    }
                }),
                (e.loadMoreLikeThis = function (i, n) {
                    var o = n.split("|"),
                        s = o[0],
                        a = e.lilBro.getTrackingId();
                    o.length >= 3 && (a = o[2]), e.Tracking.writeClick(i, 0, !0, s, a);
                    var r = e.BaseUrl + "/default.aspx?fn=ajax&f=MoreLikeThis&args=" + n;
                    t.ajax({
                        type: "GET",
                        data: "",
                        async: "false",
                        contentType: "application/json; charset=utf-8",
                        url: r,
                        dataType: "jsonp",
                        success: function (t) {
                            e.showDialog("More Like This", t.Html);
                        },
                    });
                }),
                (e.HawkSubmit = function (i) {
                    // return false;
                    var n = t(i).find("input[name=" + t("#hdnhawkkeywordfield").val() + "]"),
                        o = t(n).val(),
                        s = t(n).attr("id");
                    return (0 == n.length && 0 == t("#hdnhawkkeyword").length) || (o != e.SuggesterGlobal.defaultKeyword[s] && o != t("#hdnhawkkeyword").val());
                }),
                (e.showAjaxPopup = function (i) {
                    var n = i.html,
                        o = t(n).find("#hawkexplain");
                    null != o && o.length > 0 && t("#divAjaxPopupContent").html(o.html()), e.showDialog("Item Information", o.html()), (e.IsExplainPopupOpen = !1);
                }),
                (e.hideBlockUI = function () {
                    e.processing || e.scroll || t.unblockUI({ fadeOut: 0 });
                }),
                (e.showBlockUI = function () {
                    t.blockUI({
                        message: e.loadingtpl,
                        fadeIn: 0,
                        overlayCSS: { backgroundColor: "#fff", opacity: 0.5, cursor: "wait" },
                        css: { borderWidth: "0px", top: (t(window).height() - 100) / 2 + "px", left: t(window).width() / 2 + "px", width: "0px" },
                    });
                }),
                (e.showRecsBlockUI = function () {
                    t(".hawk-recommendation").css("height", "100px"),
                        t(".hawk-recommendation").block({
                            message: e.loadingtpl,
                            fadeIn: 0,
                            overlayCSS: { backgroundColor: "#fff", opacity: 0.5, cursor: "wait" },
                            css: { borderWidth: "0px", top: (t(window).height() - 100) / 2 + "px", left: t(window).width() / 2 + "px", width: "0px" },
                        });
                }),
                (e.showDialog = function (t, i) {
                    alertify.myAlert ||
                        ((alertify.defaults.transition = "slide"),
                        (alertify.defaults.theme.ok = "btn btn-primary"),
                        (alertify.defaults.theme.cancel = "btn btn-danger"),
                        (alertify.defaults.theme.input = "form-control"),
                        (alertify.defaults.glossary.title = t),
                        alertify.dialog("myAlert", function () {
                            return {
                                main: function (e) {
                                    this.message = e;
                                },
                                setup: function () {
                                    return { buttons: [{ text: "Close", key: 27 }], options: { maximizable: !1, resizable: !1, movable: !1 } };
                                },
                                prepare: function () {
                                    this.setContent(this.message);
                                },
                                build: function () {
                                    e.PrefixClasses(this.elements.root, "hawk-");
                                },
                            };
                        })),
                        alertify.myAlert(i);
                }),
                (e.hideRecsBlockUI = function () {
                    t(".hawk-recommendation").css("height", "auto"), t(".hawk-recommendation").unblock({ fadeOut: 0 });
                }),
                (e.refreshResults = function (i, n) {
                    if ((log("RefreshResults"), t("#hawkitemlist").length > 0)) {
                        e.processing = !0;
                        var o = e.getCustomUrl(),
                            s = e.getHash(),
                            a = t("#hdnhawkcustom").val(),
                            r = t("#hdnhawkquery").val(),
                            l = e.BaseUrl + "/?" + ("" != s ? s + "&" : "") + "ajax=1&json=1" + ("" != o ? "&lpurl=" + encodeURIComponent(o) : "") + ("" != a ? "&hawkcustom=" + encodeURIComponent(a) : "");
                        (l += "&hawkvisitorid=" + e.lilBro.event.getVisitorId()),
                            window.jQuery.ajax({
                                type: "GET",
                                data: "",
                                async: "true",
                                contentType: "application/json; charset=utf-8",
                                url: l,
                                dataType: "jsonp",
                                success: function (t) {
                                    e.processFacets(s, t, r, i, n);
                                },
                            });
                    }
                }),
                (e.getUrl = function () {
                    var e = window.location.toString();
                    return e.indexOf("?") > -1 && (e = e.substring(0, e.indexOf("?"))), e.indexOf("#") > -1 && (e = e.substring(0, e.indexOf("#"))), e;
                }),
                (e.copyValue = function (e, i) {
                    var n = e.find(i);
                    null != n && n.length > 0 && t(i).html(n.html());
                }),
                (e.copyCustomBanners = function (e) {
                    t(e)
                        .find(".hawk-bannerZone")
                        .each(function () {
                            var i = "#" + t(this).attr("id"),
                                n = e.find(i);
                            null != n && n.length > 0 && "" != n.html().trim() ? ("1" == t("#hdnhawkprv").val() && t(n).prepend('<span class="hawk-customBannerTitle">' + n.attr("title") + "</span>"), t(i).html(n.html())) : t(i).html("");
                        });
                }),
                (e.processFacets = function (i, n, o, s, a) {
                    // var r = n.html,
                    //     l = n.location;
                    // "" == !l && window.location.replace(l);
                    // var c,
                    //     h = t(r);
                    // e.copyValue(h, "#hawktitle"),
                    //     e.copyValue(h, "#hawkitemlist"),
                    //     e.copyValue(h, "#hawktoptext"),
                    //     !0 === a ? e.copyValue(h, "#hawkRailNav-body") : e.copyValue(h, "#hawkfacets"),
                    //     e.copyValue(h, "#hawkbreadcrumb"),
                    //     e.copyValue(h, "#hawktoppager"),
                    //     e.copyValue(h, "#hawkbottompager"),
                    //     e.copyValue(h, "#hawkbannertop"),
                    //     e.copyValue(h, "#hawkbannertopmobile"),
                    //     e.copyValue(h, "#hawkbannerbottom"),
                    //     e.copyValue(h, "#hawkbannerbottommobile"),
                    //     e.copyValue(h, "#hawkfirstitem"),
                    //     e.copyValue(h, "#hawklastitem"),
                    //     e.copyValue(h, "#hawkbannerbottom2"),
                    //     e.copyValue(h, "#hawkbannerbottom2mobile"),
                    //     e.copyValue(h, "#hawkbannerlefttop"),
                    //     e.copyValue(h, "#hawkbannerlefttopmobile"),
                    //     e.copyValue(h, "#hawkbannerleftbottom"),
                    //     e.copyValue(h, "#hawkbannerleftbottommobile"),
                    //     e.copyValue(h, "#hawksmartbug"),
                    //     e.copyValue(h, "#hdnhawktrackingid"),
                    //     e.copyValue(h, "#hawktabs"),
                    //     e.copyValue(h, "#hawkflags"),
                    //     e.copyValue(h, "#hawkaid"),
                    //     e.copyValue(h, "#hawkp"),
                    //     e.copyCustomBanners(h),
                        o !== undefined && t("#hdnhawkquery").val(o),
                        // "" == t("#hawkrelated").html() && e.copyValue(h, "#hawkrelated"),
                        // null != (c = h.find("#errormsg")) && c.length > 0 && alert(c.html()),
                        // e.regTracking(),
                        e.Tracking.writeSearch()
                        // (e.processing = !1),
                        // clearTimeout(e.loadtimer),
                        // e.hideBlockUI(),
                        // e.GetRecentSearches !== undefined && e.GetRecentSearches(),
                        // e.BindPreviewInformation(),
                        // e.BindFacetTooltip(),
                        // e.BindBackToTop(),
                        // t(window).scrollTop() > 0 && !s
                        //     ? t("html,body").animate({ scrollTop: 0 }, 500, function () {
                        //           (e.scroll = !1), e.hideBlockUI();
                        //       })
                        //     : ((e.scroll = !1), e.hideBlockUI()),
                        // t("#mobile-facets-btn").click(function () {
                        //     var e = t("#hawkRailNav");
                        //     e.hasClass("hawkRailNav--visible") ? e.removeClass("hawkRailNav--visible") : e.addClass("hawkRailNav--visible");
                        // }),
                        // !1 === a &&
                        //     (t("#hawkRailNav-header-close").click(function () {
                        //         var e = t("#hawkRailNav");
                        //         e.hasClass("hawkRailNav--visible") ? e.removeClass("hawkRailNav--visible") : e.addClass("hawkRailNav--visible");
                        //     }),
                        //     t("#hawkRailNav-footer-apply-btn").click(function () {
                        //         t("#hawkRailNav").removeClass("hawkRailNav--visible");
                        //     }),
                            // t("#hawkRailNav-footer-clear-btn").click(function () {
                                // e.clearAllFacets();
                            // }),
                            // t(".hawkRailNav").delegate(".hawk-navGroup li > a", "mouseover mouseout click", function (e) {
                            //     var i = t(this).parent();
                            //     "mouseover" == e.type
                            //         ? i.addClass("hawkFacet-hover")
                            //         : "mouseout" == e.type
                            //         ? i.removeClass("hawkFacet-hover")
                            //         : "click" == e.type &&
                            //           (e.preventDefault(),
                            //           i.hasClass("hawkFacet-indetermined")
                            //               ? (i.removeClass("hawkFacet-indetermined"), i.addClass("hawkFacet-active"), i.find("> ul > li ").removeClass("hawkFacet-active"), i.find("> ul > li ").removeClass("hawkFacet-hover"))
                            //               : (i.toggleClass("hawkFacet-active"), i.removeClass("hawkFacet-hover")),
                            //           t(i).find(".hawkFacet-active").removeClass("hawkFacet-active"),
                            //           t(i)
                            //               .parentsUntil(".hawk-navGroupContent", "ul")
                            //               .each(function () {
                            //                   var e = t(this);
                            //                   e.find("li.hawkFacet-active").length;
                            //                   if (e.find("li").length > 0) {
                            //                       var i = t(this).closest("li");
                            //                       i.removeClass("hawkFacet-active"), i.removeClass("hawkFacet-hover"), i.addClass("hawkFacet-indetermined");
                            //                   }
                            //               }));
                            // }));
                }),
                // (e.clearAllFacets = function () {
                //     var i = t("#hdnhawkkeyword").val(),
                //         n = t("#hdnhawkprv").val(),
                //         o = t("#hdnhawklp").val(),
                //         s = t("#hdnhawkadv").val(),
                //         a = t("#hdnhawkmpp").val(),
                //         r = t("#hdnhawksortby").val(),
                //         l = t("#hdnhawkit").val(),
                //         h = t("#hdnhawkoperator").val(),
                //         d = t("#hdnhawkexpand").val(),
                //         u = t("#hdnhawkb").val(),
                //         p = t("#hdnhawkdefaultmpp").val(),
                //         f = t("#hdnhawkkeywordfield").val(),
                //         m = t("#hdnhawkflags").val(),
                //         g = t("#hdnhawkaid").val(),
                //         v = "";
                //     if (
                //         (i && "" !== i && (v += ("" === v ? "" : "&") + f + "=" + encodeURIComponent(i)),
                //         n && "" !== n && (v += ("" === v ? "" : "&") + "prv=" + encodeURIComponent(n)),
                //         o && "" !== o && (v += ("" === v ? "" : "&") + "lp=" + encodeURIComponent(o)),
                //         s && "" !== s && (v += ("" === v ? "" : "&") + "adv=" + encodeURIComponent(s)),
                //         a && "" !== a && a !== p && (v += ("" === v ? "" : "&") + "mpp=" + encodeURIComponent(a)),
                //         r && "" !== r && (v += ("" === v ? "" : "&") + "sort=" + encodeURIComponent(r)),
                //         l && "" !== l && (v += ("" === v ? "" : "&") + "it=" + encodeURIComponent(l)),
                //         c && "" !== c && (v += ("" === v ? "" : "&") + "items=" + encodeURIComponent(c)),
                //         h && "" !== h && (v += ("" === v ? "" : "&") + "operator=" + encodeURIComponent(h)),
                //         d && "" !== d && (v += ("" === v ? "" : "&") + "expand=" + encodeURIComponent(d)),
                //         u && "" !== u && (v += ("" === v ? "" : "&") + "hawkb=" + encodeURIComponent(u)),
                //         m && "" !== m && (v += ("" === v ? "" : "&") + "hawkflags=" + encodeURIComponent(m)),
                //         g && "" !== g && (v += ("" === v ? "" : "&") + "hawkaid=" + encodeURIComponent(g)),
                //         HawkSearchLoader.disableAjax)
                //     ) {
                //         var w = window.location.toString();
                //         w.indexOf("?") > -1 && (w = w.substring(0, w.indexOf("?"))), w.indexOf("#") > -1 && (w = w.substring(0, w.indexOf("#"))), (window.location = w + "?" + v);
                //     } else v ? (window.history.pushState({}, {}, "?" + v), e.refreshResults(!1, !0)) : (window.history.pushState({}, {}, window.location.pathname), e.refreshResults(!1, !0));
                // }),
                (e.getHashOrQueryVariable = function (t) {
                    for (var i = e.getHash().split("&"), n = 0; n < i.length; n++) {
                        var o = i[n].split("=");
                        if (o[0].toLowerCase() == t.toLowerCase()) return o[1];
                    }
                    return e.getQueryVariable(window.location.search.substring(1), t);
                }),
                (e.getQueryVariable = function (e, t) {
                    if (t === undefined || null === t) return "";
                    for (var i = e.split("&"), n = 0; n < i.length; n++) {
                        var o = i[n].split("=");
                        if (o[0].toLowerCase() == t.toLowerCase()) return o[1];
                    }
                    return "";
                }),
                (e.getRecommenderUrl = function () {
                    return e.RecommenderUrl === undefined || "" === e.RecommenderUrl ? null : e.RecommenderUrl;
                }),
                (e.link = function (t, i, n, o, s) {
                    return (
                        t.currentTarget === undefined ||
                        t.currentTarget.href === undefined ||
                        ('v2' == e.Tracking.Version.v2
                            ? e.Tracking.writeClick(t, n, s, o, i)
                            : e.Tracking.CurrentVersion() == e.Tracking.Version.v2AndSql
                            ? (e.Tracking.writeClick(t, n, s, o, i), e.Tracking.V1.link(t, i, n, o, s))
                            : e.Tracking.V1.link(t, i, n, o, s),
                        !0)
                    );
                }),
                (e.bannerLink = function (t, i) {
                    return (
                        e.Tracking.CurrentVersion() == e.Tracking.Version.v2
                            ? e.Tracking.writeBannerClick(t, i)
                            : e.Tracking.CurrentVersion() == e.Tracking.Version.v2AndSql
                            ? (e.Tracking.writeBannerClick(t, i), e.Tracking.V1.bannerLink(t, i))
                            : e.Tracking.V1.bannerLink(t, i),
                        !0
                    );
                }),
                (e.suggestInit = function (i, n) {
                    (t.fn.hawksearchSuggest = function (n) {
                            // return (
                            //     (n = t.extend({ isAutoWidth: !1, isInstatSearch: !1, timeout: null, value: t("#hdnhawkkeyword").val() }, n)),
                            //     this.each(function () {
                            //         !(function (n, o) {
                            //             (n[0].autocomplete = "off"),
                            //                 t(n).val(o.value),
                            //                 (e.SuggesterGlobal.defaultKeyword[t(n).attr("id")] = o.value),
                            //                 n.on("keyup", function (t) {
                            //                     var i,
                            //                         r = a(e.SuggesterGlobal.divName);
                            //                     r[0],
                            //                         r.is(":hidden"),
                            //                         !t && window.event && (t = window.event),
                            //                         38 != (i = window.event ? t.keyCode : t.which) &&
                            //                             40 != i &&
                            //                             13 != i &&
                            //                             9 != i &&
                            //                             (clearTimeout(o.timeout),
                            //                             (o.timeout = setTimeout(function () {
                            //                                 return (
                            //                                     (function (t, i) {
                            //                                         var n = t.val();
                            //                                         (e.SuggesterGlobal.lastVal == n && "" == e.SuggesterGlobal.lastVal) ||
                            //                                             !e.SuggesterGlobal.focus ||
                            //                                             0 != e.SuggesterGlobal.searching ||
                            //                                             ((e.SuggesterGlobal.lastVal = n), s(encodeURI(n)));
                            //                                     })(n),
                            //                                     !0
                            //                                 );
                            //                             }, 200)));
                            //                     var l = (function (e) {
                            //                         var t = -1,
                            //                             i = e.find(".hawk-sqItem");
                            //                         return i && 1 == i.filter(".hawk-sqActive").length && (t = i.index(i.filter(".hawk-sqActive"))), t;
                            //                     })(r);
                            //                     if (13 == i) {
                            //                         if (!(l >= 0)) return c(t), !0;
                            //                         var h = v(r, l);
                            //                         if ((f(h), (t.cancelBubble = !0), window.event)) return !1;
                            //                         t.preventDefault();
                            //                     } else 9 == i ? (l + 1 < r.find(".hawk-sqItem").length ? ((t.cancelBubble = !0), t.preventDefault(), (h = v(r, l + 1))) : c(t)) : 38 == i ? (h = v(r, l - 1)) : 40 == i && (h = v(r, l + 1));
                            //                     return !0;
                            //                 }),
                            //                 n.on("focus", function (t) {
                            //                     (e.SuggesterGlobal.focus = !0), (this.value = "");
                            //                 }),
                            //                 o.hiddenDivName ? (e.SuggesterGlobal.divName = o.hiddenDivName) : (e.SuggesterGlobal.divName = "querydiv1");
                            //             function s(n) {
                            //                 e.SuggesterGlobal.searching = !0;
                            //                 var s = o.lookupUrlPrefix,
                            //                     c = e.lilBro.event.getVisitorId(),
                            //                     p = t("#hdnhawkkeywordfield").val(),
                            //                     f = (t("#" + p).val(), e.GetQueryStringValue.hawkb);
                            //                 f !== undefined && (s = s + "&hawkb=" + f);
                            //                 var m = e.VisitorTarget;
                            //                 m !== undefined && (s = s + "&hawkcustom=" + m),
                            //                     jQuery.ajax({
                            //                         type: "GET",
                            //                         contentType: "application/json; charset=utf-8",
                            //                         url: s + "&q=" + n + "&hawkvisitorid=" + c,
                            //                         data: "",
                            //                         dataType: "jsonp",
                            //                         success: function (n) {
                            //                             !(function (n) {
                            //                                 var o = a(e.SuggesterGlobal.divName),
                            //                                     s = o[0];
                            //                                 if (null === n || (0 === n.Count && 0 === n.ContentCount && (null == n.Categories || 0 === n.Categories.length) && (null == n.Popular || 0 === n.Popular.length))) return void l(!1);
                            //                                 for (; s.childNodes.length > 0; ) s.removeChild(s.childNodes[0]);
                            //                                 var c = n.Categories,
                            //                                     p = n.Popular,
                            //                                     f = n.Products,
                            //                                     m = n.Content,
                            //                                     g = n.PopularHeading,
                            //                                     v = n.CategoryHeading,
                            //                                     w = n.ProductHeading;
                            //                                 d(o, p, g, e.LilBro.Schema.AutoCompleteClick.AutoCompleteType.popular),
                            //                                     d(o, c, v, e.LilBro.Schema.AutoCompleteClick.AutoCompleteType.category),
                            //                                     (function (t, i, n) {
                            //                                         if (i.length >= 1) {
                            //                                             suggestDivNode = t[0];
                            //                                             var o = document.createElement("div");
                            //                                             (o.className = "hawk-sqHeader"), (o.innerHTML = n), suggestDivNode.appendChild(o);
                            //                                             var s = document.createElement("ul");
                            //                                             (s.className = "hawk-sqContent"), suggestDivNode.appendChild(s);
                            //                                             for (var a = 0; a < i.length; a++) {
                            //                                                 var r = i[a],
                            //                                                     l = document.createElement("li");
                            //                                                 h(a) ? (l.className = "hawk-sqItem") : (l.className = "hawk-sqItem hawk-sqItemAlt"),
                            //                                                     l.setAttribute("data-url", r.Url),
                            //                                                     l.setAttribute("data-autoCompleteType", e.LilBro.Schema.AutoCompleteClick.AutoCompleteType.product),
                            //                                                     (l.innerHTML = r.Html),
                            //                                                     s.appendChild(l);
                            //                                             }
                            //                                             var c = t.find(".hawk-sqContent .hawk-sqItem");
                            //                                             u(c);
                            //                                             var d = imagesLoaded(t);
                            //                                             d.on("progress", function (e, t) {
                            //                                                 var i = t.isLoaded ? "loaded" : "broken";
                            //                                                 "broken" === i &&
                            //                                                     (log("Image Broken: " + t.img.src),
                            //                                                     (t.img.src = "http://manage.hawksearch.com/sites/shared/images/spacer.gif"),
                            //                                                     (t.img.className = "item hawk-brokenSuggestImage"));
                            //                                             });
                            //                                         }
                            //                                     })(o, f, w);
                            //                                 var k = 1 == m.length ? "Top Content Match" : "Top " + m.length + " Content Matches";
                            //                                 if (
                            //                                     ((function (t, i, n) {
                            //                                         if (i.length >= 1) {
                            //                                             suggestDivNode = t[0];
                            //                                             var o = document.createElement("div");
                            //                                             (o.className = "hawk-sqHeader"), (o.innerHTML = n), suggestDivNode.appendChild(o);
                            //                                             var s = document.createElement("ul");
                            //                                             (s.className = "hawk-sqContent"), suggestDivNode.appendChild(s);
                            //                                             for (var a = 0; a < i.length; a++) {
                            //                                                 var r = i[a],
                            //                                                     l = document.createElement("li");
                            //                                                 h(a) ? (l.className = "hawk-sqItem term") : (l.className = "hawk-sqItem hawk-sqItemAlt term"),
                            //                                                     l.setAttribute("data-url", r.Url),
                            //                                                     l.setAttribute("data-autoCompleteType", e.LilBro.Schema.AutoCompleteClick.AutoCompleteType.content),
                            //                                                     (l.innerHTML = r.Html),
                            //                                                     s.appendChild(l);
                            //                                             }
                            //                                             var c = t.find(".hawk-sqContent .hawk-sqItem");
                            //                                             u(c);
                            //                                         }
                            //                                     })(o, m, k),
                            //                                     c.length > 0 || p.length > 0 || f.length > 0 || m.length > 0)
                            //                                 ) {
                            //                                     var y = "View All Matches";
                            //                                     "undefined" !== n && "" !== n.ViewAllButtonLabel && (y = n.ViewAllButtonLabel),
                            //                                         (function (n, o, s, a, l, c) {
                            //                                             var h = document.createElement("div");
                            //                                             h.className = "hawk-sqFooter";
                            //                                             var d = document.createElement("a");
                            //                                             if (
                            //                                                 ((d.href = "javascript:void(0);"),
                            //                                                 d.setAttribute("onclick", "window.location='" + a + "?" + l + "=" + encodeURIComponent(t(i).val()) + e.preserveUrlParams() + "'"),
                            //                                                 (d.innerHTML = c),
                            //                                                 o > 0)
                            //                                             ) {
                            //                                                 var u = document.createElement("div");
                            //                                                 (u.style.marginTop = "3px"), (u.style.fontSize = ".85em"), (u.innerHTML = o + " product(s)"), h.appendChild(u);
                            //                                             }
                            //                                             h.appendChild(d), n.append(h), r();
                            //                                         })(o, n.Count, n.ContentCount, n.SearchWebsiteUrl, n.KeywordField, y),
                            //                                         l(!0);
                            //                                 }
                            //                             })(n),
                            //                                 (e.SuggesterGlobal.searching = !1);
                            //                         },
                            //                         error: function () {
                            //                             e.SuggesterGlobal.searching = !1;
                            //                         },
                            //                     });
                            //             }
                            //             function a(i) {
                            //                 if (!e.SuggesterGlobal.globalDiv) {
                            //                     if (!document.getElementById(i)) {
                            //                         var s = document.createElement("div");
                            //                         s.setAttribute("id", i), s.setAttribute("class", "hawk-searchQuery"), document.body.appendChild(s);
                            //                     }
                            //                     (e.SuggesterGlobal.globalDiv = document.getElementById(i)), (e.SuggesterGlobal.queryDiv = t("#" + i));
                            //                 }
                            //                 if (n && n.offset().left != e.SuggesterGlobal.storedOffset) {
                            //                     var a = n.offset().left,
                            //                         r = n.offset().top + n.outerHeight(),
                            //                         l = n.attr("id");
                            //                     if (
                            //                         ((e.SuggesterGlobal.storedOffset = a),
                            //                         !e.SuggesterGlobal.divFormatted &&
                            //                             (e.SuggesterGlobal.queryDiv
                            //                                 .removeAttr("style")
                            //                                 .css({ left: a, top: r })
                            //                                 .attr("class", "hawk-searchQuery hawk-searchQuery-" + l),
                            //                             o && o.isAutoWidth))
                            //                     ) {
                            //                         var c = n.outerWidth();
                            //                         c < 324 && (c = 324), e.SuggesterGlobal.queryDiv.css("width", c);
                            //                     }
                            //                 }
                            //                 return e.SuggesterGlobal.queryDiv;
                            //             }
                            //             function r() {
                            //                 if (o.isAbove) {
                            //                     var t = e.SuggesterGlobal.queryDiv.outerHeight(!0),
                            //                         i = n.offset().top - t;
                            //                     e.SuggesterGlobal.queryDiv.css({ top: i }), e.SuggesterGlobal.queryDiv.hasClass("hawk-queryAbove") || e.SuggesterGlobal.queryDiv.addClass("hawk-queryAbove");
                            //                 }
                            //             }
                            //             function l(i) {
                            //                 var n = a(e.SuggesterGlobal.divName);
                            //                 !1 === i ? (n.hide(), t("body").off("click", c)) : (n.show(), t("body").on("click", c));
                            //             }
                            //             function c(e) {
                            //                 var i = !1;
                            //                 !i && t(e.target).closest(".hawk-searchQuery").length <= 0 && (l(!1), (i = !0));
                            //             }
                            //             function h(e) {
                            //                 return !1 !== e && !0 !== e && !isNaN(e) && e % 2 == 0;
                            //             }
                            //             function d(e, t, i, n) {
                            //                 if (t.length >= 1) {
                            //                     suggestDivNode = e[0];
                            //                     var o = document.createElement("div");
                            //                     (o.className = "hawk-sqHeader"), (o.innerHTML = i), suggestDivNode.appendChild(o);
                            //                     var s = document.createElement("ul");
                            //                     (s.className = "hawk-sqContent"), suggestDivNode.appendChild(s);
                            //                     for (var a = 0; a < t.length; a++) {
                            //                         var l = t[a];
                            //                         if (null != l.Value) {
                            //                             var c = document.createElement("li");
                            //                             c.setAttribute("data-url", l.Url), c.setAttribute("data-autoCompleteType", n), h(a) ? (c.className = "hawk-sqItem term") : (c.className = "hawk-sqItem hawk-sqItemAlt term");
                            //                             var d = document.createElement("h1");
                            //                             (d.className = "hawk-sqItemName"), (d.innerHTML = l.Value), c.appendChild(d), console.debug("resultItem", c), s.appendChild(c);
                            //                         }
                            //                     }
                            //                     var p = e.find(".hawk-sqContent .hawk-sqItem");
                            //                     u(p), r();
                            //                 }
                            //             }
                            //             function u(i) {
                            //                 i.on("mouseenter mouseleave", function (i) {
                            //                     var n,
                            //                         o = t(i.currentTarget);
                            //                     "mouseenter" === i.type
                            //                         ? ((n = o), t(e.SuggesterGlobal.globalDiv).find(".hawk-sqItem").removeClass("hawk-sqActive"), m(n))
                            //                         : (function (e) {
                            //                             g(e);
                            //                         })(o);
                            //                 }),
                            //                     i.off("click").on("click", p);
                            //             }
                            //             function p(n) {
                            //                 console.log('here in p(n)..');
                            //                 n.preventDefault();
                            //                 var o = t(n.target).closest("li").attr("data-autoCompleteType"),
                            //                     s = t(n.target)
                            //                         .text()
                            //                         .replace(/\u00bb/g, "&raquo;");
                            //                 "" === s && (s = t(n.target).parents(".hawk-sqActive").find("div.hawk-sqItemContent h1").text());
                            //                 var a = t(n.currentTarget).data("url"),
                            //                     r = t(i).val();
                            //                     console.log('e.Tracking.Version.v2: '+ e.Tracking.Version.v2);
                            //                     console.log('e.Tracking.CurrentVersion() '+ e.Tracking.Version.v2);
                            //                     console.log('r '+ r);
                            //                 'v2' == e.Tracking.Version.v2
                            //                     ? e.Tracking.writeAutoCompleteClick(r, n, o, s, a)
                            //                     : e.Tracking.CurrentVersion() == e.Tracking.Version.v2AndSQL
                            //                     ? (e.Tracking.writeAutoCompleteClick(r, n, o, s, a), e.Tracking.V1.autosuggestClick(r, s, a, o))
                            //                     : e.Tracking.V1.autosuggestClick(r, s, a, o);
                            //                     // (window.location = a);
                            //             }
                            //             function f(e) {
                            //                 (itemUrl = e.data("url")), (window.location = itemUrl);
                            //             }
                            //             function m(e) {
                            //                 null != e && e.addClass("hawk-sqActive");
                            //             }
                            //             function g(e) {
                            //                 e.removeClass("hawk-sqActive");
                            //             }
                            //             function v(e, t) {
                            //                 var i = -1,
                            //                     n = null,
                            //                     o = null,
                            //                     s = e.find(".hawk-sqItem");
                            //                 if (s) for (var a = 0; a < s.length; a++) null == o && (o = s.eq(a)), ++i == t ? (m(s.eq(a)), (n = s.eq(a))) : g(s.eq(a));
                            //                 return null == n && t < 0 ? m((n = s.eq(-1))) : null == n && m((n = o)), n;
                            //             }
                            //         })(t(this), n);
                            //     })
                            // );
                        }),
                        t(i).hawksearchSuggest(n);
                }),
                (e.preserveUrlParams = function () {
                    var t = e.GetQueryStringValue.prv + "",
                        i = e.GetQueryStringValue.adv + "",
                        n = e.GetQueryStringValue.hawkflags + "",
                        o = e.GetQueryStringValue.hawkaid + "",
                        s = "";
                    return (
                        "undefined" != t && "" != t && (s += "&prv=" + escape(t)),
                        "undefined" != i && "" != i && (s += "&adv=" + escape(i)),
                        "undefined" != n && "" != n && (s += "&hawkflags=" + escape(n)),
                        "undefined" != o && "" != o && (s += "&hawkaid=" + escape(o)),
                        s
                    );
                }),
                (e.GetRecentSearches = function () {
                    var i = t.cookie("recent-searches"),
                        n = [];
                    if (null != i) {
                        var o = i.split(",");
                        t(o).each(function () {
                            var e = this.split("|");
                            if (e.length > 1) {
                                var t = {};
                                (t.keyword = e[0]), (t.count = e[1]), n.push(t);
                            }
                        });
                    }
                    var s = e.RecentSearchesKeyword,
                        a = e.RecentSearchesCount;
                    if ("" !== s && a > 0) {
                        for (var r = !1, l = 0; l < n.length; l++)
                            if (n[l].keyword == encodeURIComponent(s)) {
                                r = !0;
                                break;
                            }
                        if (!r) {
                            var c = new Object();
                            (c.keyword = encodeURIComponent(s)), (c.count = a), n.unshift(c);
                        }
                    }
                    var m = [];
                    t(n).each(function () {
                        m.push(this.keyword + "|" + this.count);
                    }),
                        (i = m.join(",")),
                        t.cookie("recent-searches", i, { expires: 365 });
                }),
                (e.getTipPlacementFunction = function (e, i, n) {
                    return function (o, s) {
                        var a,
                            r,
                            l,
                            c,
                            h,
                            d = t(s),
                            u = t(document).scrollTop(),
                            p = t(document).scrollLeft(),
                            f = p + t(window).width(),
                            m = u + t(window).height(),
                            g = t.extend({}, d.offset(), { width: s.offsetWidth, height: s.offsetHeight }),
                            v = function (e) {
                                return u < e.top && p < e.left && f > e.left + i && m > e.top + n;
                            },
                            w = function () {
                                return !1 !== r && !!(r = v({ top: g.top - n, left: g.left + g.width / 2 - i / 2 })) && "top";
                            },
                            k = function () {
                                return !1 !== l && !!(l = v({ top: g.top + g.height, left: g.left + g.width / 2 - i / 2 })) && "bottom";
                            },
                            y = function () {
                                return !1 !== c && !!(c = v({ top: g.top + g.height / 2 - n / 2, left: g.left - i })) && "left";
                            },
                            b = function () {
                                return !1 !== h && !!(h = v({ top: g.top + g.height / 2 - n / 2, left: g.left + g.width })) && "right";
                            };
                        switch (e) {
                            case "top":
                                if ((a = w())) return a;
                            case "bottom":
                                if ((a = k())) return a;
                            case "left":
                                if ((a = y())) return a;
                            case "right":
                                if ((a = b())) return a;
                            default:
                                return (a = w()) ? a : (a = k()) ? a : (a = y()) ? a : (a = b()) ? a : e;
                        }
                    };
                }),
                (e.Popover = function (i, n, o) {
                    t(i).webuiPopover({
                        html: !0,
                        trigger: "hover",
                        content: '<div class="hawk-detail-content">' + o + "<div>",
                        placement: n,
                        onShow: function (n) {
                            e.PrefixClasses(n, "hawk-", ".hawk-detail-content");
                            t(i).parents(".hawk-itemWrapper").find(".hdn-itemPinned");
                            t(n).on("click", ".onoffswitch-label", function () {
                                var i = t(n).find(".onoffswitch-checkbox");
                                i.prop("checked", !i.prop("checked")), i.toggleClass("toggle-item-pin");
                                var o = t(i).prop("checked"),
                                    s = t(i).attr("primary-key");
                                o ? (e.addToTop(i, s), t(i).parents(".hawk-itemWrapper").find(".hdn-itemPinned").val(o)) : (e.unpinItem(i, s), t(i).parents(".hawk-itemWrapper").find(".hdn-itemPinned").val(o));
                                t(i).parents(".hawk-itemWrapper").find(".hdn-itemPinned").val(o), t("#hawkitemlist").sortable("option", "disabled", !0), t(".hawk-preview-info").addClass("hawk-no-sortable");
                            });
                        },
                        onHide: function (i) {
                            t(i).off("click", ".onoffswitch-label"), e.PrefixClasses(i, "hawk-", ".hawk-detail-content");
                        },
                    });
                }),
                (e.PrefixClasses = function (n, o, s) {
                    if (s === undefined || !t(n).is(s)) {
                        var a = t(n).attr("class");
                        if (a !== undefined) {
                            var r = a.split(" "),
                                l = r.length;
                            for (i = 0; i < l; i++) -1 == r.indexOf(o + r[i]) && r[i].substring(0, o.length) != o && r.push(o + r[i]);
                            t(n).attr("class", r.join(" "));
                        }
                        t(n)
                            .children()
                            .each(function () {
                                e.PrefixClasses(t(this), o, s);
                            });
                    }
                }),
                (e.PopoverAction = function (e, i) {
                    t(e).webuiPopover(i);
                }),
                (e.BindPreviewInformation = function () {
                    t(".hawk-preview-info").each(function () {
                        var i = t(this).parent().find(".hawk-preview-info-content").html();
                        e.Popover(t(this), e.getTipPlacementFunction("top", 230, 200), i);
                    }),
                        t("#hawkitemlist").sortable({
                            items: ".hawk-itemPinned",
                            placeholder: "grid_3 hawk-itemWrapper-placeholder",
                            appendTo: "#hawkitemlist",
                            handle: ".hawk-preview-info",
                            cursor: "move",
                            start: function (e, i) {
                                t(this).find(".popover").webuiPopover("hide"), i.placeholder.hide();
                                var n = i.item.find(".hawk-itemWrapper"),
                                    o = n.outerHeight() - 4,
                                    s = n.width() - 2;
                                i.placeholder.height(o).width(s), i.placeholder.show();
                            },
                            update: function (i, n) {
                                var o = t(this).sortable("toArray", { attribute: "data-hawk-id" }).toString();
                                e.updatePinOrder(o);
                            },
                        });
                }),
                (e.BindFacetTooltip = function () {
                    t(".hawk-facet-tooltip").each(function () {
                        t(this).click(function (e) {
                            e.preventDefault(), e.stopPropagation();
                        });
                        var i = t(this).parent().find(".hawk-facet-tooltip-content").html();
                        e.Popover(t(this), "right", i);
                    });
                }),
                (e.BindBackToTop = function () {
                    t(window).scroll(function () {
                        var e = t("#hawk-backToTop");
                        t(window).scrollTop() > 0 ? e.is(":visible") || e.fadeIn({ duration: 200, queue: !1 }) : e.is(":visible") && e.fadeOut({ duration: 200, queue: !1 });
                    }),
                        t("#hawk-backToTop").hover(function () {
                            t(this).toggleClass("hover");
                        }),
                        t("#hawk-backToTop").on("click", function () {
                            t("html,body").animate({ scrollTop: 0 }, 500);
                        });
                }),
                e.Tracking.setReady(t),
                "" !== e.getHashOrQueryVariable("hawkRegVisitor") && parent.postMessage(e.lilBro.event.getVisitorId(), "*");
        })((window.HawkSearch = window.HawkSearch || {}), jQuery),
            e(document).ready(function () {
                if (
                    (HawkSearch.initAutoSuggest !== undefined && HawkSearch.initAutoSuggest(),
                    HawkSearch.initCustomEvents !== undefined && HawkSearch.initCustomEvents(),
                    e("#hawkitemlist").length)
                ) {
                    var t = decodeURIComponent(HawkSearch.getHashOrQueryVariable("items"));
                    var n = e(".hawkmpp");
                    n.length > 0 && "" !== n.eq(0).val() && "" === e("#hdnhawkmpp").val() && (e("#hdnhawkmpp").val(n.eq(0).val()), n.val(e("#hdnhawkmpp").val())),
                        "" == e("#hawkitemlist").html() || (!HawkSearchLoader.disableAjax && window.location.hash) ? HawkSearch.refreshResults(!1, !1) : (HawkSearch.Tracking.writeSearch(), HawkSearch.regTracking()),
                        HawkSearch.GetRecentSearches !== undefined && HawkSearch.GetRecentSearches(),
                        e(window).on("debouncedresize", function (t) {
                            e("#hawkitemlist .itemWrapper").css("min-height", 0),
                                e("#hawkbannertop .itemWrapper").css("min-height", 0),
                                e("#hawkbannertopmobile .itemWrapper").css("min-height", 0),
                                HawkSearch.normalizeHeights(),
                                log("resize");
                        }),
                        HawkSearch.BindPreviewInformation(),
                        HawkSearch.BindFacetTooltip(),
                        e(".hawk-facetScollingContainer").length && HawkSearch.FacetContainerScrollable(),
                        HawkSearch.BindBackToTop();
                } else HawkSearch.regSmartBug();
            }),
            (e.expr[":"].containsNoCase = function (e, t, i) {
                var n = (e.textContent || e.innerText || "").match(/(.*?)\s\(\d+?\)/);
                return null == n ? null : n[1].toUpperCase().indexOf(i[3].toUpperCase()) >= 0;
            }),
            (e.fn.filterThatList = function (t) {
                (t !== undefined && null !== t) || (t = {});
                var i = { searchTarget: e(this) };
                return this.each(function () {
                    var n = e.extend(i, t);
                    n.searchTarget
                        .change(function () {
                            var t = e(this).val(),
                                i = n.list,
                                o = n.list.hasClass("hawk-nestedfacet");
                            if (o) {
                                var s = n.list.attr("id") + "_flat";
                                if (0 == e("#" + s).length) {
                                    (i = e(n.list[0].cloneNode(!1))).removeClass("hawk-navTruncateList"),
                                        i.addClass("hawk-scrollList"),
                                        i.attr("id", s),
                                        i.appendTo(n.list.parent()),
                                        e(n.list)
                                            .find("li")
                                            .each(function () {
                                                var t = [];
                                                e(this)
                                                    .parentsUntil("#" + n.list.attr("id"), "li")
                                                    .each(function () {
                                                        var i = e(e(e(this).children("a")).children("span").contents()[0]).text();
                                                        (i = i.trim()), t.unshift(i);
                                                    });
                                                var o = e("<li>");
                                                e(this).hasClass("hawkFacet-active") && o.addClass("hawkFacet-active"), o.appendTo(i);
                                                var s = e(this).children("a").clone();
                                                if (t.length > 0) {
                                                    var a = s.children("span"),
                                                        r = a.children(".hawk-facetCount").remove();
                                                    t.push(a.text()), a.html(t.join(" &raquo; ")), a.append(r);
                                                }
                                                s.appendTo(o);
                                            });
                                    var a = i.children("li").first().outerHeight();
                                    i.css("max-height", 20 * a + "px"), n.list.hide();
                                } else (i = e("#" + s)).show(), n.list.hide();
                            }
                            var r = "<li><span>No Results Found</span></li>";
                            if (t) {
                                if (
                                    (i
                                        .find("li:not(:containsNoCase(" + t + "))")
                                        .hide()
                                        .end()
                                        .find("li:containsNoCase(" + t + ")")
                                        .show(),
                                    0 == (h = i.find("li:containsNoCase(" + t + ")")).length)
                                ) {
                                    var l = e(r);
                                    return void i.prepend(l);
                                }
                                var c = n.list.data().options;
                                if (
                                    ((d = h.filter(function (e) {
                                        return e >= c.cutoff;
                                    })).hide(),
                                    0 == d.length)
                                )
                                    return;
                                if ((h.find(":contains('No Results Found')").remove(), d))
                                    (u = n.list.find("li.hawk-navMore")).off("click").each(function () {
                                        e(this).find("span").text(e(this).parent().data().options.moreText);
                                    }),
                                        u.show(),
                                        u.on("click", function (n) {
                                            var o = e(this);
                                            if (e(this).hasClass("hawk-navMoreActive"))
                                                i
                                                    .find("li:not(:containsNoCase(" + t + "))")
                                                    .hide()
                                                    .end()
                                                    .find("li:containsNoCase(" + t + ")")
                                                    .show(),
                                                    (h = i.find("li:containsNoCase(" + t + ")")),
                                                    (d = h.filter(function (e) {
                                                        return e >= c.cutoff;
                                                    })).hide(),
                                                    o.find("span").text(o.parent().data().options.moreText),
                                                    o.removeClass("hawk-navMoreActive"),
                                                    (window["hawkexpfacet_" + i.attr("id")] = null),
                                                    o.show();
                                            else {
                                                if (
                                                    (i
                                                        .find("li:not(:containsNoCase(" + t + "))")
                                                        .hide()
                                                        .end()
                                                        .find("li:containsNoCase(" + t + ")")
                                                        .show(),
                                                    0 == (h = i.find("li:containsNoCase(" + t + ")")).length)
                                                ) {
                                                    var s = e(r);
                                                    return void i.prepend(s);
                                                }
                                                o.addClass("hawk-navMoreActive").find("span").text(c.lessText), o.show(), (window["hawkexpfacet_" + i.attr("id")] = !0);
                                            }
                                        });
                            } else {
                                if ((n.list.find(":contains('No Results Found')").remove(), o)) i.hide(), n.list.show();
                                else if (n.list.hasClass("hawk-navTruncateList"))
                                    if (n.list.find("li.hawk-navMore > span").hasClass("hawk-navMoreActive")) n.list.find("li").show();
                                    else {
                                        var h;
                                        c = n.list.data().options;
                                        (h = n.list.find("li:not(.hawk-navMore)")).each(function (t, i) {
                                            t < c.cutoff ? e(this).show() : e(this).hide();
                                        });
                                        var d, u;
                                        c = n.list.data().options;
                                        if (
                                            ((d = h.filter(function (e) {
                                                return e >= c.cutoff;
                                            })).hide(),
                                            0 == d.length)
                                        )
                                            return;
                                        if (d)
                                            (u = n.list.find("li.hawk-navMore")).off("click").find("span").text(c.moreText),
                                                u.show(),
                                                u.on("click", function (t) {
                                                    var n = e(this);
                                                    e(this).hasClass("hawk-navMoreActive")
                                                        ? (n.hide(), n.removeClass("hawk-navMoreActive").find("span").text(c.moreText), (window["hawkexpfacet_" + i.attr("id")] = null), n.show())
                                                        : (n.addClass("hawk-navMoreActive").find("span").text(c.lessText), (window["hawkexpfacet_" + i.attr("id")] = !0), n.show());
                                                });
                                    }
                                else n.list.find("li").show();
                            }
                        })
                        .keyup(function () {
                            e(this).change();
                        });
                });
            });
        var t,
            n,
            o,
            s,
            a = undefined;
        1 == HawkSearch.loadPlugins.jQueryUI &&
            ((function (e, t) {
                function i(t, i) {
                    var o,
                        s,
                        a,
                        r = t.nodeName.toLowerCase();
                    return "area" === r
                        ? ((s = (o = t.parentNode).name), !(!t.href || !s || "map" !== o.nodeName.toLowerCase()) && !!(a = e("img[usemap=#" + s + "]")[0]) && n(a))
                        : (/input|select|textarea|button|object/.test(r) ? !t.disabled : ("a" === r && t.href) || i) && n(t);
                }
                function n(t) {
                    return (
                        e.expr.filters.visible(t) &&
                        !e(t)
                            .parents()
                            .addBack()
                            .filter(function () {
                                return "hidden" === e.css(this, "visibility");
                            }).length
                    );
                }
                var o = 0,
                    s = /^ui-id-\d+$/;
                (e.ui = e.ui || {}),
                    e.extend(e.ui, {
                        version: "1.10.4",
                        keyCode: {
                            BACKSPACE: 8,
                            COMMA: 188,
                            DELETE: 46,
                            DOWN: 40,
                            END: 35,
                            ENTER: 13,
                            ESCAPE: 27,
                            HOME: 36,
                            LEFT: 37,
                            NUMPAD_ADD: 107,
                            NUMPAD_DECIMAL: 110,
                            NUMPAD_DIVIDE: 111,
                            NUMPAD_ENTER: 108,
                            NUMPAD_MULTIPLY: 106,
                            NUMPAD_SUBTRACT: 109,
                            PAGE_DOWN: 34,
                            PAGE_UP: 33,
                            PERIOD: 190,
                            RIGHT: 39,
                            SPACE: 32,
                            TAB: 9,
                            UP: 38,
                        },
                    }),
                    e.fn.extend({
                        focus: (function (t) {
                            return function (i, n) {
                                return "number" == typeof i
                                    ? this.each(function () {
                                          var t = this;
                                          setTimeout(function () {
                                              e(t).focus(), n && n.call(t);
                                          }, i);
                                      })
                                    : t.apply(this, arguments);
                            };
                        })(e.fn.focus),
                        scrollParent: function () {
                            var t;
                            return (
                                (t =
                                    (e.ui.ie && /(static|relative)/.test(this.css("position"))) || /absolute/.test(this.css("position"))
                                        ? this.parents()
                                              .filter(function () {
                                                  return /(relative|absolute|fixed)/.test(e.css(this, "position")) && /(auto|scroll)/.test(e.css(this, "overflow") + e.css(this, "overflow-y") + e.css(this, "overflow-x"));
                                              })
                                              .eq(0)
                                        : this.parents()
                                              .filter(function () {
                                                  return /(auto|scroll)/.test(e.css(this, "overflow") + e.css(this, "overflow-y") + e.css(this, "overflow-x"));
                                              })
                                              .eq(0)),
                                /fixed/.test(this.css("position")) || !t.length ? e(document) : t
                            );
                        },
                        zIndex: function (i) {
                            if (i !== t) return this.css("zIndex", i);
                            if (this.length)
                                for (var n, o, s = e(this[0]); s.length && s[0] !== document; ) {
                                    if (("absolute" === (n = s.css("position")) || "relative" === n || "fixed" === n) && ((o = parseInt(s.css("zIndex"), 10)), !isNaN(o) && 0 !== o)) return o;
                                    s = s.parent();
                                }
                            return 0;
                        },
                        uniqueId: function () {
                            return this.each(function () {
                                this.id || (this.id = "ui-id-" + ++o);
                            });
                        },
                        removeUniqueId: function () {
                            return this.each(function () {
                                s.test(this.id) && e(this).removeAttr("id");
                            });
                        },
                    }),
                    e.extend(e.expr[":"], {
                        data: e.expr.createPseudo
                            ? e.expr.createPseudo(function (t) {
                                  return function (i) {
                                      return !!e.data(i, t);
                                  };
                              })
                            : function (t, i, n) {
                                  return !!e.data(t, n[3]);
                              },
                        focusable: function (t) {
                            return i(t, !isNaN(e.attr(t, "tabindex")));
                        },
                        tabbable: function (t) {
                            var n = e.attr(t, "tabindex"),
                                o = isNaN(n);
                            return (o || n >= 0) && i(t, !o);
                        },
                    }),
                    e("<a>").outerWidth(1).jquery ||
                        e.each(["Width", "Height"], function (i, n) {
                            function o(t, i, n, o) {
                                return (
                                    e.each(s, function () {
                                        (i -= parseFloat(e.css(t, "padding" + this)) || 0), n && (i -= parseFloat(e.css(t, "border" + this + "Width")) || 0), o && (i -= parseFloat(e.css(t, "margin" + this)) || 0);
                                    }),
                                    i
                                );
                            }
                            var s = "Width" === n ? ["Left", "Right"] : ["Top", "Bottom"],
                                a = n.toLowerCase(),
                                r = { innerWidth: e.fn.innerWidth, innerHeight: e.fn.innerHeight, outerWidth: e.fn.outerWidth, outerHeight: e.fn.outerHeight };
                            (e.fn["inner" + n] = function (i) {
                                return i === t
                                    ? r["inner" + n].call(this)
                                    : this.each(function () {
                                          e(this).css(a, o(this, i) + "px");
                                      });
                            }),
                                (e.fn["outer" + n] = function (t, i) {
                                    return "number" != typeof t
                                        ? r["outer" + n].call(this, t)
                                        : this.each(function () {
                                              e(this).css(a, o(this, t, !0, i) + "px");
                                          });
                                });
                        }),
                    e.fn.addBack ||
                        (e.fn.addBack = function (e) {
                            return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
                        }),
                    e("<a>").data("a-b", "a").removeData("a-b").data("a-b") &&
                        (e.fn.removeData = (function (t) {
                            return function (i) {
                                return arguments.length ? t.call(this, e.camelCase(i)) : t.call(this);
                            };
                        })(e.fn.removeData)),
                    (e.ui.ie = !!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase())),
                    (e.support.selectstart = "onselectstart" in document.createElement("div")),
                    e.fn.extend({
                        disableSelection: function () {
                            return this.bind((e.support.selectstart ? "selectstart" : "mousedown") + ".ui-disableSelection", function (e) {
                                e.preventDefault();
                            });
                        },
                        enableSelection: function () {
                            return this.unbind(".ui-disableSelection");
                        },
                    }),
                    e.extend(e.ui, {
                        plugin: {
                            add: function (t, i, n) {
                                var o,
                                    s = e.ui[t].prototype;
                                for (o in n) (s.plugins[o] = s.plugins[o] || []), s.plugins[o].push([i, n[o]]);
                            },
                            call: function (e, t, i) {
                                var n,
                                    o = e.plugins[t];
                                if (o && e.element[0].parentNode && 11 !== e.element[0].parentNode.nodeType) for (n = 0; o.length > n; n++) e.options[o[n][0]] && o[n][1].apply(e.element, i);
                            },
                        },
                        hasScroll: function (t, i) {
                            if ("hidden" === e(t).css("overflow")) return !1;
                            var n = i && "left" === i ? "scrollLeft" : "scrollTop",
                                o = !1;
                            return t[n] > 0 || ((t[n] = 1), (o = t[n] > 0), (t[n] = 0), o);
                        },
                    });
            })(jQuery),
            (function (e, t) {
                var i = 0,
                    n = Array.prototype.slice,
                    o = e.cleanData;
                (e.cleanData = function (t) {
                    for (var i, n = 0; null != (i = t[n]); n++)
                        try {
                            e(i).triggerHandler("remove");
                        } catch (e) {}
                    o(t);
                }),
                    (e.widget = function (i, n, o) {
                        var s,
                            a,
                            r,
                            l,
                            c = {},
                            h = i.split(".")[0];
                        (i = i.split(".")[1]),
                            (s = h + "-" + i),
                            o || ((o = n), (n = e.Widget)),
                            (e.expr[":"][s.toLowerCase()] = function (t) {
                                return !!e.data(t, s);
                            }),
                            (e[h] = e[h] || {}),
                            (a = e[h][i]),
                            (r = e[h][i] = function (e, i) {
                                return this._createWidget ? (arguments.length && this._createWidget(e, i), t) : new r(e, i);
                            }),
                            e.extend(r, a, { version: o.version, _proto: e.extend({}, o), _childConstructors: [] }),
                            ((l = new n()).options = e.widget.extend({}, l.options)),
                            e.each(o, function (i, o) {
                                return e.isFunction(o)
                                    ? ((c[i] = (function () {
                                          var e = function () {
                                                  return n.prototype[i].apply(this, arguments);
                                              },
                                              t = function (e) {
                                                  return n.prototype[i].apply(this, e);
                                              };
                                          return function () {
                                              var i,
                                                  n = this._super,
                                                  s = this._superApply;
                                              return (this._super = e), (this._superApply = t), (i = o.apply(this, arguments)), (this._super = n), (this._superApply = s), i;
                                          };
                                      })()),
                                      t)
                                    : ((c[i] = o), t);
                            }),
                            (r.prototype = e.widget.extend(l, { widgetEventPrefix: (a && l.widgetEventPrefix) || i }, c, { constructor: r, namespace: h, widgetName: i, widgetFullName: s })),
                            a
                                ? (e.each(a._childConstructors, function (t, i) {
                                      var n = i.prototype;
                                      e.widget(n.namespace + "." + n.widgetName, r, i._proto);
                                  }),
                                  delete a._childConstructors)
                                : n._childConstructors.push(r),
                            e.widget.bridge(i, r);
                    }),
                    (e.widget.extend = function (i) {
                        for (var o, s, a = n.call(arguments, 1), r = 0, l = a.length; l > r; r++)
                            for (o in a[r]) (s = a[r][o]), a[r].hasOwnProperty(o) && s !== t && (i[o] = e.isPlainObject(s) ? (e.isPlainObject(i[o]) ? e.widget.extend({}, i[o], s) : e.widget.extend({}, s)) : s);
                        return i;
                    }),
                    (e.widget.bridge = function (i, o) {
                        var s = o.prototype.widgetFullName || i;
                        e.fn[i] = function (a) {
                            var r = "string" == typeof a,
                                l = n.call(arguments, 1),
                                c = this;
                            return (
                                (a = !r && l.length ? e.widget.extend.apply(null, [a].concat(l)) : a),
                                r
                                    ? this.each(function () {
                                          var n,
                                              o = e.data(this, s);
                                          return o
                                              ? e.isFunction(o[a]) && "_" !== a.charAt(0)
                                                  ? (n = o[a].apply(o, l)) !== o && n !== t
                                                      ? ((c = n && n.jquery ? c.pushStack(n.get()) : n), !1)
                                                      : t
                                                  : e.error("no such method '" + a + "' for " + i + " widget instance")
                                              : e.error("cannot call methods on " + i + " prior to initialization; attempted to call method '" + a + "'");
                                      })
                                    : this.each(function () {
                                          var t = e.data(this, s);
                                          t ? t.option(a || {})._init() : e.data(this, s, new o(a, this));
                                      }),
                                c
                            );
                        };
                    }),
                    (e.Widget = function () {}),
                    (e.Widget._childConstructors = []),
                    (e.Widget.prototype = {
                        widgetName: "widget",
                        widgetEventPrefix: "",
                        defaultElement: "<div>",
                        options: { disabled: !1, create: null },
                        _createWidget: function (t, n) {
                            (n = e(n || this.defaultElement || this)[0]),
                                (this.element = e(n)),
                                (this.uuid = i++),
                                (this.eventNamespace = "." + this.widgetName + this.uuid),
                                (this.options = e.widget.extend({}, this.options, this._getCreateOptions(), t)),
                                (this.bindings = e()),
                                (this.hoverable = e()),
                                (this.focusable = e()),
                                n !== this &&
                                    (e.data(n, this.widgetFullName, this),
                                    this._on(!0, this.element, {
                                        remove: function (e) {
                                            e.target === n && this.destroy();
                                        },
                                    }),
                                    (this.document = e(n.style ? n.ownerDocument : n.document || n)),
                                    (this.window = e(this.document[0].defaultView || this.document[0].parentWindow))),
                                this._create(),
                                this._trigger("create", null, this._getCreateEventData()),
                                this._init();
                        },
                        _getCreateOptions: e.noop,
                        _getCreateEventData: e.noop,
                        _create: e.noop,
                        _init: e.noop,
                        destroy: function () {
                            this._destroy(),
                                this.element.unbind(this.eventNamespace).removeData(this.widgetName).removeData(this.widgetFullName).removeData(e.camelCase(this.widgetFullName)),
                                this.widget()
                                    .unbind(this.eventNamespace)
                                    .removeAttr("aria-disabled")
                                    .removeClass(this.widgetFullName + "-disabled ui-state-disabled"),
                                this.bindings.unbind(this.eventNamespace),
                                this.hoverable.removeClass("ui-state-hover"),
                                this.focusable.removeClass("ui-state-focus");
                        },
                        _destroy: e.noop,
                        widget: function () {
                            return this.element;
                        },
                        option: function (i, n) {
                            var o,
                                s,
                                a,
                                r = i;
                            if (0 === arguments.length) return e.widget.extend({}, this.options);
                            if ("string" == typeof i)
                                if (((r = {}), (o = i.split(".")), (i = o.shift()), o.length)) {
                                    for (s = r[i] = e.widget.extend({}, this.options[i]), a = 0; o.length - 1 > a; a++) (s[o[a]] = s[o[a]] || {}), (s = s[o[a]]);
                                    if (((i = o.pop()), 1 === arguments.length)) return s[i] === t ? null : s[i];
                                    s[i] = n;
                                } else {
                                    if (1 === arguments.length) return this.options[i] === t ? null : this.options[i];
                                    r[i] = n;
                                }
                            return this._setOptions(r), this;
                        },
                        _setOptions: function (e) {
                            var t;
                            for (t in e) this._setOption(t, e[t]);
                            return this;
                        },
                        _setOption: function (e, t) {
                            return (
                                (this.options[e] = t),
                                "disabled" === e &&
                                    (this.widget()
                                        .toggleClass(this.widgetFullName + "-disabled ui-state-disabled", !!t)
                                        .attr("aria-disabled", t),
                                    this.hoverable.removeClass("ui-state-hover"),
                                    this.focusable.removeClass("ui-state-focus")),
                                this
                            );
                        },
                        enable: function () {
                            return this._setOption("disabled", !1);
                        },
                        disable: function () {
                            return this._setOption("disabled", !0);
                        },
                        _on: function (i, n, o) {
                            var s,
                                a = this;
                            "boolean" != typeof i && ((o = n), (n = i), (i = !1)),
                                o ? ((n = s = e(n)), (this.bindings = this.bindings.add(n))) : ((o = n), (n = this.element), (s = this.widget())),
                                e.each(o, function (o, r) {
                                    function l() {
                                        return i || (!0 !== a.options.disabled && !e(this).hasClass("ui-state-disabled")) ? ("string" == typeof r ? a[r] : r).apply(a, arguments) : t;
                                    }
                                    "string" != typeof r && (l.guid = r.guid = r.guid || l.guid || e.guid++);
                                    var c = o.match(/^(\w+)\s*(.*)$/),
                                        h = c[1] + a.eventNamespace,
                                        d = c[2];
                                    d ? s.delegate(d, h, l) : n.bind(h, l);
                                });
                        },
                        _off: function (e, t) {
                            (t = (t || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace), e.unbind(t).undelegate(t);
                        },
                        _delay: function (e, t) {
                            var i = this;
                            return setTimeout(function () {
                                return ("string" == typeof e ? i[e] : e).apply(i, arguments);
                            }, t || 0);
                        },
                        _hoverable: function (t) {
                            (this.hoverable = this.hoverable.add(t)),
                                this._on(t, {
                                    mouseenter: function (t) {
                                        e(t.currentTarget).addClass("ui-state-hover");
                                    },
                                    mouseleave: function (t) {
                                        e(t.currentTarget).removeClass("ui-state-hover");
                                    },
                                });
                        },
                        _focusable: function (t) {
                            (this.focusable = this.focusable.add(t)),
                                this._on(t, {
                                    focusin: function (t) {
                                        e(t.currentTarget).addClass("ui-state-focus");
                                    },
                                    focusout: function (t) {
                                        e(t.currentTarget).removeClass("ui-state-focus");
                                    },
                                });
                        },
                        _trigger: function (t, i, n) {
                            var o,
                                s,
                                a = this.options[t];
                            if (((n = n || {}), ((i = e.Event(i)).type = (t === this.widgetEventPrefix ? t : this.widgetEventPrefix + t).toLowerCase()), (i.target = this.element[0]), (s = i.originalEvent)))
                                for (o in s) o in i || (i[o] = s[o]);
                            return this.element.trigger(i, n), !((e.isFunction(a) && !1 === a.apply(this.element[0], [i].concat(n))) || i.isDefaultPrevented());
                        },
                    }),
                    e.each({ show: "fadeIn", hide: "fadeOut" }, function (t, i) {
                        e.Widget.prototype["_" + t] = function (n, o, s) {
                            "string" == typeof o && (o = { effect: o });
                            var a,
                                r = o ? (!0 === o || "number" == typeof o ? i : o.effect || i) : t;
                            "number" == typeof (o = o || {}) && (o = { duration: o }),
                                (a = !e.isEmptyObject(o)),
                                (o.complete = s),
                                o.delay && n.delay(o.delay),
                                a && e.effects && e.effects.effect[r]
                                    ? n[t](o)
                                    : r !== t && n[r]
                                    ? n[r](o.duration, o.easing, s)
                                    : n.queue(function (i) {
                                          e(this)[t](), s && s.call(n[0]), i();
                                      });
                        };
                    });
            })(jQuery),
            (n = !1),
            (t = jQuery)(document).mouseup(function () {
                n = !1;
            }),
            t.widget("ui.mouse", {
                version: "1.10.4",
                options: { cancel: "input,textarea,button,select,option", distance: 1, delay: 0 },
                _mouseInit: function () {
                    var e = this;
                    this.element
                        .bind("mousedown." + this.widgetName, function (t) {
                            return e._mouseDown(t);
                        })
                        .bind("click." + this.widgetName, function (i) {
                            return !0 === t.data(i.target, e.widgetName + ".preventClickEvent") ? (t.removeData(i.target, e.widgetName + ".preventClickEvent"), i.stopImmediatePropagation(), !1) : undefined;
                        }),
                        (this.started = !1);
                },
                _mouseDestroy: function () {
                    this.element.unbind("." + this.widgetName),
                        this._mouseMoveDelegate &&
                            t(document)
                                .unbind("mousemove." + this.widgetName, this._mouseMoveDelegate)
                                .unbind("mouseup." + this.widgetName, this._mouseUpDelegate);
                },
                _mouseDown: function (e) {
                    if (!n) {
                        this._mouseStarted && this._mouseUp(e), (this._mouseDownEvent = e);
                        var i = this,
                            o = 1 === e.which,
                            s = !("string" != typeof this.options.cancel || !e.target.nodeName) && t(e.target).closest(this.options.cancel).length;
                        return !(
                            o &&
                            !s &&
                            this._mouseCapture(e) &&
                            ((this.mouseDelayMet = !this.options.delay),
                            this.mouseDelayMet ||
                                (this._mouseDelayTimer = setTimeout(function () {
                                    i.mouseDelayMet = !0;
                                }, this.options.delay)),
                            this._mouseDistanceMet(e) && this._mouseDelayMet(e) && ((this._mouseStarted = !1 !== this._mouseStart(e)), !this._mouseStarted)
                                ? (e.preventDefault(), 0)
                                : (!0 === t.data(e.target, this.widgetName + ".preventClickEvent") && t.removeData(e.target, this.widgetName + ".preventClickEvent"),
                                  (this._mouseMoveDelegate = function (e) {
                                      return i._mouseMove(e);
                                  }),
                                  (this._mouseUpDelegate = function (e) {
                                      return i._mouseUp(e);
                                  }),
                                  t(document)
                                      .bind("mousemove." + this.widgetName, this._mouseMoveDelegate)
                                      .bind("mouseup." + this.widgetName, this._mouseUpDelegate),
                                  e.preventDefault(),
                                  (n = !0),
                                  0))
                        );
                    }
                },
                _mouseMove: function (e) {
                    return t.ui.ie && (!document.documentMode || 9 > document.documentMode) && !e.button
                        ? this._mouseUp(e)
                        : this._mouseStarted
                        ? (this._mouseDrag(e), e.preventDefault())
                        : (this._mouseDistanceMet(e) && this._mouseDelayMet(e) && ((this._mouseStarted = !1 !== this._mouseStart(this._mouseDownEvent, e)), this._mouseStarted ? this._mouseDrag(e) : this._mouseUp(e)), !this._mouseStarted);
                },
                _mouseUp: function (e) {
                    return (
                        t(document)
                            .unbind("mousemove." + this.widgetName, this._mouseMoveDelegate)
                            .unbind("mouseup." + this.widgetName, this._mouseUpDelegate),
                        this._mouseStarted && ((this._mouseStarted = !1), e.target === this._mouseDownEvent.target && t.data(e.target, this.widgetName + ".preventClickEvent", !0), this._mouseStop(e)),
                        !1
                    );
                },
                _mouseDistanceMet: function (e) {
                    return Math.max(Math.abs(this._mouseDownEvent.pageX - e.pageX), Math.abs(this._mouseDownEvent.pageY - e.pageY)) >= this.options.distance;
                },
                _mouseDelayMet: function () {
                    return this.mouseDelayMet;
                },
                _mouseStart: function () {},
                _mouseDrag: function () {},
                _mouseStop: function () {},
                _mouseCapture: function () {
                    return !0;
                },
            }),
            (function (e) {
                function t(e, t, i) {
                    return e > t && t + i > e;
                }
                function i(e) {
                    return /left|right/.test(e.css("float")) || /inline|table-cell/.test(e.css("display"));
                }
                e.widget("ui.sortable", e.ui.mouse, {
                    version: "1.10.4",
                    widgetEventPrefix: "sort",
                    ready: !1,
                    options: {
                        appendTo: "parent",
                        axis: !1,
                        connectWith: !1,
                        containment: !1,
                        cursor: "auto",
                        cursorAt: !1,
                        dropOnEmpty: !0,
                        forcePlaceholderSize: !1,
                        forceHelperSize: !1,
                        grid: !1,
                        handle: !1,
                        helper: "original",
                        items: "> *",
                        opacity: !1,
                        placeholder: !1,
                        revert: !1,
                        scroll: !0,
                        scrollSensitivity: 20,
                        scrollSpeed: 20,
                        scope: "default",
                        tolerance: "intersect",
                        zIndex: 1e3,
                        activate: null,
                        beforeStop: null,
                        change: null,
                        deactivate: null,
                        out: null,
                        over: null,
                        receive: null,
                        remove: null,
                        sort: null,
                        start: null,
                        stop: null,
                        update: null,
                    },
                    _create: function () {
                        var e = this.options;
                        (this.containerCache = {}),
                            this.element.addClass("ui-sortable"),
                            this.refresh(),
                            (this.floating = !!this.items.length && ("x" === e.axis || i(this.items[0].item))),
                            (this.offset = this.element.offset()),
                            this._mouseInit(),
                            (this.ready = !0);
                    },
                    _destroy: function () {
                        this.element.removeClass("ui-sortable ui-sortable-disabled"), this._mouseDestroy();
                        for (var e = this.items.length - 1; e >= 0; e--) this.items[e].item.removeData(this.widgetName + "-item");
                        return this;
                    },
                    _setOption: function (t, i) {
                        "disabled" === t ? ((this.options[t] = i), this.widget().toggleClass("ui-sortable-disabled", !!i)) : e.Widget.prototype._setOption.apply(this, arguments);
                    },
                    _mouseCapture: function (t, i) {
                        var n = null,
                            o = !1,
                            s = this;
                        return (
                            !this.reverting &&
                            !this.options.disabled &&
                            "static" !== this.options.type &&
                            (this._refreshItems(t),
                            e(t.target)
                                .parents()
                                .each(function () {
                                    return e.data(this, s.widgetName + "-item") === s ? ((n = e(this)), !1) : undefined;
                                }),
                            e.data(t.target, s.widgetName + "-item") === s && (n = e(t.target)),
                            !!n &&
                                !(
                                    this.options.handle &&
                                    !i &&
                                    (e(this.options.handle, n)
                                        .find("*")
                                        .addBack()
                                        .each(function () {
                                            this === t.target && (o = !0);
                                        }),
                                    !o)
                                ) &&
                                ((this.currentItem = n), this._removeCurrentsFromItems(), !0))
                        );
                    },
                    _mouseStart: function (t, i, n) {
                        var o,
                            s,
                            a = this.options;
                        if (
                            ((this.currentContainer = this),
                            this.refreshPositions(),
                            (this.helper = this._createHelper(t)),
                            this._cacheHelperProportions(),
                            this._cacheMargins(),
                            (this.scrollParent = this.helper.scrollParent()),
                            (this.offset = this.currentItem.offset()),
                            (this.offset = { top: this.offset.top - this.margins.top, left: this.offset.left - this.margins.left }),
                            e.extend(this.offset, { click: { left: t.pageX - this.offset.left, top: t.pageY - this.offset.top }, parent: this._getParentOffset(), relative: this._getRelativeOffset() }),
                            this.helper.css("position", "absolute"),
                            (this.cssPosition = this.helper.css("position")),
                            (this.originalPosition = this._generatePosition(t)),
                            (this.originalPageX = t.pageX),
                            (this.originalPageY = t.pageY),
                            a.cursorAt && this._adjustOffsetFromHelper(a.cursorAt),
                            (this.domPosition = { prev: this.currentItem.prev()[0], parent: this.currentItem.parent()[0] }),
                            this.helper[0] !== this.currentItem[0] && this.currentItem.hide(),
                            this._createPlaceholder(),
                            a.containment && this._setContainment(),
                            a.cursor &&
                                "auto" !== a.cursor &&
                                ((s = this.document.find("body")), (this.storedCursor = s.css("cursor")), s.css("cursor", a.cursor), (this.storedStylesheet = e("<style>*{ cursor: " + a.cursor + " !important; }</style>").appendTo(s))),
                            a.opacity && (this.helper.css("opacity") && (this._storedOpacity = this.helper.css("opacity")), this.helper.css("opacity", a.opacity)),
                            a.zIndex && (this.helper.css("zIndex") && (this._storedZIndex = this.helper.css("zIndex")), this.helper.css("zIndex", a.zIndex)),
                            this.scrollParent[0] !== document && "HTML" !== this.scrollParent[0].tagName && (this.overflowOffset = this.scrollParent.offset()),
                            this._trigger("start", t, this._uiHash()),
                            this._preserveHelperProportions || this._cacheHelperProportions(),
                            !n)
                        )
                            for (o = this.containers.length - 1; o >= 0; o--) this.containers[o]._trigger("activate", t, this._uiHash(this));
                        return (
                            e.ui.ddmanager && (e.ui.ddmanager.current = this),
                            e.ui.ddmanager && !a.dropBehaviour && e.ui.ddmanager.prepareOffsets(this, t),
                            (this.dragging = !0),
                            this.helper.addClass("ui-sortable-helper"),
                            this._mouseDrag(t),
                            !0
                        );
                    },
                    _mouseDrag: function (t) {
                        var i,
                            n,
                            o,
                            s,
                            a = this.options,
                            r = !1;
                        for (
                            this.position = this._generatePosition(t),
                                this.positionAbs = this._convertPositionTo("absolute"),
                                this.lastPositionAbs || (this.lastPositionAbs = this.positionAbs),
                                this.options.scroll &&
                                    (this.scrollParent[0] !== document && "HTML" !== this.scrollParent[0].tagName
                                        ? (this.overflowOffset.top + this.scrollParent[0].offsetHeight - t.pageY < a.scrollSensitivity
                                              ? (this.scrollParent[0].scrollTop = r = this.scrollParent[0].scrollTop + a.scrollSpeed)
                                              : t.pageY - this.overflowOffset.top < a.scrollSensitivity && (this.scrollParent[0].scrollTop = r = this.scrollParent[0].scrollTop - a.scrollSpeed),
                                          this.overflowOffset.left + this.scrollParent[0].offsetWidth - t.pageX < a.scrollSensitivity
                                              ? (this.scrollParent[0].scrollLeft = r = this.scrollParent[0].scrollLeft + a.scrollSpeed)
                                              : t.pageX - this.overflowOffset.left < a.scrollSensitivity && (this.scrollParent[0].scrollLeft = r = this.scrollParent[0].scrollLeft - a.scrollSpeed))
                                        : (t.pageY - e(document).scrollTop() < a.scrollSensitivity
                                              ? (r = e(document).scrollTop(e(document).scrollTop() - a.scrollSpeed))
                                              : e(window).height() - (t.pageY - e(document).scrollTop()) < a.scrollSensitivity && (r = e(document).scrollTop(e(document).scrollTop() + a.scrollSpeed)),
                                          t.pageX - e(document).scrollLeft() < a.scrollSensitivity
                                              ? (r = e(document).scrollLeft(e(document).scrollLeft() - a.scrollSpeed))
                                              : e(window).width() - (t.pageX - e(document).scrollLeft()) < a.scrollSensitivity && (r = e(document).scrollLeft(e(document).scrollLeft() + a.scrollSpeed))),
                                    !1 !== r && e.ui.ddmanager && !a.dropBehaviour && e.ui.ddmanager.prepareOffsets(this, t)),
                                this.positionAbs = this._convertPositionTo("absolute"),
                                (this.options.axis && "y" === this.options.axis) || (this.helper[0].style.left = this.position.left + "px"),
                                (this.options.axis && "x" === this.options.axis) || (this.helper[0].style.top = this.position.top + "px"),
                                i = this.items.length - 1;
                            i >= 0;
                            i--
                        )
                            if (
                                ((o = (n = this.items[i]).item[0]),
                                (s = this._intersectsWithPointer(n)) &&
                                    n.instance === this.currentContainer &&
                                    o !== this.currentItem[0] &&
                                    this.placeholder[1 === s ? "next" : "prev"]()[0] !== o &&
                                    !e.contains(this.placeholder[0], o) &&
                                    ("semi-dynamic" !== this.options.type || !e.contains(this.element[0], o)))
                            ) {
                                if (((this.direction = 1 === s ? "down" : "up"), "pointer" !== this.options.tolerance && !this._intersectsWithSides(n))) break;
                                this._rearrange(t, n), this._trigger("change", t, this._uiHash());
                                break;
                            }
                        return this._contactContainers(t), e.ui.ddmanager && e.ui.ddmanager.drag(this, t), this._trigger("sort", t, this._uiHash()), (this.lastPositionAbs = this.positionAbs), !1;
                    },
                    _mouseStop: function (t, i) {
                        if (t) {
                            if ((e.ui.ddmanager && !this.options.dropBehaviour && e.ui.ddmanager.drop(this, t), this.options.revert)) {
                                var n = this,
                                    o = this.placeholder.offset(),
                                    s = this.options.axis,
                                    a = {};
                                (s && "x" !== s) || (a.left = o.left - this.offset.parent.left - this.margins.left + (this.offsetParent[0] === document.body ? 0 : this.offsetParent[0].scrollLeft)),
                                    (s && "y" !== s) || (a.top = o.top - this.offset.parent.top - this.margins.top + (this.offsetParent[0] === document.body ? 0 : this.offsetParent[0].scrollTop)),
                                    (this.reverting = !0),
                                    e(this.helper).animate(a, parseInt(this.options.revert, 10) || 500, function () {
                                        n._clear(t);
                                    });
                            } else this._clear(t, i);
                            return !1;
                        }
                    },
                    cancel: function () {
                        if (this.dragging) {
                            this._mouseUp({ target: null }), "original" === this.options.helper ? this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper") : this.currentItem.show();
                            for (var t = this.containers.length - 1; t >= 0; t--)
                                this.containers[t]._trigger("deactivate", null, this._uiHash(this)),
                                    this.containers[t].containerCache.over && (this.containers[t]._trigger("out", null, this._uiHash(this)), (this.containers[t].containerCache.over = 0));
                        }
                        return (
                            this.placeholder &&
                                (this.placeholder[0].parentNode && this.placeholder[0].parentNode.removeChild(this.placeholder[0]),
                                "original" !== this.options.helper && this.helper && this.helper[0].parentNode && this.helper.remove(),
                                e.extend(this, { helper: null, dragging: !1, reverting: !1, _noFinalSort: null }),
                                this.domPosition.prev ? e(this.domPosition.prev).after(this.currentItem) : e(this.domPosition.parent).prepend(this.currentItem)),
                            this
                        );
                    },
                    serialize: function (t) {
                        var i = this._getItemsAsjQuery(t && t.connected),
                            n = [];
                        return (
                            (t = t || {}),
                            e(i).each(function () {
                                var i = (e(t.item || this).attr(t.attribute || "id") || "").match(t.expression || /(.+)[\-=_](.+)/);
                                i && n.push((t.key || i[1] + "[]") + "=" + (t.key && t.expression ? i[1] : i[2]));
                            }),
                            !n.length && t.key && n.push(t.key + "="),
                            n.join("&")
                        );
                    },
                    toArray: function (t) {
                        var i = this._getItemsAsjQuery(t && t.connected),
                            n = [];
                        return (
                            (t = t || {}),
                            i.each(function () {
                                n.push(e(t.item || this).attr(t.attribute || "id") || "");
                            }),
                            n
                        );
                    },
                    _intersectsWith: function (e) {
                        var t = this.positionAbs.left,
                            i = t + this.helperProportions.width,
                            n = this.positionAbs.top,
                            o = n + this.helperProportions.height,
                            s = e.left,
                            a = s + e.width,
                            r = e.top,
                            l = r + e.height,
                            c = this.offset.click.top,
                            h = this.offset.click.left,
                            d = "x" === this.options.axis || (n + c > r && l > n + c),
                            u = "y" === this.options.axis || (t + h > s && a > t + h),
                            p = d && u;
                        return "pointer" === this.options.tolerance ||
                            this.options.forcePointerForContainers ||
                            ("pointer" !== this.options.tolerance && this.helperProportions[this.floating ? "width" : "height"] > e[this.floating ? "width" : "height"])
                            ? p
                            : t + this.helperProportions.width / 2 > s && a > i - this.helperProportions.width / 2 && n + this.helperProportions.height / 2 > r && l > o - this.helperProportions.height / 2;
                    },
                    _intersectsWithPointer: function (e) {
                        var i = "x" === this.options.axis || t(this.positionAbs.top + this.offset.click.top, e.top, e.height),
                            n = "y" === this.options.axis || t(this.positionAbs.left + this.offset.click.left, e.left, e.width),
                            o = i && n,
                            s = this._getDragVerticalDirection(),
                            a = this._getDragHorizontalDirection();
                        return !!o && (this.floating ? ((a && "right" === a) || "down" === s ? 2 : 1) : s && ("down" === s ? 2 : 1));
                    },
                    _intersectsWithSides: function (e) {
                        var i = t(this.positionAbs.top + this.offset.click.top, e.top + e.height / 2, e.height),
                            n = t(this.positionAbs.left + this.offset.click.left, e.left + e.width / 2, e.width),
                            o = this._getDragVerticalDirection(),
                            s = this._getDragHorizontalDirection();
                        return this.floating && s ? ("right" === s && n) || ("left" === s && !n) : o && (("down" === o && i) || ("up" === o && !i));
                    },
                    _getDragVerticalDirection: function () {
                        var e = this.positionAbs.top - this.lastPositionAbs.top;
                        return 0 !== e && (e > 0 ? "down" : "up");
                    },
                    _getDragHorizontalDirection: function () {
                        var e = this.positionAbs.left - this.lastPositionAbs.left;
                        return 0 !== e && (e > 0 ? "right" : "left");
                    },
                    refresh: function (e) {
                        return this._refreshItems(e), this.refreshPositions(), this;
                    },
                    _connectWith: function () {
                        var e = this.options;
                        return e.connectWith.constructor === String ? [e.connectWith] : e.connectWith;
                    },
                    _getItemsAsjQuery: function (t) {
                        function i() {
                            r.push(this);
                        }
                        var n,
                            o,
                            s,
                            a,
                            r = [],
                            l = [],
                            c = this._connectWith();
                        if (c && t)
                            for (n = c.length - 1; n >= 0; n--)
                                for (o = (s = e(c[n])).length - 1; o >= 0; o--)
                                    (a = e.data(s[o], this.widgetFullName)) &&
                                        a !== this &&
                                        !a.options.disabled &&
                                        l.push([e.isFunction(a.options.items) ? a.options.items.call(a.element) : e(a.options.items, a.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), a]);
                        for (
                            l.push([
                                e.isFunction(this.options.items)
                                    ? this.options.items.call(this.element, null, { options: this.options, item: this.currentItem })
                                    : e(this.options.items, this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),
                                this,
                            ]),
                                n = l.length - 1;
                            n >= 0;
                            n--
                        )
                            l[n][0].each(i);
                        return e(r);
                    },
                    _removeCurrentsFromItems: function () {
                        var t = this.currentItem.find(":data(" + this.widgetName + "-item)");
                        this.items = e.grep(this.items, function (e) {
                            for (var i = 0; t.length > i; i++) if (t[i] === e.item[0]) return !1;
                            return !0;
                        });
                    },
                    _refreshItems: function (t) {
                        (this.items = []), (this.containers = [this]);
                        var i,
                            n,
                            o,
                            s,
                            a,
                            r,
                            l,
                            c,
                            h = this.items,
                            d = [[e.isFunction(this.options.items) ? this.options.items.call(this.element[0], t, { item: this.currentItem }) : e(this.options.items, this.element), this]],
                            u = this._connectWith();
                        if (u && this.ready)
                            for (i = u.length - 1; i >= 0; i--)
                                for (n = (o = e(u[i])).length - 1; n >= 0; n--)
                                    (s = e.data(o[n], this.widgetFullName)) &&
                                        s !== this &&
                                        !s.options.disabled &&
                                        (d.push([e.isFunction(s.options.items) ? s.options.items.call(s.element[0], t, { item: this.currentItem }) : e(s.options.items, s.element), s]), this.containers.push(s));
                        for (i = d.length - 1; i >= 0; i--)
                            for (a = d[i][1], n = 0, c = (r = d[i][0]).length; c > n; n++) (l = e(r[n])).data(this.widgetName + "-item", a), h.push({ item: l, instance: a, width: 0, height: 0, left: 0, top: 0 });
                    },
                    refreshPositions: function (t) {
                        var i, n, o, s;
                        for (this.offsetParent && this.helper && (this.offset.parent = this._getParentOffset()), i = this.items.length - 1; i >= 0; i--)
                            ((n = this.items[i]).instance !== this.currentContainer && this.currentContainer && n.item[0] !== this.currentItem[0]) ||
                                ((o = this.options.toleranceElement ? e(this.options.toleranceElement, n.item) : n.item),
                                t || ((n.width = o.outerWidth()), (n.height = o.outerHeight())),
                                (s = o.offset()),
                                (n.left = s.left),
                                (n.top = s.top));
                        if (this.options.custom && this.options.custom.refreshContainers) this.options.custom.refreshContainers.call(this);
                        else
                            for (i = this.containers.length - 1; i >= 0; i--)
                                (s = this.containers[i].element.offset()),
                                    (this.containers[i].containerCache.left = s.left),
                                    (this.containers[i].containerCache.top = s.top),
                                    (this.containers[i].containerCache.width = this.containers[i].element.outerWidth()),
                                    (this.containers[i].containerCache.height = this.containers[i].element.outerHeight());
                        return this;
                    },
                    _createPlaceholder: function (t) {
                        var i,
                            n = (t = t || this).options;
                        (n.placeholder && n.placeholder.constructor !== String) ||
                            ((i = n.placeholder),
                            (n.placeholder = {
                                element: function () {
                                    var n = t.currentItem[0].nodeName.toLowerCase(),
                                        o = e("<" + n + ">", t.document[0])
                                            .addClass(i || t.currentItem[0].className + " ui-sortable-placeholder")
                                            .removeClass("ui-sortable-helper");
                                    return (
                                        "tr" === n
                                            ? t.currentItem.children().each(function () {
                                                  e("<td>&#160;</td>", t.document[0])
                                                      .attr("colspan", e(this).attr("colspan") || 1)
                                                      .appendTo(o);
                                              })
                                            : "img" === n && o.attr("src", t.currentItem.attr("src")),
                                        i || o.css("visibility", "hidden"),
                                        o
                                    );
                                },
                                update: function (e, o) {
                                    (!i || n.forcePlaceholderSize) &&
                                        (o.height() || o.height(t.currentItem.innerHeight() - parseInt(t.currentItem.css("paddingTop") || 0, 10) - parseInt(t.currentItem.css("paddingBottom") || 0, 10)),
                                        o.width() || o.width(t.currentItem.innerWidth() - parseInt(t.currentItem.css("paddingLeft") || 0, 10) - parseInt(t.currentItem.css("paddingRight") || 0, 10)));
                                },
                            })),
                            (t.placeholder = e(n.placeholder.element.call(t.element, t.currentItem))),
                            t.currentItem.after(t.placeholder),
                            n.placeholder.update(t, t.placeholder);
                    },
                    _contactContainers: function (n) {
                        var o,
                            s,
                            a,
                            r,
                            l,
                            c,
                            h,
                            d,
                            u,
                            p,
                            f = null,
                            m = null;
                        for (o = this.containers.length - 1; o >= 0; o--)
                            if (!e.contains(this.currentItem[0], this.containers[o].element[0]))
                                if (this._intersectsWith(this.containers[o].containerCache)) {
                                    if (f && e.contains(this.containers[o].element[0], f.element[0])) continue;
                                    (f = this.containers[o]), (m = o);
                                } else this.containers[o].containerCache.over && (this.containers[o]._trigger("out", n, this._uiHash(this)), (this.containers[o].containerCache.over = 0));
                        if (f)
                            if (1 === this.containers.length) this.containers[m].containerCache.over || (this.containers[m]._trigger("over", n, this._uiHash(this)), (this.containers[m].containerCache.over = 1));
                            else {
                                for (a = 1e4, r = null, l = (p = f.floating || i(this.currentItem)) ? "left" : "top", c = p ? "width" : "height", h = this.positionAbs[l] + this.offset.click[l], s = this.items.length - 1; s >= 0; s--)
                                    e.contains(this.containers[m].element[0], this.items[s].item[0]) &&
                                        this.items[s].item[0] !== this.currentItem[0] &&
                                        (!p || t(this.positionAbs.top + this.offset.click.top, this.items[s].top, this.items[s].height)) &&
                                        ((d = this.items[s].item.offset()[l]),
                                        (u = !1),
                                        Math.abs(d - h) > Math.abs(d + this.items[s][c] - h) && ((u = !0), (d += this.items[s][c])),
                                        a > Math.abs(d - h) && ((a = Math.abs(d - h)), (r = this.items[s]), (this.direction = u ? "up" : "down")));
                                if (!r && !this.options.dropOnEmpty) return;
                                if (this.currentContainer === this.containers[m]) return;
                                r ? this._rearrange(n, r, null, !0) : this._rearrange(n, null, this.containers[m].element, !0),
                                    this._trigger("change", n, this._uiHash()),
                                    this.containers[m]._trigger("change", n, this._uiHash(this)),
                                    (this.currentContainer = this.containers[m]),
                                    this.options.placeholder.update(this.currentContainer, this.placeholder),
                                    this.containers[m]._trigger("over", n, this._uiHash(this)),
                                    (this.containers[m].containerCache.over = 1);
                            }
                    },
                    _createHelper: function (t) {
                        var i = this.options,
                            n = e.isFunction(i.helper) ? e(i.helper.apply(this.element[0], [t, this.currentItem])) : "clone" === i.helper ? this.currentItem.clone() : this.currentItem;
                        return (
                            n.parents("body").length || e("parent" !== i.appendTo ? i.appendTo : this.currentItem[0].parentNode)[0].appendChild(n[0]),
                            n[0] === this.currentItem[0] &&
                                (this._storedCSS = {
                                    width: this.currentItem[0].style.width,
                                    height: this.currentItem[0].style.height,
                                    position: this.currentItem.css("position"),
                                    top: this.currentItem.css("top"),
                                    left: this.currentItem.css("left"),
                                }),
                            (!n[0].style.width || i.forceHelperSize) && n.width(this.currentItem.width()),
                            (!n[0].style.height || i.forceHelperSize) && n.height(this.currentItem.height()),
                            n
                        );
                    },
                    _adjustOffsetFromHelper: function (t) {
                        "string" == typeof t && (t = t.split(" ")),
                            e.isArray(t) && (t = { left: +t[0], top: +t[1] || 0 }),
                            "left" in t && (this.offset.click.left = t.left + this.margins.left),
                            "right" in t && (this.offset.click.left = this.helperProportions.width - t.right + this.margins.left),
                            "top" in t && (this.offset.click.top = t.top + this.margins.top),
                            "bottom" in t && (this.offset.click.top = this.helperProportions.height - t.bottom + this.margins.top);
                    },
                    _getParentOffset: function () {
                        this.offsetParent = this.helper.offsetParent();
                        var t = this.offsetParent.offset();
                        return (
                            "absolute" === this.cssPosition &&
                                this.scrollParent[0] !== document &&
                                e.contains(this.scrollParent[0], this.offsetParent[0]) &&
                                ((t.left += this.scrollParent.scrollLeft()), (t.top += this.scrollParent.scrollTop())),
                            (this.offsetParent[0] === document.body || (this.offsetParent[0].tagName && "html" === this.offsetParent[0].tagName.toLowerCase() && e.ui.ie)) && (t = { top: 0, left: 0 }),
                            { top: t.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0), left: t.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0) }
                        );
                    },
                    _getRelativeOffset: function () {
                        if ("relative" === this.cssPosition) {
                            var e = this.currentItem.position();
                            return { top: e.top - (parseInt(this.helper.css("top"), 10) || 0) + this.scrollParent.scrollTop(), left: e.left - (parseInt(this.helper.css("left"), 10) || 0) + this.scrollParent.scrollLeft() };
                        }
                        return { top: 0, left: 0 };
                    },
                    _cacheMargins: function () {
                        this.margins = { left: parseInt(this.currentItem.css("marginLeft"), 10) || 0, top: parseInt(this.currentItem.css("marginTop"), 10) || 0 };
                    },
                    _cacheHelperProportions: function () {
                        this.helperProportions = { width: this.helper.outerWidth(), height: this.helper.outerHeight() };
                    },
                    _setContainment: function () {
                        var t,
                            i,
                            n,
                            o = this.options;
                        "parent" === o.containment && (o.containment = this.helper[0].parentNode),
                            ("document" === o.containment || "window" === o.containment) &&
                                (this.containment = [
                                    0 - this.offset.relative.left - this.offset.parent.left,
                                    0 - this.offset.relative.top - this.offset.parent.top,
                                    e("document" === o.containment ? document : window).width() - this.helperProportions.width - this.margins.left,
                                    (e("document" === o.containment ? document : window).height() || document.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top,
                                ]),
                            /^(document|window|parent)$/.test(o.containment) ||
                                ((t = e(o.containment)[0]),
                                (i = e(o.containment).offset()),
                                (n = "hidden" !== e(t).css("overflow")),
                                (this.containment = [
                                    i.left + (parseInt(e(t).css("borderLeftWidth"), 10) || 0) + (parseInt(e(t).css("paddingLeft"), 10) || 0) - this.margins.left,
                                    i.top + (parseInt(e(t).css("borderTopWidth"), 10) || 0) + (parseInt(e(t).css("paddingTop"), 10) || 0) - this.margins.top,
                                    i.left +
                                        (n ? Math.max(t.scrollWidth, t.offsetWidth) : t.offsetWidth) -
                                        (parseInt(e(t).css("borderLeftWidth"), 10) || 0) -
                                        (parseInt(e(t).css("paddingRight"), 10) || 0) -
                                        this.helperProportions.width -
                                        this.margins.left,
                                    i.top +
                                        (n ? Math.max(t.scrollHeight, t.offsetHeight) : t.offsetHeight) -
                                        (parseInt(e(t).css("borderTopWidth"), 10) || 0) -
                                        (parseInt(e(t).css("paddingBottom"), 10) || 0) -
                                        this.helperProportions.height -
                                        this.margins.top,
                                ]));
                    },
                    _convertPositionTo: function (t, i) {
                        i || (i = this.position);
                        var n = "absolute" === t ? 1 : -1,
                            o = "absolute" !== this.cssPosition || (this.scrollParent[0] !== document && e.contains(this.scrollParent[0], this.offsetParent[0])) ? this.scrollParent : this.offsetParent,
                            s = /(html|body)/i.test(o[0].tagName);
                        return {
                            top: i.top + this.offset.relative.top * n + this.offset.parent.top * n - ("fixed" === this.cssPosition ? -this.scrollParent.scrollTop() : s ? 0 : o.scrollTop()) * n,
                            left: i.left + this.offset.relative.left * n + this.offset.parent.left * n - ("fixed" === this.cssPosition ? -this.scrollParent.scrollLeft() : s ? 0 : o.scrollLeft()) * n,
                        };
                    },
                    _generatePosition: function (t) {
                        var i,
                            n,
                            o = this.options,
                            s = t.pageX,
                            a = t.pageY,
                            r = "absolute" !== this.cssPosition || (this.scrollParent[0] !== document && e.contains(this.scrollParent[0], this.offsetParent[0])) ? this.scrollParent : this.offsetParent,
                            l = /(html|body)/i.test(r[0].tagName);
                        return (
                            "relative" !== this.cssPosition || (this.scrollParent[0] !== document && this.scrollParent[0] !== this.offsetParent[0]) || (this.offset.relative = this._getRelativeOffset()),
                            this.originalPosition &&
                                (this.containment &&
                                    (t.pageX - this.offset.click.left < this.containment[0] && (s = this.containment[0] + this.offset.click.left),
                                    t.pageY - this.offset.click.top < this.containment[1] && (a = this.containment[1] + this.offset.click.top),
                                    t.pageX - this.offset.click.left > this.containment[2] && (s = this.containment[2] + this.offset.click.left),
                                    t.pageY - this.offset.click.top > this.containment[3] && (a = this.containment[3] + this.offset.click.top)),
                                o.grid &&
                                    ((i = this.originalPageY + Math.round((a - this.originalPageY) / o.grid[1]) * o.grid[1]),
                                    (a = this.containment
                                        ? i - this.offset.click.top >= this.containment[1] && i - this.offset.click.top <= this.containment[3]
                                            ? i
                                            : i - this.offset.click.top >= this.containment[1]
                                            ? i - o.grid[1]
                                            : i + o.grid[1]
                                        : i),
                                    (n = this.originalPageX + Math.round((s - this.originalPageX) / o.grid[0]) * o.grid[0]),
                                    (s = this.containment
                                        ? n - this.offset.click.left >= this.containment[0] && n - this.offset.click.left <= this.containment[2]
                                            ? n
                                            : n - this.offset.click.left >= this.containment[0]
                                            ? n - o.grid[0]
                                            : n + o.grid[0]
                                        : n))),
                            {
                                top: a - this.offset.click.top - this.offset.relative.top - this.offset.parent.top + ("fixed" === this.cssPosition ? -this.scrollParent.scrollTop() : l ? 0 : r.scrollTop()),
                                left: s - this.offset.click.left - this.offset.relative.left - this.offset.parent.left + ("fixed" === this.cssPosition ? -this.scrollParent.scrollLeft() : l ? 0 : r.scrollLeft()),
                            }
                        );
                    },
                    _rearrange: function (e, t, i, n) {
                        i ? i[0].appendChild(this.placeholder[0]) : t.item[0].parentNode.insertBefore(this.placeholder[0], "down" === this.direction ? t.item[0] : t.item[0].nextSibling), (this.counter = this.counter ? ++this.counter : 1);
                        var o = this.counter;
                        this._delay(function () {
                            o === this.counter && this.refreshPositions(!n);
                        });
                    },
                    _clear: function (e, t) {
                        function i(e, t, i) {
                            return function (n) {
                                i._trigger(e, n, t._uiHash(t));
                            };
                        }
                        this.reverting = !1;
                        var n,
                            o = [];
                        if ((!this._noFinalSort && this.currentItem.parent().length && this.placeholder.before(this.currentItem), (this._noFinalSort = null), this.helper[0] === this.currentItem[0])) {
                            for (n in this._storedCSS) ("auto" === this._storedCSS[n] || "static" === this._storedCSS[n]) && (this._storedCSS[n] = "");
                            this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
                        } else this.currentItem.show();
                        for (
                            this.fromOutside &&
                                !t &&
                                o.push(function (e) {
                                    this._trigger("receive", e, this._uiHash(this.fromOutside));
                                }),
                                (!this.fromOutside && this.domPosition.prev === this.currentItem.prev().not(".ui-sortable-helper")[0] && this.domPosition.parent === this.currentItem.parent()[0]) ||
                                    t ||
                                    o.push(function (e) {
                                        this._trigger("update", e, this._uiHash());
                                    }),
                                this !== this.currentContainer &&
                                    (t ||
                                        (o.push(function (e) {
                                            this._trigger("remove", e, this._uiHash());
                                        }),
                                        o.push(
                                            function (e) {
                                                return function (t) {
                                                    e._trigger("receive", t, this._uiHash(this));
                                                };
                                            }.call(this, this.currentContainer)
                                        ),
                                        o.push(
                                            function (e) {
                                                return function (t) {
                                                    e._trigger("update", t, this._uiHash(this));
                                                };
                                            }.call(this, this.currentContainer)
                                        ))),
                                n = this.containers.length - 1;
                            n >= 0;
                            n--
                        )
                            t || o.push(i("deactivate", this, this.containers[n])), this.containers[n].containerCache.over && (o.push(i("out", this, this.containers[n])), (this.containers[n].containerCache.over = 0));
                        if (
                            (this.storedCursor && (this.document.find("body").css("cursor", this.storedCursor), this.storedStylesheet.remove()),
                            this._storedOpacity && this.helper.css("opacity", this._storedOpacity),
                            this._storedZIndex && this.helper.css("zIndex", "auto" === this._storedZIndex ? "" : this._storedZIndex),
                            (this.dragging = !1),
                            this.cancelHelperRemoval)
                        ) {
                            if (!t) {
                                for (this._trigger("beforeStop", e, this._uiHash()), n = 0; o.length > n; n++) o[n].call(this, e);
                                this._trigger("stop", e, this._uiHash());
                            }
                            return (this.fromOutside = !1), !1;
                        }
                        if ((t || this._trigger("beforeStop", e, this._uiHash()), this.placeholder[0].parentNode.removeChild(this.placeholder[0]), this.helper[0] !== this.currentItem[0] && this.helper.remove(), (this.helper = null), !t)) {
                            for (n = 0; o.length > n; n++) o[n].call(this, e);
                            this._trigger("stop", e, this._uiHash());
                        }
                        return (this.fromOutside = !1), !0;
                    },
                    _trigger: function () {
                        !1 === e.Widget.prototype._trigger.apply(this, arguments) && this.cancel();
                    },
                    _uiHash: function (t) {
                        var i = t || this;
                        return { helper: i.helper, placeholder: i.placeholder || e([]), position: i.position, originalPosition: i.originalPosition, offset: i.positionAbs, item: i.currentItem, sender: t ? t.element : null };
                    },
                });
            })(jQuery),
            (function (e) {
                e.widget("ui.slider", e.ui.mouse, {
                    version: "1.10.4",
                    widgetEventPrefix: "slide",
                    options: { animate: !1, distance: 0, max: 100, min: 0, orientation: "horizontal", range: !1, step: 1, value: 0, values: null, change: null, slide: null, start: null, stop: null },
                    _create: function () {
                        (this._keySliding = !1),
                            (this._mouseSliding = !1),
                            (this._animateOff = !0),
                            (this._handleIndex = null),
                            this._detectOrientation(),
                            this._mouseInit(),
                            this.element.addClass("ui-slider ui-slider-" + this.orientation + " ui-widget ui-widget-content ui-corner-all"),
                            this._refresh(),
                            this._setOption("disabled", this.options.disabled),
                            (this._animateOff = !1);
                    },
                    _refresh: function () {
                        this._createRange(), this._createHandles(), this._setupEvents(), this._refreshValue();
                    },
                    _createHandles: function () {
                        var t,
                            i,
                            n = this.options,
                            o = this.element.find(".ui-slider-handle").addClass("ui-state-default ui-corner-all"),
                            s = [];
                        for (i = (n.values && n.values.length) || 1, o.length > i && (o.slice(i).remove(), (o = o.slice(0, i))), t = o.length; i > t; t++) s.push("<a class='ui-slider-handle ui-state-default ui-corner-all' href='#'></a>");
                        (this.handles = o.add(e(s.join("")).appendTo(this.element))),
                            (this.handle = this.handles.eq(0)),
                            this.handles.each(function (t) {
                                e(this).data("ui-slider-handle-index", t);
                            });
                    },
                    _createRange: function () {
                        var t = this.options,
                            i = "";
                        t.range
                            ? (!0 === t.range &&
                                  (t.values ? (t.values.length && 2 !== t.values.length ? (t.values = [t.values[0], t.values[0]]) : e.isArray(t.values) && (t.values = t.values.slice(0))) : (t.values = [this._valueMin(), this._valueMin()])),
                              this.range && this.range.length
                                  ? this.range.removeClass("ui-slider-range-min ui-slider-range-max").css({ left: "", bottom: "" })
                                  : ((this.range = e("<div></div>").appendTo(this.element)), (i = "ui-slider-range ui-widget-header ui-corner-all")),
                              this.range.addClass(i + ("min" === t.range || "max" === t.range ? " ui-slider-range-" + t.range : "")))
                            : (this.range && this.range.remove(), (this.range = null));
                    },
                    _setupEvents: function () {
                        var e = this.handles.add(this.range).filter("a");
                        this._off(e), this._on(e, this._handleEvents), this._hoverable(e), this._focusable(e);
                    },
                    _destroy: function () {
                        this.handles.remove(), this.range && this.range.remove(), this.element.removeClass("ui-slider ui-slider-horizontal ui-slider-vertical ui-widget ui-widget-content ui-corner-all"), this._mouseDestroy();
                    },
                    _mouseCapture: function (t) {
                        var i,
                            n,
                            o,
                            s,
                            a,
                            r,
                            l,
                            c = this,
                            h = this.options;
                        return (
                            !h.disabled &&
                            ((this.elementSize = { width: this.element.outerWidth(), height: this.element.outerHeight() }),
                            (this.elementOffset = this.element.offset()),
                            (i = { x: t.pageX, y: t.pageY }),
                            (n = this._normValueFromMouse(i)),
                            (o = this._valueMax() - this._valueMin() + 1),
                            this.handles.each(function (t) {
                                var i = Math.abs(n - c.values(t));
                                (o > i || (o === i && (t === c._lastChangedValue || c.values(t) === h.min))) && ((o = i), (s = e(this)), (a = t));
                            }),
                            !1 !== this._start(t, a) &&
                                ((this._mouseSliding = !0),
                                (this._handleIndex = a),
                                s.addClass("ui-state-active").focus(),
                                (r = s.offset()),
                                (l = !e(t.target).parents().addBack().is(".ui-slider-handle")),
                                (this._clickOffset = l
                                    ? { left: 0, top: 0 }
                                    : {
                                          left: t.pageX - r.left - s.width() / 2,
                                          top: t.pageY - r.top - s.height() / 2 - (parseInt(s.css("borderTopWidth"), 10) || 0) - (parseInt(s.css("borderBottomWidth"), 10) || 0) + (parseInt(s.css("marginTop"), 10) || 0),
                                      }),
                                this.handles.hasClass("ui-state-hover") || this._slide(t, a, n),
                                (this._animateOff = !0),
                                !0))
                        );
                    },
                    _mouseStart: function () {
                        return !0;
                    },
                    _mouseDrag: function (e) {
                        var t = { x: e.pageX, y: e.pageY },
                            i = this._normValueFromMouse(t);
                        return this._slide(e, this._handleIndex, i), !1;
                    },
                    _mouseStop: function (e) {
                        return (
                            this.handles.removeClass("ui-state-active"),
                            (this._mouseSliding = !1),
                            this._stop(e, this._handleIndex),
                            this._change(e, this._handleIndex),
                            (this._handleIndex = null),
                            (this._clickOffset = null),
                            (this._animateOff = !1),
                            !1
                        );
                    },
                    _detectOrientation: function () {
                        this.orientation = "vertical" === this.options.orientation ? "vertical" : "horizontal";
                    },
                    _normValueFromMouse: function (e) {
                        var t, i, n, o, s;
                        return (
                            "horizontal" === this.orientation
                                ? ((t = this.elementSize.width), (i = e.x - this.elementOffset.left - (this._clickOffset ? this._clickOffset.left : 0)))
                                : ((t = this.elementSize.height), (i = e.y - this.elementOffset.top - (this._clickOffset ? this._clickOffset.top : 0))),
                            (n = i / t) > 1 && (n = 1),
                            0 > n && (n = 0),
                            "vertical" === this.orientation && (n = 1 - n),
                            (o = this._valueMax() - this._valueMin()),
                            (s = this._valueMin() + n * o),
                            this._trimAlignValue(s)
                        );
                    },
                    _start: function (e, t) {
                        var i = { handle: this.handles[t], value: this.value() };
                        return this.options.values && this.options.values.length && ((i.value = this.values(t)), (i.values = this.values())), this._trigger("start", e, i);
                    },
                    _slide: function (e, t, i) {
                        var n, o, s;
                        this.options.values && this.options.values.length
                            ? ((n = this.values(t ? 0 : 1)),
                              2 === this.options.values.length && !0 === this.options.range && ((0 === t && i > n) || (1 === t && n > i)) && (i = n),
                              i !== this.values(t) && (((o = this.values())[t] = i), (s = this._trigger("slide", e, { handle: this.handles[t], value: i, values: o })), (n = this.values(t ? 0 : 1)), !1 !== s && this.values(t, i)))
                            : i !== this.value() && !1 !== (s = this._trigger("slide", e, { handle: this.handles[t], value: i })) && this.value(i);
                    },
                    _stop: function (e, t) {
                        var i = { handle: this.handles[t], value: this.value() };
                        this.options.values && this.options.values.length && ((i.value = this.values(t)), (i.values = this.values())), this._trigger("stop", e, i);
                    },
                    _change: function (e, t) {
                        if (!this._keySliding && !this._mouseSliding) {
                            var i = { handle: this.handles[t], value: this.value() };
                            this.options.values && this.options.values.length && ((i.value = this.values(t)), (i.values = this.values())), (this._lastChangedValue = t), this._trigger("change", e, i);
                        }
                    },
                    value: function (e) {
                        return arguments.length ? ((this.options.value = this._trimAlignValue(e)), this._refreshValue(), this._change(null, 0), undefined) : this._value();
                    },
                    values: function (t, i) {
                        var n, o, s;
                        if (arguments.length > 1) return (this.options.values[t] = this._trimAlignValue(i)), this._refreshValue(), this._change(null, t), undefined;
                        if (!arguments.length) return this._values();
                        if (!e.isArray(arguments[0])) return this.options.values && this.options.values.length ? this._values(t) : this.value();
                        for (n = this.options.values, o = arguments[0], s = 0; n.length > s; s += 1) (n[s] = this._trimAlignValue(o[s])), this._change(null, s);
                        this._refreshValue();
                    },
                    _setOption: function (t, i) {
                        var n,
                            o = 0;
                        switch (
                            ("range" === t &&
                                !0 === this.options.range &&
                                ("min" === i ? ((this.options.value = this._values(0)), (this.options.values = null)) : "max" === i && ((this.options.value = this._values(this.options.values.length - 1)), (this.options.values = null))),
                            e.isArray(this.options.values) && (o = this.options.values.length),
                            e.Widget.prototype._setOption.apply(this, arguments),
                            t)
                        ) {
                            case "orientation":
                                this._detectOrientation(), this.element.removeClass("ui-slider-horizontal ui-slider-vertical").addClass("ui-slider-" + this.orientation), this._refreshValue();
                                break;
                            case "value":
                                (this._animateOff = !0), this._refreshValue(), this._change(null, 0), (this._animateOff = !1);
                                break;
                            case "values":
                                for (this._animateOff = !0, this._refreshValue(), n = 0; o > n; n += 1) this._change(null, n);
                                this._animateOff = !1;
                                break;
                            case "min":
                            case "max":
                                (this._animateOff = !0), this._refreshValue(), (this._animateOff = !1);
                                break;
                            case "range":
                                (this._animateOff = !0), this._refresh(), (this._animateOff = !1);
                        }
                    },
                    _value: function () {
                        var e = this.options.value;
                        return this._trimAlignValue(e);
                    },
                    _values: function (e) {
                        var t, i, n;
                        if (arguments.length) return (t = this.options.values[e]), this._trimAlignValue(t);
                        if (this.options.values && this.options.values.length) {
                            for (i = this.options.values.slice(), n = 0; i.length > n; n += 1) i[n] = this._trimAlignValue(i[n]);
                            return i;
                        }
                        return [];
                    },
                    _trimAlignValue: function (e) {
                        if (this._valueMin() >= e) return this._valueMin();
                        if (e >= this._valueMax()) return this._valueMax();
                        var t = this.options.step > 0 ? this.options.step : 1,
                            i = (e - this._valueMin()) % t,
                            n = e - i;
                        return 2 * Math.abs(i) >= t && (n += i > 0 ? t : -t), parseFloat(n.toFixed(5));
                    },
                    _valueMin: function () {
                        return this.options.min;
                    },
                    _valueMax: function () {
                        return this.options.max;
                    },
                    _refreshValue: function () {
                        var t,
                            i,
                            n,
                            o,
                            s,
                            a = this.options.range,
                            r = this.options,
                            l = this,
                            c = !this._animateOff && r.animate,
                            h = {};
                        this.options.values && this.options.values.length
                            ? this.handles.each(function (n) {
                                  (i = ((l.values(n) - l._valueMin()) / (l._valueMax() - l._valueMin())) * 100),
                                      (h["horizontal" === l.orientation ? "left" : "bottom"] = i + "%"),
                                      e(this).stop(1, 1)[c ? "animate" : "css"](h, r.animate),
                                      !0 === l.options.range &&
                                          ("horizontal" === l.orientation
                                              ? (0 === n && l.range.stop(1, 1)[c ? "animate" : "css"]({ left: i + "%" }, r.animate), 1 === n && l.range[c ? "animate" : "css"]({ width: i - t + "%" }, { queue: !1, duration: r.animate }))
                                              : (0 === n && l.range.stop(1, 1)[c ? "animate" : "css"]({ bottom: i + "%" }, r.animate), 1 === n && l.range[c ? "animate" : "css"]({ height: i - t + "%" }, { queue: !1, duration: r.animate }))),
                                      (t = i);
                              })
                            : ((n = this.value()),
                              (o = this._valueMin()),
                              (s = this._valueMax()),
                              (i = s !== o ? ((n - o) / (s - o)) * 100 : 0),
                              (h["horizontal" === this.orientation ? "left" : "bottom"] = i + "%"),
                              this.handle.stop(1, 1)[c ? "animate" : "css"](h, r.animate),
                              "min" === a && "horizontal" === this.orientation && this.range.stop(1, 1)[c ? "animate" : "css"]({ width: i + "%" }, r.animate),
                              "max" === a && "horizontal" === this.orientation && this.range[c ? "animate" : "css"]({ width: 100 - i + "%" }, { queue: !1, duration: r.animate }),
                              "min" === a && "vertical" === this.orientation && this.range.stop(1, 1)[c ? "animate" : "css"]({ height: i + "%" }, r.animate),
                              "max" === a && "vertical" === this.orientation && this.range[c ? "animate" : "css"]({ height: 100 - i + "%" }, { queue: !1, duration: r.animate }));
                    },
                    _handleEvents: {
                        keydown: function (t) {
                            var i,
                                n,
                                o,
                                s = e(t.target).data("ui-slider-handle-index");
                            switch (t.keyCode) {
                                case e.ui.keyCode.HOME:
                                case e.ui.keyCode.END:
                                case e.ui.keyCode.PAGE_UP:
                                case e.ui.keyCode.PAGE_DOWN:
                                case e.ui.keyCode.UP:
                                case e.ui.keyCode.RIGHT:
                                case e.ui.keyCode.DOWN:
                                case e.ui.keyCode.LEFT:
                                    if ((t.preventDefault(), !this._keySliding && ((this._keySliding = !0), e(t.target).addClass("ui-state-active"), !1 === this._start(t, s)))) return;
                            }
                            switch (((o = this.options.step), (i = n = this.options.values && this.options.values.length ? this.values(s) : this.value()), t.keyCode)) {
                                case e.ui.keyCode.HOME:
                                    n = this._valueMin();
                                    break;
                                case e.ui.keyCode.END:
                                    n = this._valueMax();
                                    break;
                                case e.ui.keyCode.PAGE_UP:
                                    n = this._trimAlignValue(i + (this._valueMax() - this._valueMin()) / 5);
                                    break;
                                case e.ui.keyCode.PAGE_DOWN:
                                    n = this._trimAlignValue(i - (this._valueMax() - this._valueMin()) / 5);
                                    break;
                                case e.ui.keyCode.UP:
                                case e.ui.keyCode.RIGHT:
                                    if (i === this._valueMax()) return;
                                    n = this._trimAlignValue(i + o);
                                    break;
                                case e.ui.keyCode.DOWN:
                                case e.ui.keyCode.LEFT:
                                    if (i === this._valueMin()) return;
                                    n = this._trimAlignValue(i - o);
                            }
                            this._slide(t, s, n);
                        },
                        click: function (e) {
                            e.preventDefault();
                        },
                        keyup: function (t) {
                            var i = e(t.target).data("ui-slider-handle-index");
                            this._keySliding && ((this._keySliding = !1), this._stop(t, i), this._change(t, i), e(t.target).removeClass("ui-state-active"));
                        },
                    },
                });
            })(jQuery)),
            1 == HawkSearch.loadPlugins.slider &&
                ((o = function () {
                    "use strict";
                    function e(e, t) {
                        var i = document.createElement("div");
                        return s(i, t), e.appendChild(i), i;
                    }
                    function t(e) {
                        return "number" == typeof e && !isNaN(e) && isFinite(e);
                    }
                    function i(e, t, i) {
                        i > 0 &&
                            (s(e, t),
                            setTimeout(function () {
                                a(e, t);
                            }, i));
                    }
                    function n(e) {
                        return Array.isArray(e) ? e : [e];
                    }
                    function o(e) {
                        var t = (e = String(e)).split(".");
                        return t.length > 1 ? t[1].length : 0;
                    }
                    function s(e, t) {
                        e.classList ? e.classList.add(t) : (e.className += " " + t);
                    }
                    function a(e, t) {
                        e.classList ? e.classList.remove(t) : (e.className = e.className.replace(new RegExp("(^|\\b)" + t.split(" ").join("|") + "(\\b|$)", "gi"), " "));
                    }
                    function r() {
                        var e = void 0 !== window.pageXOffset,
                            t = "CSS1Compat" === (document.compatMode || "");
                        return { x: e ? window.pageXOffset : t ? document.documentElement.scrollLeft : document.body.scrollLeft, y: e ? window.pageYOffset : t ? document.documentElement.scrollTop : document.body.scrollTop };
                    }
                    function l(e, t) {
                        return 100 / (t - e);
                    }
                    function c(e, t) {
                        return (100 * t) / (e[1] - e[0]);
                    }
                    function h(e, t) {
                        for (var i = 1; e >= t[i]; ) i += 1;
                        return i;
                    }
                    function d(e, t, i) {
                        if (i >= e.slice(-1)[0]) return 100;
                        var n,
                            o,
                            s,
                            a,
                            r = h(i, e);
                        return (
                            (n = e[r - 1]),
                            (o = e[r]),
                            (s = t[r - 1]),
                            (a = t[r]),
                            s +
                                (function (e, t) {
                                    return c(e, e[0] < 0 ? t + Math.abs(e[0]) : t - e[0]);
                                })([n, o], i) /
                                    l(s, a)
                        );
                    }
                    function u(e, t, i, n) {
                        if (100 === n) return n;
                        var o,
                            s,
                            a = h(n, e);
                        return i
                            ? n - (o = e[a - 1]) > ((s = e[a]) - o) / 2
                                ? s
                                : o
                            : t[a - 1]
                            ? e[a - 1] +
                              (function (e, t) {
                                  return Math.round(e / t) * t;
                              })(n - e[a - 1], t[a - 1])
                            : n;
                    }
                    function p(e, i, n) {
                        var o;
                        if (("number" == typeof i && (i = [i]), "[object Array]" !== Object.prototype.toString.call(i))) throw new Error("noUiSlider: 'range' contains invalid value.");
                        if (!t((o = "min" === e ? 0 : "max" === e ? 100 : parseFloat(e))) || !t(i[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
                        n.xPct.push(o), n.xVal.push(i[0]), o ? n.xSteps.push(!isNaN(i[1]) && i[1]) : isNaN(i[1]) || (n.xSteps[0] = i[1]), n.xHighestCompleteStep.push(0);
                    }
                    function f(e, t, i) {
                        if (!t) return !0;
                        i.xSteps[e] = c([i.xVal[e], i.xVal[e + 1]], t) / l(i.xPct[e], i.xPct[e + 1]);
                        var n = (i.xVal[e + 1] - i.xVal[e]) / i.xNumSteps[e],
                            o = Math.ceil(Number(n.toFixed(3)) - 1),
                            s = i.xVal[e] + i.xNumSteps[e] * o;
                        i.xHighestCompleteStep[e] = s;
                    }
                    function m(e, t, i, n) {
                        (this.xPct = []), (this.xVal = []), (this.xSteps = [n || !1]), (this.xNumSteps = [!1]), (this.xHighestCompleteStep = []), (this.snap = t), (this.direction = i);
                        var o,
                            s = [];
                        for (o in e) e.hasOwnProperty(o) && s.push([e[o], o]);
                        for (
                            s.length && "object" == typeof s[0][0]
                                ? s.sort(function (e, t) {
                                      return e[0][0] - t[0][0];
                                  })
                                : s.sort(function (e, t) {
                                      return e[0] - t[0];
                                  }),
                                o = 0;
                            o < s.length;
                            o++
                        )
                            p(s[o][1], s[o][0], this);
                        for (this.xNumSteps = this.xSteps.slice(0), o = 0; o < this.xNumSteps.length; o++) f(o, this.xNumSteps[o], this);
                    }
                    function g(e, i) {
                        if (!t(i)) throw new Error("noUiSlider: 'step' is not numeric.");
                        e.singleStep = i;
                    }
                    function v(e, t) {
                        if ("object" != typeof t || Array.isArray(t)) throw new Error("noUiSlider: 'range' is not an object.");
                        if (void 0 === t.min || void 0 === t.max) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
                        if (t.min === t.max) throw new Error("noUiSlider: 'range' 'min' and 'max' cannot be equal.");
                        e.spectrum = new m(t, e.snap, e.dir, e.singleStep);
                    }
                    function w(e, t) {
                        if (((t = n(t)), !Array.isArray(t) || !t.length)) throw new Error("noUiSlider: 'start' option is incorrect.");
                        (e.handles = t.length), (e.start = t);
                    }
                    function k(e, t) {
                        if (((e.snap = t), "boolean" != typeof t)) throw new Error("noUiSlider: 'snap' option must be a boolean.");
                    }
                    function y(e, t) {
                        if (((e.animate = t), "boolean" != typeof t)) throw new Error("noUiSlider: 'animate' option must be a boolean.");
                    }
                    function b(e, t) {
                        if (((e.animationDuration = t), "number" != typeof t)) throw new Error("noUiSlider: 'animationDuration' option must be a number.");
                    }
                    function S(e, t) {
                        var i,
                            n = [!1];
                        if (!0 === t || !1 === t) {
                            for (i = 1; i < e.handles; i++) n.push(t);
                            n.push(!1);
                        } else {
                            if (!Array.isArray(t) || !t.length || t.length !== e.handles + 1) throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
                            n = t;
                        }
                        e.connect = n;
                    }
                    function C(e, t) {
                        switch (t) {
                            case "horizontal":
                                e.ort = 0;
                                break;
                            case "vertical":
                                e.ort = 1;
                                break;
                            default:
                                throw new Error("noUiSlider: 'orientation' option is invalid.");
                        }
                    }
                    function _(e, i) {
                        if (!t(i)) throw new Error("noUiSlider: 'margin' option must be numeric.");
                        if (0 !== i && ((e.margin = e.spectrum.getMargin(i)), !e.margin)) throw new Error("noUiSlider: 'margin' option is only supported on linear sliders.");
                    }
                    function x(e, i) {
                        if (!t(i)) throw new Error("noUiSlider: 'limit' option must be numeric.");
                        if (((e.limit = e.spectrum.getMargin(i)), !e.limit || e.handles < 2)) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
                    }
                    function T(e, t) {
                        switch (t) {
                            case "ltr":
                                e.dir = 0;
                                break;
                            case "rtl":
                                e.dir = 1;
                                break;
                            default:
                                throw new Error("noUiSlider: 'direction' option was not recognized.");
                        }
                    }
                    function H(e, t) {
                        if ("string" != typeof t) throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
                        var i = t.indexOf("tap") >= 0,
                            n = t.indexOf("drag") >= 0,
                            o = t.indexOf("fixed") >= 0,
                            s = t.indexOf("snap") >= 0,
                            a = t.indexOf("hover") >= 0;
                        if (o) {
                            if (2 !== e.handles) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
                            _(e, e.start[1] - e.start[0]);
                        }
                        e.events = { tap: i || s, drag: n, fixed: o, snap: s, hover: a };
                    }
                    function I(e, t) {
                        if (!1 !== t)
                            if (!0 === t) {
                                e.tooltips = [];
                                for (var i = 0; i < e.handles; i++) e.tooltips.push(!0);
                            } else {
                                if (((e.tooltips = n(t)), e.tooltips.length !== e.handles)) throw new Error("noUiSlider: must pass a formatter for all handles.");
                                e.tooltips.forEach(function (e) {
                                    if ("boolean" != typeof e && ("object" != typeof e || "function" != typeof e.to)) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
                                });
                            }
                    }
                    function P(e, t) {
                        if (((e.format = t), "function" == typeof t.to && "function" == typeof t.from)) return !0;
                        throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
                    }
                    function E(e, t) {
                        if (void 0 !== t && "string" != typeof t && !1 !== t) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
                        e.cssPrefix = t;
                    }
                    function O(e, t) {
                        if (void 0 !== t && "object" != typeof t) throw new Error("noUiSlider: 'cssClasses' must be an object.");
                        if ("string" == typeof e.cssPrefix) for (var i in ((e.cssClasses = {}), t)) t.hasOwnProperty(i) && (e.cssClasses[i] = e.cssPrefix + t[i]);
                        else e.cssClasses = t;
                    }
                    function A(e, t) {
                        if (!0 !== t && !1 !== t) throw new Error("noUiSlider: 'useRequestAnimationFrame' option should be true (default) or false.");
                        e.useRequestAnimationFrame = t;
                    }
                    function L(e) {
                        var t,
                            i = { margin: 0, limit: 0, animate: !0, animationDuration: 300, format: U };
                        t = {
                            step: { r: !1, t: g },
                            start: { r: !0, t: w },
                            connect: { r: !0, t: S },
                            direction: { r: !0, t: T },
                            snap: { r: !1, t: k },
                            animate: { r: !1, t: y },
                            animationDuration: { r: !1, t: b },
                            range: { r: !0, t: v },
                            orientation: { r: !1, t: C },
                            margin: { r: !1, t: _ },
                            limit: { r: !1, t: x },
                            behaviour: { r: !0, t: H },
                            format: { r: !1, t: P },
                            tooltips: { r: !1, t: I },
                            cssPrefix: { r: !1, t: E },
                            cssClasses: { r: !1, t: O },
                            useRequestAnimationFrame: { r: !1, t: A },
                        };
                        var n = {
                            connect: !1,
                            direction: "ltr",
                            behaviour: "tap",
                            orientation: "horizontal",
                            cssPrefix: "noUi-",
                            cssClasses: {
                                target: "target",
                                base: "base",
                                origin: "origin",
                                handle: "handle",
                                horizontal: "horizontal",
                                vertical: "vertical",
                                background: "background",
                                connect: "connect",
                                ltr: "ltr",
                                rtl: "rtl",
                                draggable: "draggable",
                                drag: "state-drag",
                                tap: "state-tap",
                                active: "active",
                                tooltip: "tooltip",
                                pips: "pips",
                                pipsHorizontal: "pips-horizontal",
                                pipsVertical: "pips-vertical",
                                marker: "marker",
                                markerHorizontal: "marker-horizontal",
                                markerVertical: "marker-vertical",
                                markerNormal: "marker-normal",
                                markerLarge: "marker-large",
                                markerSub: "marker-sub",
                                value: "value",
                                valueHorizontal: "value-horizontal",
                                valueVertical: "value-vertical",
                                valueNormal: "value-normal",
                                valueLarge: "value-large",
                                valueSub: "value-sub",
                            },
                            useRequestAnimationFrame: !0,
                        };
                        Object.keys(t).forEach(function (o) {
                            if (void 0 === e[o] && void 0 === n[o]) {
                                if (t[o].r) throw new Error("noUiSlider: '" + o + "' is required.");
                                return !0;
                            }
                            t[o].t(i, void 0 === e[o] ? n[o] : e[o]);
                        }),
                            (i.pips = e.pips);
                        var o = [
                            ["left", "top"],
                            ["right", "bottom"],
                        ];
                        return (i.style = o[i.dir][i.ort]), (i.styleOposite = o[i.dir ? 0 : 1][i.ort]), i;
                    }
                    function N(t, o, l) {
                        function c(t, i) {
                            var n = e(t, o.cssClasses.origin);
                            return e(n, o.cssClasses.handle).setAttribute("data-handle", i), n;
                        }
                        function h(t, i) {
                            return !!i && e(t, o.cssClasses.connect);
                        }
                        function d(t, i) {
                            return !!o.tooltips[i] && e(t.firstChild, o.cssClasses.tooltip);
                        }
                        function u(e, t, i) {
                            function n(e, t, i) {
                                return (
                                    'class="' +
                                    (function (e, t) {
                                        var i = t === o.cssClasses.value,
                                            n = i ? c : h;
                                        return t + " " + (i ? d : u)[o.ort] + " " + n[e];
                                    })(i[1], t) +
                                    '" style="' +
                                    o.style +
                                    ": " +
                                    e +
                                    '%"'
                                );
                            }
                            function a(e, s) {
                                (s[1] = s[1] && t ? t(s[0], s[1]) : s[1]), (l += "<div " + n(e, o.cssClasses.marker, s) + "></div>"), s[1] && (l += "<div " + n(e, o.cssClasses.value, s) + ">" + i.to(s[0]) + "</div>");
                            }
                            var r = document.createElement("div"),
                                l = "",
                                c = [o.cssClasses.valueNormal, o.cssClasses.valueLarge, o.cssClasses.valueSub],
                                h = [o.cssClasses.markerNormal, o.cssClasses.markerLarge, o.cssClasses.markerSub],
                                d = [o.cssClasses.valueHorizontal, o.cssClasses.valueVertical],
                                u = [o.cssClasses.markerHorizontal, o.cssClasses.markerVertical];
                            return (
                                s(r, o.cssClasses.pips),
                                s(r, 0 === o.ort ? o.cssClasses.pipsHorizontal : o.cssClasses.pipsVertical),
                                Object.keys(e).forEach(function (t) {
                                    a(t, e[t]);
                                }),
                                (r.innerHTML = l),
                                r
                            );
                        }
                        function p(e) {
                            var t = e.mode,
                                i = e.density || 1,
                                n = e.filter || !1,
                                o = (function (e, t, i) {
                                    if ("range" === e || "steps" === e) return q.xVal;
                                    if ("count" === e) {
                                        var n,
                                            o = 100 / (t - 1),
                                            s = 0;
                                        for (t = []; (n = s++ * o) <= 100; ) t.push(n);
                                        e = "positions";
                                    }
                                    return "positions" === e
                                        ? t.map(function (e) {
                                              return q.fromStepping(i ? q.getStep(e) : e);
                                          })
                                        : "values" === e
                                        ? i
                                            ? t.map(function (e) {
                                                  return q.fromStepping(q.getStep(q.toStepping(e)));
                                              })
                                            : t
                                        : void 0;
                                })(t, e.values || !1, e.stepped || !1),
                                s = (function (e, t, i) {
                                    function n(e, t) {
                                        return (e + t).toFixed(7) / 1;
                                    }
                                    var o = {},
                                        s = q.xVal[0],
                                        a = q.xVal[q.xVal.length - 1],
                                        r = !1,
                                        l = !1,
                                        c = 0;
                                    return (
                                        (i = (function (e) {
                                            return e.filter(function (e) {
                                                return !this[e] && (this[e] = !0);
                                            }, {});
                                        })(
                                            i.slice().sort(function (e, t) {
                                                return e - t;
                                            })
                                        ))[0] !== s && (i.unshift(s), (r = !0)),
                                        i[i.length - 1] !== a && (i.push(a), (l = !0)),
                                        i.forEach(function (s, a) {
                                            var h,
                                                d,
                                                u,
                                                p,
                                                f,
                                                m,
                                                g,
                                                v,
                                                w,
                                                k = s,
                                                y = i[a + 1];
                                            if (("steps" === t && (h = q.xNumSteps[a]), h || (h = y - k), !1 !== k && void 0 !== y))
                                                for (h = Math.max(h, 1e-7), d = k; d <= y; d = n(d, h)) {
                                                    for (g = (f = (p = q.toStepping(d)) - c) / e, w = f / (v = Math.round(g)), u = 1; u <= v; u += 1) o[(c + u * w).toFixed(5)] = ["x", 0];
                                                    (m = i.indexOf(d) > -1 ? 1 : "steps" === t ? 2 : 0), !a && r && (m = 0), (d === y && l) || (o[p.toFixed(5)] = [d, m]), (c = p);
                                                }
                                        }),
                                        o
                                    );
                                })(i, t, o),
                                a = e.format || { to: Math.round };
                            return R.appendChild(u(s, n, a));
                        }
                        function f() {
                            var e = U.getBoundingClientRect(),
                                t = "offset" + ["Width", "Height"][o.ort];
                            return 0 === o.ort ? e.width || U[t] : e.height || U[t];
                        }
                        function m(e, t, i, n) {
                            var s = function (t) {
                                    return (
                                        !R.hasAttribute("disabled") &&
                                        !(function (e, t) {
                                            return e.classList ? e.classList.contains(t) : new RegExp("\\b" + t + "\\b").test(e.className);
                                        })(R, o.cssClasses.tap) &&
                                        ((t = (function (e, t) {
                                            e.preventDefault();
                                            var i,
                                                n,
                                                o = 0 === e.type.indexOf("touch"),
                                                s = 0 === e.type.indexOf("mouse"),
                                                a = 0 === e.type.indexOf("pointer"),
                                                l = e;
                                            if ((0 === e.type.indexOf("MSPointer") && (a = !0), o)) {
                                                if (l.touches.length > 1) return !1;
                                                (i = e.changedTouches[0].pageX), (n = e.changedTouches[0].pageY);
                                            }
                                            return (t = t || r()), (s || a) && ((i = e.clientX + t.x), (n = e.clientY + t.y)), (l.pageOffset = t), (l.points = [i, n]), (l.cursor = s || a), l;
                                        })(t, n.pageOffset)),
                                        !(e === B.start && void 0 !== t.buttons && t.buttons > 1) && (!n.hover || !t.buttons) && ((t.calcPoint = t.points[o.ort]), void i(t, n)))
                                    );
                                },
                                a = [];
                            return (
                                e.split(" ").forEach(function (e) {
                                    t.addEventListener(e, s, !1), a.push([e, s]);
                                }),
                                a
                            );
                        }
                        function g(e) {
                            var t =
                                (100 *
                                    (e -
                                        (function (e, t) {
                                            var i = e.getBoundingClientRect(),
                                                n = e.ownerDocument.documentElement,
                                                o = r();
                                            return /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (o.x = 0), t ? i.top + o.y - n.clientTop : i.left + o.x - n.clientLeft;
                                        })(U, o.ort))) /
                                f();
                            return o.dir ? 100 - t : t;
                        }
                        function v(e, t, i, n) {
                            var o = i.slice(),
                                s = [!e, e],
                                a = [e, !e];
                            (n = n.slice()),
                                e && n.reverse(),
                                n.length > 1
                                    ? n.forEach(function (e, i) {
                                          var n = x(o, e, o[e] + t, s[i], a[i]);
                                          !1 === n ? (t = 0) : ((t = n - o[e]), (o[e] = n));
                                      })
                                    : (s = a = [!0]);
                            var r = !1;
                            n.forEach(function (e, n) {
                                r = I(e, i[e] + t, s[n], a[n]) || r;
                            }),
                                r &&
                                    n.forEach(function (e) {
                                        w("update", e), w("slide", e);
                                    });
                        }
                        function w(e, t, i) {
                            Object.keys(V).forEach(function (n) {
                                var s = n.split(".")[0];
                                e === s &&
                                    V[n].forEach(function (e) {
                                        e.call($, F.map(o.format.to), t, F.slice(), i || !1, D.slice());
                                    });
                            });
                        }
                        function k(e, t) {
                            "mouseout" === e.type && "HTML" === e.target.nodeName && null === e.relatedTarget && b(e, t);
                        }
                        function y(e, t) {
                            if (-1 === navigator.appVersion.indexOf("MSIE 9") && 0 === e.buttons && 0 !== t.buttonsProperty) return b(e, t);
                            var i = (o.dir ? -1 : 1) * (e.calcPoint - t.startCalcPoint);
                            v(i > 0, (100 * i) / t.baseSize, t.locations, t.handleNumbers);
                        }
                        function b(e, t) {
                            var i = U.querySelector("." + o.cssClasses.active);
                            null !== i && a(i, o.cssClasses.active),
                                e.cursor && ((document.body.style.cursor = ""), document.body.removeEventListener("selectstart", document.body.noUiListener)),
                                document.documentElement.noUiListeners.forEach(function (e) {
                                    document.documentElement.removeEventListener(e[0], e[1]);
                                }),
                                a(R, o.cssClasses.drag),
                                H(),
                                t.handleNumbers.forEach(function (e) {
                                    w("set", e), w("change", e), w("end", e);
                                });
                        }
                        function S(e, t) {
                            if (1 === t.handleNumbers.length) {
                                var i = M[t.handleNumbers[0]];
                                if (i.hasAttribute("disabled")) return !1;
                                s(i.children[0], o.cssClasses.active);
                            }
                            e.preventDefault(), e.stopPropagation();
                            var n = m(B.move, document.documentElement, y, { startCalcPoint: e.calcPoint, baseSize: f(), pageOffset: e.pageOffset, handleNumbers: t.handleNumbers, buttonsProperty: e.buttons, locations: D.slice() }),
                                a = m(B.end, document.documentElement, b, { handleNumbers: t.handleNumbers }),
                                r = m("mouseout", document.documentElement, k, { handleNumbers: t.handleNumbers });
                            if (((document.documentElement.noUiListeners = n.concat(a, r)), e.cursor)) {
                                (document.body.style.cursor = getComputedStyle(e.target).cursor), M.length > 1 && s(R, o.cssClasses.drag);
                                var l = function () {
                                    return !1;
                                };
                                (document.body.noUiListener = l), document.body.addEventListener("selectstart", l, !1);
                            }
                            t.handleNumbers.forEach(function (e) {
                                w("start", e);
                            });
                        }
                        function C(e) {
                            e.stopPropagation();
                            var t = g(e.calcPoint),
                                n = (function (e) {
                                    var t = 100,
                                        i = !1;
                                    return (
                                        M.forEach(function (n, o) {
                                            if (!n.hasAttribute("disabled")) {
                                                var s = Math.abs(D[o] - e);
                                                s < t && ((i = o), (t = s));
                                            }
                                        }),
                                        i
                                    );
                                })(t);
                            return (
                                !1 !== n &&
                                (o.events.snap || i(R, o.cssClasses.tap, o.animationDuration),
                                I(n, t, !0, !0),
                                H(),
                                w("slide", n, !0),
                                w("set", n, !0),
                                w("change", n, !0),
                                w("update", n, !0),
                                void (o.events.snap && S(e, { handleNumbers: [n] })))
                            );
                        }
                        function _(e) {
                            var t = g(e.calcPoint),
                                i = q.getStep(t),
                                n = q.fromStepping(i);
                            Object.keys(V).forEach(function (e) {
                                "hover" === e.split(".")[0] &&
                                    V[e].forEach(function (e) {
                                        e.call($, n);
                                    });
                            });
                        }
                        function x(e, t, i, n, s) {
                            return (
                                M.length > 1 && (n && t > 0 && (i = Math.max(i, e[t - 1] + o.margin)), s && t < M.length - 1 && (i = Math.min(i, e[t + 1] - o.margin))),
                                M.length > 1 && o.limit && (n && t > 0 && (i = Math.min(i, e[t - 1] + o.limit)), s && t < M.length - 1 && (i = Math.max(i, e[t + 1] - o.limit))),
                                (i = (function (e) {
                                    return Math.max(Math.min(e, 100), 0);
                                })((i = q.getStep(i)))) !== e[t] && i
                            );
                        }
                        function T(e) {
                            return e + "%";
                        }
                        function H() {
                            z.forEach(function (e) {
                                var t = D[e] > 50 ? -1 : 1,
                                    i = 3 + (M.length + t * e);
                                M[e].childNodes[0].style.zIndex = i;
                            });
                        }
                        function I(e, t, i, n) {
                            return (
                                !1 !== (t = x(D, e, t, i, n)) &&
                                ((function (e, t) {
                                    (D[e] = t), (F[e] = q.fromStepping(t));
                                    var i = function () {
                                        (M[e].style[o.style] = T(t)), P(e), P(e + 1);
                                    };
                                    window.requestAnimationFrame && o.useRequestAnimationFrame ? window.requestAnimationFrame(i) : i();
                                })(e, t),
                                !0)
                            );
                        }
                        function P(e) {
                            if (j[e]) {
                                var t = 0,
                                    i = 100;
                                0 !== e && (t = D[e - 1]), e !== j.length - 1 && (i = D[e]), (j[e].style[o.style] = T(t)), (j[e].style[o.styleOposite] = T(100 - i));
                            }
                        }
                        function E(e, t) {
                            null !== e && !1 !== e && ("number" == typeof e && (e = String(e)), !1 === (e = o.format.from(e)) || isNaN(e) || I(t, q.toStepping(e), !1, !1));
                        }
                        function O(e, t) {
                            var s = n(e),
                                a = void 0 === D[0];
                            (t = void 0 === t || !!t),
                                s.forEach(E),
                                o.animate && !a && i(R, o.cssClasses.tap, o.animationDuration),
                                z.forEach(function (e) {
                                    I(e, D[e], !0, !1);
                                }),
                                H(),
                                z.forEach(function (e) {
                                    w("update", e), null !== s[e] && t && w("set", e);
                                });
                        }
                        function A() {
                            var e = F.map(o.format.to);
                            return 1 === e.length ? e[0] : e;
                        }
                        function N(e, t) {
                            (V[e] = V[e] || []),
                                V[e].push(t),
                                "update" === e.split(".")[0] &&
                                    M.forEach(function (e, t) {
                                        w("update", t);
                                    });
                        }
                        var U,
                            M,
                            j,
                            $,
                            B = window.navigator.pointerEnabled
                                ? { start: "pointerdown", move: "pointermove", end: "pointerup" }
                                : window.navigator.msPointerEnabled
                                ? { start: "MSPointerDown", move: "MSPointerMove", end: "MSPointerUp" }
                                : { start: "mousedown touchstart", move: "mousemove touchmove", end: "mouseup touchend" },
                            R = t,
                            D = [],
                            z = [],
                            q = o.spectrum,
                            F = [],
                            V = {};
                        if (R.noUiSlider) throw new Error("Slider was already initialized.");
                        return (
                            (function (t) {
                                s(t, o.cssClasses.target), 0 === o.dir ? s(t, o.cssClasses.ltr) : s(t, o.cssClasses.rtl), 0 === o.ort ? s(t, o.cssClasses.horizontal) : s(t, o.cssClasses.vertical), (U = e(t, o.cssClasses.base));
                            })(R),
                            (function (e, t) {
                                (M = []), (j = []).push(h(t, e[0]));
                                for (var i = 0; i < o.handles; i++) M.push(c(t, i)), (z[i] = i), j.push(h(t, e[i + 1]));
                            })(o.connect, U),
                            ($ = {
                                destroy: function () {
                                    for (var e in o.cssClasses) o.cssClasses.hasOwnProperty(e) && a(R, o.cssClasses[e]);
                                    for (; R.firstChild; ) R.removeChild(R.firstChild);
                                    delete R.noUiSlider;
                                },
                                steps: function () {
                                    return D.map(function (e, t) {
                                        var i = q.getNearbySteps(e),
                                            n = F[t],
                                            o = i.thisStep.step,
                                            s = null;
                                        !1 !== o && n + o > i.stepAfter.startValue && (o = i.stepAfter.startValue - n),
                                            (s = n > i.thisStep.startValue ? i.thisStep.step : !1 !== i.stepBefore.step && n - i.stepBefore.highestStep),
                                            100 === e ? (o = null) : 0 === e && (s = null);
                                        var a = q.countStepDecimals();
                                        return null !== o && !1 !== o && (o = Number(o.toFixed(a))), null !== s && !1 !== s && (s = Number(s.toFixed(a))), [s, o];
                                    });
                                },
                                on: N,
                                off: function (e) {
                                    var t = e && e.split(".")[0],
                                        i = t && e.substring(t.length);
                                    Object.keys(V).forEach(function (e) {
                                        var n = e.split(".")[0],
                                            o = e.substring(n.length);
                                        (t && t !== n) || (i && i !== o) || delete V[e];
                                    });
                                },
                                get: A,
                                set: O,
                                reset: function (e) {
                                    O(o.start, e);
                                },
                                __moveHandles: function (e, t, i) {
                                    v(e, t, D, i);
                                },
                                options: l,
                                updateOptions: function (e, t) {
                                    var i = A(),
                                        n = ["margin", "limit", "range", "animate", "snap", "step", "format"];
                                    n.forEach(function (t) {
                                        void 0 !== e[t] && (l[t] = e[t]);
                                    });
                                    var s = L(l);
                                    n.forEach(function (t) {
                                        void 0 !== e[t] && (o[t] = s[t]);
                                    }),
                                        (s.spectrum.direction = q.direction),
                                        (q = s.spectrum),
                                        (o.margin = s.margin),
                                        (o.limit = s.limit),
                                        (D = []),
                                        O(e.start || i, t);
                                },
                                target: R,
                                pips: p,
                            }),
                            (function (e) {
                                e.fixed ||
                                    M.forEach(function (e, t) {
                                        m(B.start, e.children[0], S, { handleNumbers: [t] });
                                    }),
                                    e.tap && m(B.start, U, C, {}),
                                    e.hover && m(B.move, U, _, { hover: !0 }),
                                    e.drag &&
                                        j.forEach(function (t, i) {
                                            if (!1 !== t && 0 !== i && i !== j.length - 1) {
                                                var n = M[i - 1],
                                                    a = M[i],
                                                    r = [t];
                                                s(t, o.cssClasses.draggable),
                                                    e.fixed && (r.push(n.children[0]), r.push(a.children[0])),
                                                    r.forEach(function (e) {
                                                        m(B.start, e, S, { handles: [n, a], handleNumbers: [i - 1, i] });
                                                    });
                                            }
                                        });
                            })(o.events),
                            O(o.start),
                            o.pips && p(o.pips),
                            o.tooltips &&
                                (function () {
                                    var e = M.map(d);
                                    N("update", function (t, i, n) {
                                        if (e[i]) {
                                            var s = t[i];
                                            !0 !== o.tooltips[i] && (s = o.tooltips[i].to(n[i])), (e[i].innerHTML = s);
                                        }
                                    });
                                })(),
                            $
                        );
                    }
                    (m.prototype.getMargin = function (e) {
                        var t = this.xNumSteps[0];
                        if (t && e % t) throw new Error("noUiSlider: 'limit' and 'margin' must be divisible by step.");
                        return 2 === this.xPct.length && c(this.xVal, e);
                    }),
                        (m.prototype.toStepping = function (e) {
                            return d(this.xVal, this.xPct, e);
                        }),
                        (m.prototype.fromStepping = function (e) {
                            return (function (e, t, i) {
                                if (i >= 100) return e.slice(-1)[0];
                                var n,
                                    o = h(i, t);
                                return (function (e, t) {
                                    return (t * (e[1] - e[0])) / 100 + e[0];
                                })([e[o - 1], e[o]], (i - (n = t[o - 1])) * l(n, t[o]));
                            })(this.xVal, this.xPct, e);
                        }),
                        (m.prototype.getStep = function (e) {
                            return u(this.xPct, this.xSteps, this.snap, e);
                        }),
                        (m.prototype.getNearbySteps = function (e) {
                            var t = h(e, this.xPct);
                            return {
                                stepBefore: { startValue: this.xVal[t - 2], step: this.xNumSteps[t - 2], highestStep: this.xHighestCompleteStep[t - 2] },
                                thisStep: { startValue: this.xVal[t - 1], step: this.xNumSteps[t - 1], highestStep: this.xHighestCompleteStep[t - 1] },
                                stepAfter: { startValue: this.xVal[t - 0], step: this.xNumSteps[t - 0], highestStep: this.xHighestCompleteStep[t - 0] },
                            };
                        }),
                        (m.prototype.countStepDecimals = function () {
                            var e = this.xNumSteps.map(o);
                            return Math.max.apply(null, e);
                        }),
                        (m.prototype.convert = function (e) {
                            return this.getStep(this.toStepping(e));
                        });
                    var U = {
                        to: function (e) {
                            return void 0 !== e && e.toFixed(2);
                        },
                        from: Number,
                    };
                    return {
                        create: function (e, t) {
                            if (!e.nodeName) throw new Error("noUiSlider.create requires a single element.");
                            var i = N(e, L(t), t);
                            return (e.noUiSlider = i), i;
                        },
                    };
                }),
                "function" == typeof a && a.amd ? a([], o) : "object" == typeof exports ? (module.exports = o()) : (window.noUiSlider = o())),
            1 == HawkSearch.loadPlugins.wNumb &&
                (function () {
                    "use strict";
                    function e(e) {
                        return e.split("").reverse().join("");
                    }
                    function t(e, t) {
                        return e.substring(0, t.length) === t;
                    }
                    function i(e, t, i) {
                        if ((e[t] || e[i]) && e[t] === e[i]) throw new Error(t);
                    }
                    function n(e) {
                        return "number" == typeof e && isFinite(e);
                    }
                    function o(t, i, o, s, a, r, l, c, h, d, u, p) {
                        var f,
                            m,
                            g,
                            v = p,
                            w = "",
                            k = "";
                        return (
                            r && (p = r(p)),
                            !!n(p) &&
                                (!1 !== t && 0 === parseFloat(p.toFixed(t)) && (p = 0),
                                p < 0 && ((f = !0), (p = Math.abs(p))),
                                !1 !== t &&
                                    (p = (function (e, t) {
                                        var i = Math.pow(10, t);
                                        return (Math.round(e * i) / i).toFixed(t);
                                    })(p, t)),
                                -1 !== (p = p.toString()).indexOf(".") ? ((g = (m = p.split("."))[0]), o && (w = o + m[1])) : (g = p),
                                i && ((g = e(g).match(/.{1,3}/g)), (g = e(g.join(e(i))))),
                                f && c && (k += c),
                                s && (k += s),
                                f && h && (k += h),
                                (k += g),
                                (k += w),
                                a && (k += a),
                                d && (k = d(k, v)),
                                k)
                        );
                    }
                    function s(e, i, o, s, a, r, l, c, h, d, u, p) {
                        var f,
                            m = "";
                        return (
                            u && (p = u(p)),
                            !(!p || "string" != typeof p) &&
                                (c && t(p, c) && ((p = p.replace(c, "")), (f = !0)),
                                s && t(p, s) && (p = p.replace(s, "")),
                                h && t(p, h) && ((p = p.replace(h, "")), (f = !0)),
                                a &&
                                    (function (e, t) {
                                        return e.slice(-1 * t.length) === t;
                                    })(p, a) &&
                                    (p = p.slice(0, -1 * a.length)),
                                i && (p = p.split(i).join("")),
                                o && (p = p.replace(o, ".")),
                                f && (m += "-"),
                                "" !== (m = (m += p).replace(/[^0-9\.\-.]/g, "")) && ((m = Number(m)), l && (m = l(m)), !!n(m) && m))
                        );
                    }
                    function a(e) {
                        var t,
                            n,
                            o,
                            s = {};
                        for (t = 0; t < l.length; t += 1)
                            if (void 0 === (o = e[(n = l[t])])) "negative" !== n || s.negativeBefore ? ("mark" === n && "." !== s.thousand ? (s[n] = ".") : (s[n] = !1)) : (s[n] = "-");
                            else if ("decimals" === n) {
                                if (!(o >= 0 && o < 8)) throw new Error(n);
                                s[n] = o;
                            } else if ("encoder" === n || "decoder" === n || "edit" === n || "undo" === n) {
                                if ("function" != typeof o) throw new Error(n);
                                s[n] = o;
                            } else {
                                if ("string" != typeof o) throw new Error(n);
                                s[n] = o;
                            }
                        return i(s, "mark", "thousand"), i(s, "prefix", "negative"), i(s, "prefix", "negativeBefore"), s;
                    }
                    function r(e, t, i) {
                        var n,
                            o = [];
                        for (n = 0; n < l.length; n += 1) o.push(e[l[n]]);
                        return o.push(i), t.apply("", o);
                    }
                    var l = ["decimals", "thousand", "mark", "prefix", "postfix", "encoder", "decoder", "negativeBefore", "negative", "edit", "undo"];
                    window.wNumb = function e(t) {
                        return this instanceof e
                            ? void (
                                  "object" == typeof t &&
                                  ((t = a(t)),
                                  (this.to = function (e) {
                                      return r(t, o, e);
                                  }),
                                  (this.from = function (e) {
                                      return r(t, s, e);
                                  }))
                              )
                            : new e(t);
                    };
                })(),
            1 == HawkSearch.loadPlugins.blockUI &&
                (function () {
                    function e(e) {
                        function t(t, n) {
                            var s,
                                p,
                                f = t == window,
                                m = n && void 0 !== n.message ? n.message : void 0;
                            if (!(n = e.extend({}, e.blockUI.defaults, n || {})).ignoreIfBlocked || !e(t).data("blockUI.isBlocked")) {
                                if (
                                    ((n.overlayCSS = e.extend({}, e.blockUI.defaults.overlayCSS, n.overlayCSS || {})),
                                    (s = e.extend({}, e.blockUI.defaults.css, n.css || {})),
                                    n.onOverlayClick && (n.overlayCSS.cursor = "pointer"),
                                    (p = e.extend({}, e.blockUI.defaults.themedCSS, n.themedCSS || {})),
                                    (m = void 0 === m ? n.message : m),
                                    f && d && i(window, { fadeOut: 0 }),
                                    m && "string" != typeof m && (m.parentNode || m.jquery))
                                ) {
                                    var g = m.jquery ? m[0] : m,
                                        v = {};
                                    e(t).data("blockUI.history", v), (v.el = g), (v.parent = g.parentNode), (v.display = g.style.display), (v.position = g.style.position), v.parent && v.parent.removeChild(g);
                                }
                                e(t).data("blockUI.onUnblock", n.onUnblock);
                                var w;
                                v = n.baseZ;
                                (w =
                                    l || n.forceIframe
                                        ? e('<iframe class="blockUI" style="z-index:' + v++ + ';display:none;border:none;margin:0;padding:0;position:absolute;width:100%;height:100%;top:0;left:0" src="' + n.iframeSrc + '"></iframe>')
                                        : e('<div class="blockUI" style="display:none"></div>')),
                                    (g = n.theme
                                        ? e('<div class="blockUI blockOverlay ui-widget-overlay" style="z-index:' + v++ + ';display:none"></div>')
                                        : e('<div class="blockUI blockOverlay" style="z-index:' + v++ + ';display:none;border:none;margin:0;padding:0;width:100%;height:100%;top:0;left:0"></div>')),
                                    n.theme && f
                                        ? ((v = '<div class="blockUI ' + n.blockMsgClass + ' blockPage ui-dialog ui-widget ui-corner-all" style="z-index:' + (v + 10) + ';display:none;position:fixed">'),
                                          n.title && (v += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">' + (n.title || "&nbsp;") + "</div>"),
                                          (v += '<div class="ui-widget-content ui-dialog-content"></div></div>'))
                                        : n.theme
                                        ? ((v = '<div class="blockUI ' + n.blockMsgClass + ' blockElement ui-dialog ui-widget ui-corner-all" style="z-index:' + (v + 10) + ';display:none;position:absolute">'),
                                          n.title && (v += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">' + (n.title || "&nbsp;") + "</div>"),
                                          (v += '<div class="ui-widget-content ui-dialog-content"></div>'),
                                          (v += "</div>"))
                                        : (v = f
                                              ? '<div class="blockUI ' + n.blockMsgClass + ' blockPage" style="z-index:' + (v + 10) + ';display:none;position:fixed"></div>'
                                              : '<div class="blockUI ' + n.blockMsgClass + ' blockElement" style="z-index:' + (v + 10) + ';display:none;position:absolute"></div>'),
                                    (v = e(v)),
                                    m && (n.theme ? (v.css(p), v.addClass("ui-widget-content")) : v.css(s)),
                                    n.theme || g.css(n.overlayCSS),
                                    g.css("position", f ? "fixed" : "absolute"),
                                    (l || n.forceIframe) && w.css("opacity", 0),
                                    (s = [w, g, v]);
                                var k = e(f ? "body" : t);
                                if (
                                    (e.each(s, function () {
                                        this.appendTo(k);
                                    }),
                                    n.theme && n.draggable && e.fn.draggable && v.draggable({ handle: ".ui-dialog-titlebar", cancel: "li" }),
                                    (p = h && (!e.support.boxModel || 0 < e("object,embed", f ? null : t).length)),
                                    c || p)
                                ) {
                                    if ((f && n.allowBodyStretch && e.support.boxModel && e("html,body").css("height", "100%"), (c || !e.support.boxModel) && !f)) {
                                        p = parseInt(e.css(t, "borderTopWidth"), 10) || 0;
                                        var y = parseInt(e.css(t, "borderLeftWidth"), 10) || 0,
                                            b = p ? "(0 - " + p + ")" : 0,
                                            S = y ? "(0 - " + y + ")" : 0;
                                    }
                                    e.each(s, function (e, t) {
                                        var i = t[0].style;
                                        if (((i.position = "absolute"), 2 > e))
                                            f
                                                ? i.setExpression("height", "Math.max(document.body.scrollHeight, document.body.offsetHeight) - (jQuery.support.boxModel?0:" + n.quirksmodeOffsetHack + ') + "px"')
                                                : i.setExpression("height", 'this.parentNode.offsetHeight + "px"'),
                                                f
                                                    ? i.setExpression("width", 'jQuery.support.boxModel && document.documentElement.clientWidth || document.body.clientWidth + "px"')
                                                    : i.setExpression("width", 'this.parentNode.offsetWidth + "px"'),
                                                S && i.setExpression("left", S),
                                                b && i.setExpression("top", b);
                                        else if (n.centerY)
                                            f &&
                                                i.setExpression(
                                                    "top",
                                                    '(document.documentElement.clientHeight || document.body.clientHeight) / 2 - (this.offsetHeight / 2) + (blah = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + "px"'
                                                ),
                                                (i.marginTop = 0);
                                        else if (!n.centerY && f) {
                                            var o = "((document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + " + (n.css && n.css.top ? parseInt(n.css.top, 10) : 0) + ') + "px"';
                                            i.setExpression("top", o);
                                        }
                                    });
                                }
                                m && (n.theme ? v.find(".ui-widget-content").append(m) : v.append(m), (m.jquery || m.nodeType) && e(m).show()),
                                    (l || n.forceIframe) && n.showOverlay && w.show(),
                                    n.fadeIn
                                        ? ((s = n.onBlock ? n.onBlock : r), (w = n.showOverlay && !m ? s : r), (s = m ? s : r), n.showOverlay && g._fadeIn(n.fadeIn, w), m && v._fadeIn(n.fadeIn, s))
                                        : (n.showOverlay && g.show(), m && v.show(), n.onBlock && n.onBlock()),
                                    o(1, t, n),
                                    f
                                        ? ((d = v[0]), (u = e(n.focusableElements, d)), n.focusInput && setTimeout(a, 20))
                                        : (function (t, i, n) {
                                              var o = t.parentNode,
                                                  s = t.style,
                                                  a = (o.offsetWidth - t.offsetWidth) / 2 - (parseInt(e.css(o, "borderLeftWidth"), 10) || 0);
                                              (t = (o.offsetHeight - t.offsetHeight) / 2 - (parseInt(e.css(o, "borderTopWidth"), 10) || 0)), i && (s.left = 0 < a ? a + "px" : "0"), n && (s.top = 0 < t ? t + "px" : "0");
                                          })(v[0], n.centerX, n.centerY),
                                    n.timeout &&
                                        ((m = setTimeout(function () {
                                            f ? e.unblockUI(n) : e(t).unblock(n);
                                        }, n.timeout)),
                                        e(t).data("blockUI.timeout", m));
                            }
                        }
                        function i(t, i) {
                            var s,
                                a,
                                r = t == window,
                                l = e(t),
                                c = l.data("blockUI.history"),
                                h = l.data("blockUI.timeout");
                            h && (clearTimeout(h), l.removeData("blockUI.timeout")),
                                (i = e.extend({}, e.blockUI.defaults, i || {})),
                                o(0, t, i),
                                null === i.onUnblock && ((i.onUnblock = l.data("blockUI.onUnblock")), l.removeData("blockUI.onUnblock")),
                                (a = r ? e("body").children().filter(".blockUI").add("body > .blockUI") : l.find(">.blockUI")),
                                i.cursorReset && (1 < a.length && (a[1].style.cursor = i.cursorReset), 2 < a.length && (a[2].style.cursor = i.cursorReset)),
                                r && (d = u = null),
                                i.fadeOut
                                    ? ((s = a.length),
                                      a.stop().fadeOut(i.fadeOut, function () {
                                          0 == --s && n(a, c, i, t);
                                      }))
                                    : n(a, c, i, t);
                        }
                        function n(t, i, n, o) {
                            var s = e(o);
                            s.data("blockUI.isBlocked") ||
                                (t.each(function (e, t) {
                                    this.parentNode && this.parentNode.removeChild(this);
                                }),
                                i && i.el && ((i.el.style.display = i.display), (i.el.style.position = i.position), i.parent && i.parent.appendChild(i.el), s.removeData("blockUI.history")),
                                s.data("blockUI.static") && s.css("position", "static"),
                                "function" == typeof n.onUnblock && n.onUnblock(o, n),
                                (i = (t = e(document.body)).width()),
                                (n = t[0].style.width),
                                t.width(i - 1).width(i),
                                (t[0].style.width = n));
                        }
                        function o(t, i, n) {
                            var o = i == window;
                            (i = e(i)),
                                (t || ((!o || d) && (o || i.data("blockUI.isBlocked")))) &&
                                    (i.data("blockUI.isBlocked", t),
                                    o &&
                                        n.bindEvents &&
                                        (!t || n.showOverlay) &&
                                        (t
                                            ? e(document).bind("mousedown mouseup keydown keypress keyup touchstart touchend touchmove", n, s)
                                            : e(document).unbind("mousedown mouseup keydown keypress keyup touchstart touchend touchmove", s)));
                        }
                        function s(t) {
                            if ("keydown" === t.type && t.keyCode && 9 == t.keyCode && d && t.data.constrainTabKey) {
                                var i = u,
                                    n = t.shiftKey && t.target === i[0];
                                if ((!t.shiftKey && t.target === i[i.length - 1]) || n)
                                    return (
                                        setTimeout(function () {
                                            a(n);
                                        }, 10),
                                        !1
                                    );
                            }
                            i = t.data;
                            var o = e(t.target);
                            return o.hasClass("blockOverlay") && i.onOverlayClick && i.onOverlayClick(t), 0 < o.parents("div." + i.blockMsgClass).length || 0 === o.parents().children().filter("div.blockUI").length;
                        }
                        function a(e) {
                            u && (e = u[!0 === e ? u.length - 1 : 0]) && e.focus();
                        }
                        e.fn._fadeIn = e.fn.fadeIn;
                        var r = e.noop || function () {},
                            l = /MSIE/.test(navigator.userAgent),
                            c = /MSIE 6.0/.test(navigator.userAgent) && !/MSIE 8.0/.test(navigator.userAgent),
                            h = e.isFunction(document.createElement("div").style.setExpression);
                        (e.blockUI = function (e) {
                            t(window, e);
                        }),
                            (e.unblockUI = function (e) {
                                i(window, e);
                            }),
                            (e.growlUI = function (t, i, n, o) {
                                var s = e('<div class="growlUI"></div>');
                                t && s.append("<h1>" + t + "</h1>"), i && s.append("<h2>" + i + "</h2>"), void 0 === n && (n = 3e3);
                                var a = function (t) {
                                    (t = t || {}),
                                        e.blockUI({
                                            message: s,
                                            fadeIn: void 0 !== t.fadeIn ? t.fadeIn : 700,
                                            fadeOut: void 0 !== t.fadeOut ? t.fadeOut : 1e3,
                                            timeout: void 0 !== t.timeout ? t.timeout : n,
                                            centerY: !1,
                                            showOverlay: !1,
                                            onUnblock: o,
                                            css: e.blockUI.defaults.growlCSS,
                                        });
                                };
                                a(),
                                    s.css("opacity"),
                                    s
                                        .mouseover(function () {
                                            a({ fadeIn: 0, timeout: 3e4 });
                                            var t = e(".blockMsg");
                                            t.stop(), t.fadeTo(300, 1);
                                        })
                                        .mouseout(function () {
                                            e(".blockMsg").fadeOut(1e3);
                                        });
                            }),
                            (e.fn.block = function (i) {
                                if (this[0] === window) return e.blockUI(i), this;
                                var n = e.extend({}, e.blockUI.defaults, i || {});
                                return (
                                    this.each(function () {
                                        var t = e(this);
                                        (n.ignoreIfBlocked && t.data("blockUI.isBlocked")) || t.unblock({ fadeOut: 0 });
                                    }),
                                    this.each(function () {
                                        "static" == e.css(this, "position") && ((this.style.position = "relative"), e(this).data("blockUI.static", !0)), (this.style.zoom = 1), t(this, i);
                                    })
                                );
                            }),
                            (e.fn.unblock = function (t) {
                                return this[0] === window
                                    ? (e.unblockUI(t), this)
                                    : this.each(function () {
                                          i(this, t);
                                      });
                            }),
                            (e.blockUI.version = 2.66),
                            (e.blockUI.defaults = {
                                message: "<h1>Please wait...</h1>",
                                title: null,
                                draggable: !0,
                                theme: !1,
                                css: { padding: 0, margin: 0, width: "30%", top: "40%", left: "35%", textAlign: "center", color: "#000", border: "3px solid #aaa", backgroundColor: "#fff", cursor: "wait" },
                                themedCSS: { width: "30%", top: "40%", left: "35%" },
                                overlayCSS: { backgroundColor: "#000", opacity: 0.6, cursor: "wait" },
                                cursorReset: "default",
                                growlCSS: {
                                    width: "350px",
                                    top: "10px",
                                    left: "",
                                    right: "10px",
                                    border: "none",
                                    padding: "5px",
                                    opacity: 0.6,
                                    cursor: "default",
                                    color: "#fff",
                                    backgroundColor: "#000",
                                    "-webkit-border-radius": "10px",
                                    "-moz-border-radius": "10px",
                                    "border-radius": "10px",
                                },
                                iframeSrc: /^https/i.test(window.location.href || "") ? "javascript:false" : "about:blank",
                                forceIframe: !1,
                                baseZ: 1e3,
                                centerX: !0,
                                centerY: !0,
                                allowBodyStretch: !0,
                                bindEvents: !0,
                                constrainTabKey: !0,
                                fadeIn: 200,
                                fadeOut: 400,
                                timeout: 0,
                                showOverlay: !0,
                                focusInput: !0,
                                focusableElements: ":input:enabled:visible",
                                onBlock: null,
                                onUnblock: null,
                                onOverlayClick: null,
                                quirksmodeOffsetHack: 4,
                                blockMsgClass: "blockMsg",
                                ignoreIfBlocked: !1,
                            });
                        var d = null,
                            u = [];
                    }
                    "function" == typeof a && a.amd && a.amd.jQuery ? a(["jquery"], e) : e(jQuery);
                })(),
            1 == HawkSearch.loadPlugins.matchHeights &&
                ((s = jQuery).fn.matchHeights = function (e) {
                    var t = (e = jQuery.extend(this, { minHeight: null, maxHeight: null, extension: 0, overflow: null, includeMargin: !1 }, e)).extension,
                        i = e.minHeight ? e.minHeight : 0;
                    return (
                        this.each(function () {
                            i = Math.max(i, s(this).outerHeight());
                        }),
                        e.maxHeight && i > e.maxHeight && (i = e.maxHeight),
                        this.each(function () {
                            var n = s(this),
                                o = n.innerHeight() - n.height() + (n.outerHeight(e.includeMargin) - n.innerHeight());
                            e.overflow ? n.css({ height: i - o + t, overflow: e.overflow }) : n.css({ "min-height": i - o + t });
                        })
                    );
                }),
            1 == HawkSearch.loadPlugins.imagesLoaded &&
                ((function (e, t) {
                    "function" == typeof a && a.amd ? a("ev-emitter/ev-emitter", t) : "object" == typeof module && module.exports ? (module.exports = t()) : (e.EvEmitter = t());
                })("undefined" != typeof window ? window : this, function () {
                    function e() {}
                    var t = e.prototype;
                    return (
                        (t.on = function (e, t) {
                            if (e && t) {
                                var i = (this._events = this._events || {}),
                                    n = (i[e] = i[e] || []);
                                return -1 == n.indexOf(t) && n.push(t), this;
                            }
                        }),
                        (t.once = function (e, t) {
                            if (e && t) {
                                this.on(e, t);
                                var i = (this._onceEvents = this._onceEvents || {});
                                return ((i[e] = i[e] || {})[t] = !0), this;
                            }
                        }),
                        (t.off = function (e, t) {
                            var i = this._events && this._events[e];
                            if (i && i.length) {
                                var n = i.indexOf(t);
                                return -1 != n && i.splice(n, 1), this;
                            }
                        }),
                        (t.emitEvent = function (e, t) {
                            var i = this._events && this._events[e];
                            if (i && i.length) {
                                var n = 0,
                                    o = i[n];
                                t = t || [];
                                for (var s = this._onceEvents && this._onceEvents[e]; o; ) {
                                    var a = s && s[o];
                                    a && (this.off(e, o), delete s[o]), o.apply(this, t), (o = i[(n += a ? 0 : 1)]);
                                }
                                return this;
                            }
                        }),
                        e
                    );
                }),
                (function (e, t) {
                    "use strict";
                    "function" == typeof a && a.amd
                        ? a(["ev-emitter/ev-emitter"], function (i) {
                              return t(e, i);
                          })
                        : "object" == typeof module && module.exports
                        ? (module.exports = t(e, require("ev-emitter")))
                        : (e.imagesLoaded = t(e, e.EvEmitter));
                })(window, function (e, t) {
                    function i(e, t) {
                        for (var i in t) e[i] = t[i];
                        return e;
                    }
                    function n(e, t, o) {
                        return this instanceof n
                            ? ("string" == typeof e && (e = document.querySelectorAll(e)),
                              (this.elements = (function (e) {
                                  var t = [];
                                  if (Array.isArray(e)) t = e;
                                  else if ("number" == typeof e.length) for (var i = 0; i < e.length; i++) t.push(e[i]);
                                  else t.push(e);
                                  return t;
                              })(e)),
                              (this.options = i({}, this.options)),
                              "function" == typeof t ? (o = t) : i(this.options, t),
                              o && this.on("always", o),
                              this.getImages(),
                              a && (this.jqDeferred = new a.Deferred()),
                              void setTimeout(
                                  function () {
                                      this.check();
                                  }.bind(this)
                              ))
                            : new n(e, t, o);
                    }
                    function o(e) {
                        this.img = e;
                    }
                    function s(e, t) {
                        (this.url = e), (this.element = t), (this.img = new Image());
                    }
                    var a = a,
                        r = e.console;
                    (n.prototype = Object.create(t.prototype)),
                        (n.prototype.options = {}),
                        (n.prototype.getImages = function () {
                            (this.images = []), this.elements.forEach(this.addElementImages, this);
                        }),
                        (n.prototype.addElementImages = function (e) {
                            "IMG" == e.nodeName && this.addImage(e), !0 === this.options.background && this.addElementBackgroundImages(e);
                            var t = e.nodeType;
                            if (t && l[t]) {
                                for (var i = e.querySelectorAll("img"), n = 0; n < i.length; n++) {
                                    var o = i[n];
                                    this.addImage(o);
                                }
                                if ("string" == typeof this.options.background) {
                                    var s = e.querySelectorAll(this.options.background);
                                    for (n = 0; n < s.length; n++) {
                                        var a = s[n];
                                        this.addElementBackgroundImages(a);
                                    }
                                }
                            }
                        });
                    var l = { 1: !0, 9: !0, 11: !0 };
                    return (
                        (n.prototype.addElementBackgroundImages = function (e) {
                            var t = getComputedStyle(e);
                            if (t)
                                for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(t.backgroundImage); null !== n; ) {
                                    var o = n && n[2];
                                    o && this.addBackground(o, e), (n = i.exec(t.backgroundImage));
                                }
                        }),
                        (n.prototype.addImage = function (e) {
                            var t = new o(e);
                            this.images.push(t);
                        }),
                        (n.prototype.addBackground = function (e, t) {
                            var i = new s(e, t);
                            this.images.push(i);
                        }),
                        (n.prototype.check = function () {
                            function e(e, i, n) {
                                setTimeout(function () {
                                    t.progress(e, i, n);
                                });
                            }
                            var t = this;
                            return (
                                (this.progressedCount = 0),
                                (this.hasAnyBroken = !1),
                                this.images.length
                                    ? void this.images.forEach(function (t) {
                                          t.once("progress", e), t.check();
                                      })
                                    : void this.complete()
                            );
                        }),
                        (n.prototype.progress = function (e, t, i) {
                            this.progressedCount++,
                                (this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded),
                                this.emitEvent("progress", [this, e, t]),
                                this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, e),
                                this.progressedCount == this.images.length && this.complete(),
                                this.options.debug && r && r.log("progress: " + i, e, t);
                        }),
                        (n.prototype.complete = function () {
                            var e = this.hasAnyBroken ? "fail" : "done";
                            if (((this.isComplete = !0), this.emitEvent(e, [this]), this.emitEvent("always", [this]), this.jqDeferred)) {
                                var t = this.hasAnyBroken ? "reject" : "resolve";
                                this.jqDeferred[t](this);
                            }
                        }),
                        (o.prototype = Object.create(t.prototype)),
                        (o.prototype.check = function () {
                            return this.getIsImageComplete()
                                ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
                                : ((this.proxyImage = new Image()),
                                  this.proxyImage.addEventListener("load", this),
                                  this.proxyImage.addEventListener("error", this),
                                  this.img.addEventListener("load", this),
                                  this.img.addEventListener("error", this),
                                  void (this.proxyImage.src = this.img.src));
                        }),
                        (o.prototype.getIsImageComplete = function () {
                            return this.img.complete && void 0 !== this.img.naturalWidth;
                        }),
                        (o.prototype.confirm = function (e, t) {
                            (this.isLoaded = e), this.emitEvent("progress", [this, this.img, t]);
                        }),
                        (o.prototype.handleEvent = function (e) {
                            var t = "on" + e.type;
                            this[t] && this[t](e);
                        }),
                        (o.prototype.onload = function () {
                            this.confirm(!0, "onload"), this.unbindEvents();
                        }),
                        (o.prototype.onerror = function () {
                            this.confirm(!1, "onerror"), this.unbindEvents();
                        }),
                        (o.prototype.unbindEvents = function () {
                            this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
                        }),
                        (s.prototype = Object.create(o.prototype)),
                        (s.prototype.check = function () {
                            this.img.addEventListener("load", this),
                                this.img.addEventListener("error", this),
                                (this.img.src = this.url),
                                this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents());
                        }),
                        (s.prototype.unbindEvents = function () {
                            this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
                        }),
                        (s.prototype.confirm = function (e, t) {
                            (this.isLoaded = e), this.emitEvent("progress", [this, this.element, t]);
                        }),
                        (n.makeJQueryPlugin = function (e) {
                            (e = e || a) &&
                                ((a = e).fn.imagesLoaded = function (e, t) {
                                    return new n(this, e, t).jqDeferred.promise(a(this));
                                });
                        }),
                        n.makeJQueryPlugin(),
                        n
                    );
                })),
            1 == HawkSearch.loadPlugins.jQueryCookie &&
                (HawkSearch.jQuery.cookie = function (t, i, n) {
                    if (void 0 === i) {
                        var o = null;
                        if (document.cookie && "" != document.cookie)
                            for (var s = document.cookie.split(";"), a = 0; a < s.length; a++) {
                                var r = e.trim(s[a]);
                                if (r.substring(0, t.length + 1) == t + "=") {
                                    o = decodeURIComponent(r.substring(t.length + 1));
                                    break;
                                }
                            }
                        return o;
                    }
                    (n = n || {}), null === i && ((i = ""), (n.expires = -1));
                    var l,
                        c = "";
                    n.expires &&
                        ("number" == typeof n.expires || n.expires.toUTCString) &&
                        ("number" == typeof n.expires ? (l = new Date()).setTime(l.getTime() + 24 * n.expires * 60 * 60 * 1e3) : (l = n.expires), (c = "; expires=" + l.toUTCString()));
                    var h = n.path ? "; path=" + n.path : "",
                        d = n.domain ? "; domain=" + n.domain : "",
                        u = n.secure ? "; secure" : "";
                    document.cookie = [t, "=", encodeURIComponent(i), c, h, d, u].join("");
                }),
            1 == HawkSearch.loadPlugins.indexOf &&
                (Array.prototype.indexOf ||
                    (Array.prototype.indexOf = function (e) {
                        "use strict";
                        if (null == this) throw new TypeError();
                        var t = Object(this),
                            i = t.length >>> 0;
                        if (0 === i) return -1;
                        var n = 0;
                        if ((arguments.length > 0 && ((n = Number(arguments[1])) != n ? (n = 0) : 0 != n && n != 1 / 0 && n != -1 / 0 && (n = (n > 0 || -1) * Math.floor(Math.abs(n)))), n >= i)) return -1;
                        for (var o = n >= 0 ? n : Math.max(i - Math.abs(n), 0); o < i; o++) if (o in t && t[o] === e) return o;
                        return -1;
                    })),
            1 == HawkSearch.loadPlugins.webUIPopover &&
                (function (e, t, i) {
                    "use strict";
                    !(function (e) {
                        "function" == typeof a && a.amd ? a(["jquery"], e) : "object" == typeof exports ? (module.exports = e(require("jquery"))) : e(HawkSearch.jQuery);
                    })(function (i) {
                        function n(e, t) {
                            return (
                                (this.$element = i(e)),
                                t && (("string" !== i.type(t.delay) && "number" !== i.type(t.delay)) || (t.delay = { show: t.delay, hide: t.delay })),
                                (this.options = i.extend({}, r, t)),
                                (this._defaults = r),
                                (this._name = o),
                                (this._targetclick = !1),
                                this.init(),
                                c.push(this.$element),
                                this
                            );
                        }
                        var o = "webuiPopover",
                            s = "webui-popover",
                            a = "webui.popover",
                            r = {
                                placement: "auto",
                                container: null,
                                width: "auto",
                                height: "auto",
                                trigger: "click",
                                style: "",
                                selector: !1,
                                delay: { show: null, hide: 300 },
                                async: { type: "GET", before: null, success: null, error: null },
                                cache: !0,
                                multi: !1,
                                arrow: !0,
                                title: "",
                                content: "",
                                closeable: !1,
                                padding: !0,
                                url: "",
                                type: "html",
                                direction: "",
                                animation: null,
                                template:
                                    '<div class="webui-popover"><div class="webui-arrow"></div><div class="webui-popover-inner"><a href="#" class="close"></a><h3 class="webui-popover-title"></h3><div class="webui-popover-content"><i class="icon-refresh"></i> <p>&nbsp;</p></div></div></div>',
                                backdrop: !1,
                                dismissible: !0,
                                onShow: null,
                                onHide: null,
                                abortXHR: !0,
                                autoHide: !1,
                                offsetTop: 0,
                                offsetLeft: 0,
                                iframeOptions: { frameborder: "0", allowtransparency: "true", id: "", name: "", scrolling: "", onload: "", height: "", width: "" },
                                hideEmpty: !1,
                            },
                            l = s + "-rtl",
                            c = [],
                            h = i('<div class="webui-popover-backdrop"></div>'),
                            d = 0,
                            u = !1,
                            p = -2e3,
                            f = i(t),
                            m = function (e, t) {
                                return isNaN(e) ? t || 0 : Number(e);
                            },
                            g = function (e) {
                                return e.data("plugin_" + o);
                            },
                            v = function () {
                                for (var e = null, t = 0; t < c.length; t++) (e = g(c[t])) && e.hide(!0);
                                f.trigger("hiddenAll." + a);
                            },
                            w = "ontouchstart" in t.documentElement && /Mobi/.test(navigator.userAgent),
                            k = function (e) {
                                var t = { x: 0, y: 0 };
                                if ("touchstart" === e.type || "touchmove" === e.type || "touchend" === e.type || "touchcancel" === e.type) {
                                    var i = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                                    (t.x = i.pageX), (t.y = i.pageY);
                                } else ("mousedown" !== e.type && "mouseup" !== e.type && "click" !== e.type) || ((t.x = e.pageX), (t.y = e.pageY));
                                return t;
                            };
                        (n.prototype = {
                            init: function () {
                                if (this.$element[0] instanceof t.constructor && !this.options.selector) throw new Error("`selector` option must be specified when initializing " + this.type + " on the window.document object!");
                                "manual" !== this.getTrigger() &&
                                    ("click" === this.getTrigger() || w
                                        ? this.$element.off("click touchend", this.options.selector).on("click touchend", this.options.selector, i.proxy(this.toggle, this))
                                        : "hover" === this.getTrigger() &&
                                          this.$element
                                              .off("mouseenter mouseleave click", this.options.selector)
                                              .on("mouseenter", this.options.selector, i.proxy(this.mouseenterHandler, this))
                                              .on("mouseleave", this.options.selector, i.proxy(this.mouseleaveHandler, this))),
                                    (this._poped = !1),
                                    (this._inited = !0),
                                    (this._opened = !1),
                                    (this._idSeed = d),
                                    (this.id = o + this._idSeed),
                                    (this.options.container = i(this.options.container || t.body).first()),
                                    this.options.backdrop && h.appendTo(this.options.container).hide(),
                                    d++,
                                    "sticky" === this.getTrigger() && this.show(),
                                    this.options.selector && (this._options = i.extend({}, this.options, { selector: "" }));
                            },
                            destroy: function () {
                                for (var e = -1, t = 0; t < c.length; t++)
                                    if (c[t] === this.$element) {
                                        e = t;
                                        break;
                                    }
                                c.splice(e, 1),
                                    this.hide(),
                                    this.$element.data("plugin_" + o, null),
                                    "click" === this.getTrigger() ? this.$element.off("click") : "hover" === this.getTrigger() && this.$element.off("mouseenter mouseleave"),
                                    this.$target && this.$target.remove();
                            },
                            getDelegateOptions: function () {
                                var e = {};
                                return (
                                    this._options &&
                                        i.each(this._options, function (t, i) {
                                            r[t] !== i && (e[t] = i);
                                        }),
                                    e
                                );
                            },
                            hide: function (e, t) {
                                if ((e || "sticky" !== this.getTrigger()) && this._opened) {
                                    t && (t.preventDefault(), t.stopPropagation()), this.xhr && !0 === this.options.abortXHR && (this.xhr.abort(), (this.xhr = null));
                                    var n = i.Event("hide." + a);
                                    if ((this.$element.trigger(n, [this.$target]), this.$target)) {
                                        this.$target.removeClass("in").addClass(this.getHideAnimation());
                                        var o = this;
                                        setTimeout(function () {
                                            o.$target.hide(), o.getCache() || o.$target.remove();
                                        }, o.getHideDelay());
                                    }
                                    this.options.backdrop && h.hide(), (this._opened = !1), this.$element.trigger("hidden." + a, [this.$target]), this.options.onHide && this.options.onHide(this.$target);
                                }
                            },
                            resetAutoHide: function () {
                                var e = this,
                                    t = e.getAutoHide();
                                t &&
                                    (e.autoHideHandler && clearTimeout(e.autoHideHandler),
                                    (e.autoHideHandler = setTimeout(function () {
                                        e.hide();
                                    }, t)));
                            },
                            delegate: function (e) {
                                var t = i(e).data("plugin_" + o);
                                return t || ((t = new n(e, this.getDelegateOptions())), i(e).data("plugin_" + o, t)), t;
                            },
                            toggle: function (e) {
                                var t = this;
                                e && (e.preventDefault(), e.stopPropagation(), this.options.selector && (t = this.delegate(e.currentTarget))), t[t.getTarget().hasClass("in") ? "hide" : "show"]();
                            },
                            hideAll: function () {
                                v();
                            },
                            hideOthers: function () {
                                !(function (e) {
                                    for (var t = null, i = 0; i < c.length; i++) (t = g(c[i])) && t.id !== e.id && t.hide(!0);
                                    f.trigger("hiddenAll." + a);
                                })(this);
                            },
                            show: function () {
                                if (!this._opened) {
                                    var e = this.getTarget().removeClass().addClass(s).addClass(this._customTargetClass);
                                    if ((this.options.multi || this.hideOthers(), !this.getCache() || !this._poped || "" === this.content)) {
                                        if (
                                            ((this.content = ""),
                                            this.setTitle(this.getTitle()),
                                            this.options.closeable || e.find(".close").off("click").remove(),
                                            this.isAsync() ? this.setContentASync(this.options.content) : this.setContent(this.getContent()),
                                            this.canEmptyHide() && "" === this.content)
                                        )
                                            return;
                                        e.show();
                                    }
                                    this.displayContent(), this.options.onShow && this.options.onShow(e), this.bindBodyEvents(), this.options.backdrop && h.show(), (this._opened = !0), this.resetAutoHide();
                                }
                            },
                            displayContent: function () {
                                var e,
                                    t = this.getElementPosition(),
                                    n = this.getTarget().removeClass().addClass(s).addClass(this._customTargetClass),
                                    o = this.getContentElement(),
                                    r = n[0].offsetWidth,
                                    c = n[0].offsetHeight,
                                    h = i.Event("show." + a);
                                if (this.canEmptyHide()) {
                                    var d = o.children().html();
                                    if (null !== d && 0 === d.trim().length) return;
                                }
                                this.$element.trigger(h, [n]);
                                var u = this.$element.data("width") || this.options.width;
                                "" === u && (u = this._defaults.width), "auto" !== u && n.width(u);
                                var f = this.$element.data("height") || this.options.height;
                                "" === f && (f = this._defaults.height),
                                    "auto" !== f && o.height(f),
                                    this.options.style && this.$target.addClass(s + "-" + this.options.style),
                                    "rtl" !== this.options.direction || o.hasClass(l) || o.addClass(l),
                                    this.options.arrow || n.find(".webui-arrow").remove(),
                                    n.detach().css({ top: p, left: p, display: "block" }),
                                    this.getAnimation() && n.addClass(this.getAnimation()),
                                    n.appendTo(this.options.container),
                                    (e = this.getPlacement(t)),
                                    this.$element.trigger("added." + a),
                                    this.initTargetEvents(),
                                    this.options.padding || ("auto" !== this.options.height && o.css("height", o.outerHeight()), this.$target.addClass("webui-no-padding")),
                                    (r = n[0].offsetWidth),
                                    (c = n[0].offsetHeight);
                                var m = this.getTargetPositin(t, e, r, c);
                                if ((this.$target.css(m.position).addClass(e).addClass("in"), "iframe" === this.options.type)) {
                                    var g = n.find("iframe"),
                                        v = n.width(),
                                        w = g.parent().height();
                                    "" !== this.options.iframeOptions.width && "auto" !== this.options.iframeOptions.width && (v = this.options.iframeOptions.width),
                                        "" !== this.options.iframeOptions.height && "auto" !== this.options.iframeOptions.height && (w = this.options.iframeOptions.height),
                                        g.width(v).height(w);
                                }
                                if ((this.options.arrow || this.$target.css({ margin: 0 }), this.options.arrow)) {
                                    var k = this.$target.find(".webui-arrow");
                                    k.removeAttr("style"),
                                        "left" === e || "right" === e ? k.css({ top: this.$target.height() / 2 }) : ("top" !== e && "bottom" !== e) || k.css({ left: this.$target.width() / 2 }),
                                        m.arrowOffset && (-1 === m.arrowOffset.left || -1 === m.arrowOffset.top ? k.hide() : k.css(m.arrowOffset));
                                }
                                (this._poped = !0), this.$element.trigger("shown." + a, [this.$target]);
                            },
                            isTargetLoaded: function () {
                                return 0 === this.getTarget().find("i.glyphicon-refresh").length;
                            },
                            getTriggerElement: function () {
                                return this.$element;
                            },
                            getTarget: function () {
                                if (!this.$target) {
                                    var e = o + this._idSeed;
                                    (this.$target = i(this.options.template).attr("id", e)), (this._customTargetClass = this.$target.attr("class") !== s ? this.$target.attr("class") : null), this.getTriggerElement().attr("data-target", e);
                                }
                                return this.$target.data("trigger-element") || this.$target.data("trigger-element", this.getTriggerElement()), this.$target;
                            },
                            removeTarget: function () {
                                this.$target.remove(), (this.$target = null), (this.$contentElement = null);
                            },
                            getTitleElement: function () {
                                return this.getTarget().find("." + s + "-title");
                            },
                            getContentElement: function () {
                                return this.$contentElement || (this.$contentElement = this.getTarget().find("." + s + "-content")), this.$contentElement;
                            },
                            getTitle: function () {
                                return this.$element.attr("data-title") || this.options.title || this.$element.attr("title");
                            },
                            getUrl: function () {
                                return this.$element.attr("data-url") || this.options.url;
                            },
                            getAutoHide: function () {
                                return this.$element.attr("data-auto-hide") || this.options.autoHide;
                            },
                            getOffsetTop: function () {
                                return m(this.$element.attr("data-offset-top")) || this.options.offsetTop;
                            },
                            getOffsetLeft: function () {
                                return m(this.$element.attr("data-offset-left")) || this.options.offsetLeft;
                            },
                            getCache: function () {
                                var e = this.$element.attr("data-cache");
                                if (void 0 !== e)
                                    switch (e.toLowerCase()) {
                                        case "true":
                                        case "yes":
                                        case "1":
                                            return !0;
                                        case "false":
                                        case "no":
                                        case "0":
                                            return !1;
                                    }
                                return this.options.cache;
                            },
                            getTrigger: function () {
                                return this.$element.attr("data-trigger") || this.options.trigger;
                            },
                            getDelayShow: function () {
                                var e = this.$element.attr("data-delay-show");
                                return void 0 !== e ? e : 0 === this.options.delay.show ? 0 : this.options.delay.show || 100;
                            },
                            getHideDelay: function () {
                                var e = this.$element.attr("data-delay-hide");
                                return void 0 !== e ? e : 0 === this.options.delay.hide ? 0 : this.options.delay.hide || 100;
                            },
                            getAnimation: function () {
                                return this.$element.attr("data-animation") || this.options.animation;
                            },
                            getHideAnimation: function () {
                                var e = this.getAnimation();
                                return e ? e + "-out" : "out";
                            },
                            setTitle: function (e) {
                                var t = this.getTitleElement();
                                e ? ("rtl" !== this.options.direction || t.hasClass(l) || t.addClass(l), t.html(e)) : t.remove();
                            },
                            hasContent: function () {
                                return this.getContent();
                            },
                            canEmptyHide: function () {
                                return this.options.hideEmpty && "html" === this.options.type;
                            },
                            getIframe: function () {
                                var e = i("<iframe></iframe>").attr("src", this.getUrl()),
                                    t = this;
                                return (
                                    i.each(this._defaults.iframeOptions, function (i) {
                                        void 0 !== t.options.iframeOptions[i] && e.attr(i, t.options.iframeOptions[i]);
                                    }),
                                    e
                                );
                            },
                            getContent: function () {
                                if (this.getUrl())
                                    switch (this.options.type) {
                                        case "iframe":
                                            this.content = this.getIframe();
                                            break;
                                        case "html":
                                            try {
                                                (this.content = i(this.getUrl())), this.content.is(":visible") || this.content.show();
                                            } catch (e) {
                                                throw new Error("Unable to get popover content. Invalid selector specified.");
                                            }
                                    }
                                else if (!this.content) {
                                    var e;
                                    if (((e = i.isFunction(this.options.content) ? this.options.content.apply(this.$element[0], [this]) : this.options.content), (this.content = this.$element.attr("data-content") || e), !this.content)) {
                                        var t = this.$element.next();
                                        t && t.hasClass(s + "-content") && (this.content = t);
                                    }
                                }
                                return this.content;
                            },
                            setContent: function (e) {
                                var t = this.getTarget(),
                                    n = this.getContentElement();
                                "string" == typeof e
                                    ? n.html(e)
                                    : e instanceof i &&
                                      (n.html(""),
                                      this.options.cache
                                          ? e.removeClass(s + "-content").appendTo(n)
                                          : e
                                                .clone(!0, !0)
                                                .removeClass(s + "-content")
                                                .appendTo(n)),
                                    (this.$target = t);
                            },
                            isAsync: function () {
                                return "async" === this.options.type;
                            },
                            setContentASync: function (e) {
                                var t = this;
                                this.xhr ||
                                    (this.xhr = i.ajax({
                                        url: this.getUrl(),
                                        type: this.options.async.type,
                                        cache: this.getCache(),
                                        beforeSend: function (e) {
                                            t.options.async.before && t.options.async.before(t, e);
                                        },
                                        success: function (n) {
                                            t.bindBodyEvents(),
                                                e && i.isFunction(e) ? (t.content = e.apply(t.$element[0], [n])) : (t.content = n),
                                                t.setContent(t.content),
                                                t.getContentElement().removeAttr("style"),
                                                t.displayContent(),
                                                t.options.async.success && t.options.async.success(t, n);
                                        },
                                        complete: function () {
                                            t.xhr = null;
                                        },
                                        error: function (e, i) {
                                            t.options.async.error && t.options.async.error(t, e, i);
                                        },
                                    }));
                            },
                            bindBodyEvents: function () {
                                u ||
                                    (this.options.dismissible && "click" === this.getTrigger()
                                        ? (f.off("keyup.webui-popover").on("keyup.webui-popover", i.proxy(this.escapeHandler, this)),
                                          f.off("click.webui-popover touchend.webui-popover").on("click.webui-popover touchend.webui-popover", i.proxy(this.bodyClickHandler, this)))
                                        : "hover" === this.getTrigger() && f.off("touchend.webui-popover").on("touchend.webui-popover", i.proxy(this.bodyClickHandler, this)));
                            },
                            mouseenterHandler: function (e) {
                                var t = this;
                                e && this.options.selector && (t = this.delegate(e.currentTarget)),
                                    t._timeout && clearTimeout(t._timeout),
                                    (t._enterTimeout = setTimeout(function () {
                                        t.getTarget().is(":visible") || t.show();
                                    }, this.getDelayShow()));
                            },
                            mouseleaveHandler: function () {
                                var e = this;
                                clearTimeout(e._enterTimeout),
                                    (e._timeout = setTimeout(function () {
                                        e.hide();
                                    }, this.getHideDelay()));
                            },
                            escapeHandler: function (e) {
                                27 === e.keyCode && this.hideAll();
                            },
                            bodyClickHandler: function (e) {
                                u = !0;
                                for (var t = !0, i = 0; i < c.length; i++) {
                                    var n = g(c[i]);
                                    if (n && n._opened) {
                                        var o = n.getTarget().offset(),
                                            s = o.left,
                                            a = o.top,
                                            r = o.left + n.getTarget().width(),
                                            l = o.top + n.getTarget().height(),
                                            h = k(e);
                                        if (h.x >= s && h.x <= r && h.y >= a && h.y <= l) {
                                            t = !1;
                                            break;
                                        }
                                    }
                                }
                                t && v();
                            },
                            initTargetEvents: function () {
                                "hover" === this.getTrigger() && this.$target.off("mouseenter mouseleave").on("mouseenter", i.proxy(this.mouseenterHandler, this)).on("mouseleave", i.proxy(this.mouseleaveHandler, this)),
                                    this.$target.find(".close").off("click").on("click", i.proxy(this.hide, this, !0));
                            },
                            getPlacement: function (e) {
                                var t,
                                    i = this.options.container,
                                    n = i.innerWidth(),
                                    o = i.innerHeight(),
                                    s = i.scrollTop(),
                                    a = i.scrollLeft(),
                                    r = Math.max(0, e.left - a),
                                    l = Math.max(0, e.top - s),
                                    c =
                                        "horizontal" ===
                                        (t = "function" == typeof this.options.placement ? this.options.placement.call(this, this.getTarget()[0], this.$element[0]) : this.$element.data("placement") || this.options.placement),
                                    h = "vertical" === t;
                                return (
                                    "auto" === t || c || h
                                        ? (t =
                                              r < n / 3
                                                  ? l < o / 3
                                                      ? c
                                                          ? "right-bottom"
                                                          : "bottom-right"
                                                      : l < (2 * o) / 3
                                                      ? h
                                                          ? l <= o / 2
                                                              ? "bottom-right"
                                                              : "top-right"
                                                          : "right"
                                                      : c
                                                      ? "right-top"
                                                      : "top-right"
                                                  : r < (2 * n) / 3
                                                  ? l < o / 3
                                                      ? c
                                                          ? r <= n / 2
                                                              ? "right-bottom"
                                                              : "left-bottom"
                                                          : "bottom"
                                                      : l < (2 * o) / 3
                                                      ? c
                                                          ? r <= n / 2
                                                              ? "right"
                                                              : "left"
                                                          : l <= o / 2
                                                          ? "bottom"
                                                          : "top"
                                                      : c
                                                      ? r <= n / 2
                                                          ? "right-top"
                                                          : "left-top"
                                                      : "top"
                                                  : l < o / 3
                                                  ? c
                                                      ? "left-bottom"
                                                      : "bottom-left"
                                                  : l < (2 * o) / 3
                                                  ? h
                                                      ? l <= o / 2
                                                          ? "bottom-left"
                                                          : "top-left"
                                                      : "left"
                                                  : c
                                                  ? "left-top"
                                                  : "top-left")
                                        : "auto-top" === t
                                        ? (t = r < n / 3 ? "top-right" : r < (2 * n) / 3 ? "top" : "top-left")
                                        : "auto-bottom" === t
                                        ? (t = r < n / 3 ? "bottom-right" : r < (2 * n) / 3 ? "bottom" : "bottom-left")
                                        : "auto-left" === t
                                        ? (t = l < o / 3 ? "left-top" : l < (2 * o) / 3 ? "left" : "left-bottom")
                                        : "auto-right" === t && (t = l < o / 3 ? "right-bottom" : l < (2 * o) / 3 ? "right" : "right-top"),
                                    t
                                );
                            },
                            getElementPosition: function () {
                                var e = this.$element[0].getBoundingClientRect(),
                                    n = this.options.container,
                                    o = n.css("position");
                                if (n.is(t.body) || "static" === o) return i.extend({}, this.$element.offset(), { width: this.$element[0].offsetWidth || e.width, height: this.$element[0].offsetHeight || e.height });
                                if ("fixed" === o) {
                                    var s = n[0].getBoundingClientRect();
                                    return { top: e.top - s.top + n.scrollTop(), left: e.left - s.left + n.scrollLeft(), width: e.width, height: e.height };
                                }
                                return "relative" === o
                                    ? {
                                          top: this.$element.offset().top - n.offset().top,
                                          left: this.$element.offset().left - n.offset().left,
                                          width: this.$element[0].offsetWidth || e.width,
                                          height: this.$element[0].offsetHeight || e.height,
                                      }
                                    : void 0;
                            },
                            getTargetPositin: function (e, i, n, o) {
                                var s = e,
                                    a = this.options.container,
                                    r = this.$element.outerWidth(),
                                    l = this.$element.outerHeight(),
                                    c = t.documentElement.scrollTop + a.scrollTop(),
                                    h = t.documentElement.scrollLeft + a.scrollLeft(),
                                    d = {},
                                    u = null,
                                    f = this.options.arrow ? 20 : 0,
                                    m = 10,
                                    g = r < f + m ? f : 0,
                                    v = l < f + m ? f : 0,
                                    w = 0,
                                    k = t.documentElement.clientHeight + c,
                                    y = t.documentElement.clientWidth + h,
                                    b = s.left + s.width / 2 - g > 0,
                                    S = s.left + s.width / 2 + g < y,
                                    C = s.top + s.height / 2 - v > 0,
                                    _ = s.top + s.height / 2 + v < k;
                                switch (i) {
                                    case "bottom":
                                        d = { top: s.top + s.height, left: s.left + s.width / 2 - n / 2 };
                                        break;
                                    case "top":
                                        d = { top: s.top - o, left: s.left + s.width / 2 - n / 2 };
                                        break;
                                    case "left":
                                        d = { top: s.top + s.height / 2 - o / 2, left: s.left - n };
                                        break;
                                    case "right":
                                        d = { top: s.top + s.height / 2 - o / 2, left: s.left + s.width };
                                        break;
                                    case "top-right":
                                        (d = { top: s.top - o, left: b ? s.left - g : m }), (u = { left: b ? Math.min(r, n) / 2 + g : p });
                                        break;
                                    case "top-left":
                                        (w = S ? g : -m), (d = { top: s.top - o, left: s.left - n + s.width + w }), (u = { left: S ? n - Math.min(r, n) / 2 - g : p });
                                        break;
                                    case "bottom-right":
                                        (d = { top: s.top + s.height, left: b ? s.left - g : m }), (u = { left: b ? Math.min(r, n) / 2 + g : p });
                                        break;
                                    case "bottom-left":
                                        (w = S ? g : -m), (d = { top: s.top + s.height, left: s.left - n + s.width + w }), (u = { left: S ? n - Math.min(r, n) / 2 - g : p });
                                        break;
                                    case "right-top":
                                        (w = _ ? v : -m), (d = { top: s.top - o + s.height + w, left: s.left + s.width }), (u = { top: _ ? o - Math.min(l, o) / 2 - v : p });
                                        break;
                                    case "right-bottom":
                                        (d = { top: C ? s.top - v : m, left: s.left + s.width }), (u = { top: C ? Math.min(l, o) / 2 + v : p });
                                        break;
                                    case "left-top":
                                        (w = _ ? v : -m), (d = { top: s.top - o + s.height + w, left: s.left - n }), (u = { top: _ ? o - Math.min(l, o) / 2 - v : p });
                                        break;
                                    case "left-bottom":
                                        (d = { top: C ? s.top - v : m, left: s.left - n }), (u = { top: C ? Math.min(l, o) / 2 + v : p });
                                }
                                return (d.top += this.getOffsetTop()), (d.left += this.getOffsetLeft()), { position: d, arrowOffset: u };
                            },
                        }),
                            (i.fn[o] = function (e, t) {
                                var s = [],
                                    a = this.each(function () {
                                        var a = i.data(this, "plugin_" + o);
                                        a
                                            ? "destroy" === e
                                                ? a.destroy()
                                                : "string" == typeof e && s.push(a[e]())
                                            : (e ? ("string" == typeof e ? "destroy" !== e && (t || ((a = new n(this, null)), s.push(a[e]()))) : "object" == typeof e && (a = new n(this, e))) : (a = new n(this, null)),
                                              i.data(this, "plugin_" + o, a));
                                    });
                                return s.length ? s : a;
                            });
                        var y = {
                            show: function (e, t) {
                                t ? i(e).webuiPopover(t).webuiPopover("show") : i(e).webuiPopover("show");
                            },
                            hide: function (e) {
                                i(e).webuiPopover("hide");
                            },
                            create: function (e, t) {
                                (t = t || {}), i(e).webuiPopover(t);
                            },
                            isCreated: function (e) {
                                var t = !0;
                                return (
                                    i(e).each(function (e) {
                                        t = t && void 0 !== i(e).data("plugin_" + o);
                                    }),
                                    t
                                );
                            },
                            hideAll: function () {
                                v();
                            },
                            updateContent: function (e, t) {
                                var n = i(e).data("plugin_" + o);
                                if (n) {
                                    var s = n.getCache();
                                    (n.options.cache = !1), (n.options.content = t), n._opened ? ((n._opened = !1), n.show()) : n.isAsync() ? n.setContentASync(t) : n.setContent(t), (n.options.cache = s);
                                }
                            },
                        };
                        e.WebuiPopovers = y;
                    });
                })(window, document),
            1 == HawkSearch.loadPlugins.debounce &&
                (function (e) {
                    var t,
                        i,
                        n = e.event;
                    t = n.special.debouncedresize = {
                        setup: function () {
                            e(this).on("resize", t.handler);
                        },
                        teardown: function () {
                            e(this).off("resize", t.handler);
                        },
                        handler: function (e, o) {
                            var s = this,
                                a = arguments,
                                r = function () {
                                    (e.type = "debouncedresize"), n.dispatch.apply(s, a);
                                };
                            i && clearTimeout(i), o ? r() : (i = setTimeout(r, t.threshold));
                        },
                        threshold: 150,
                    };
                })(jQuery),
            1 == HawkSearch.loadPlugins.slick &&
                (function (e) {
                    "use strict";
                    "function" == typeof a && a.amd ? a(["jquery"], e) : "undefined" != typeof exports ? (module.exports = e(require("jquery"))) : e(jQuery);
                })(function (e) {
                    "use strict";
                    var t = window.Slick || {};
                    ((t = (function () {
                        var t = 0;
                        return function (i, n) {
                            var o,
                                s,
                                a,
                                r = this;
                            if (
                                ((r.defaults = {
                                    accessibility: !0,
                                    adaptiveHeight: !1,
                                    appendArrows: e(i),
                                    appendDots: e(i),
                                    arrows: !0,
                                    asNavFor: null,
                                    prevArrow: '<button type="button" data-role="none" class="slick-prev">Previous</button>',
                                    nextArrow: '<button type="button" data-role="none" class="slick-next">Next</button>',
                                    autoplay: !1,
                                    autoplaySpeed: 3e3,
                                    centerMode: !1,
                                    centerPadding: "50px",
                                    cssEase: "ease",
                                    customPaging: function (e, t) {
                                        return '<button type="button" data-role="none">' + (t + 1) + "</button>";
                                    },
                                    dots: !1,
                                    dotsClass: "slick-dots",
                                    draggable: !0,
                                    easing: "linear",
                                    edgeFriction: 0.35,
                                    fade: !1,
                                    focusOnSelect: !1,
                                    infinite: !0,
                                    initialSlide: 0,
                                    lazyLoad: "ondemand",
                                    mobileFirst: !1,
                                    pauseOnHover: !0,
                                    pauseOnDotsHover: !1,
                                    respondTo: "window",
                                    responsive: null,
                                    rtl: !1,
                                    slide: "",
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    speed: 500,
                                    swipe: !0,
                                    swipeToSlide: !1,
                                    touchMove: !0,
                                    touchThreshold: 5,
                                    useCSS: !0,
                                    variableWidth: !1,
                                    vertical: !1,
                                    waitForAnimate: !0,
                                }),
                                (r.initials = {
                                    animating: !1,
                                    dragging: !1,
                                    autoPlayTimer: null,
                                    currentDirection: 0,
                                    currentLeft: null,
                                    currentSlide: 0,
                                    direction: 1,
                                    $dots: null,
                                    listWidth: null,
                                    listHeight: null,
                                    loadIndex: 0,
                                    $nextArrow: null,
                                    $prevArrow: null,
                                    slideCount: null,
                                    slideWidth: null,
                                    $slideTrack: null,
                                    $slides: null,
                                    sliding: !1,
                                    slideOffset: 0,
                                    swipeLeft: null,
                                    $list: null,
                                    touchObject: {},
                                    transformsEnabled: !1,
                                }),
                                e.extend(r, r.initials),
                                (r.activeBreakpoint = null),
                                (r.animType = null),
                                (r.animProp = null),
                                (r.breakpoints = []),
                                (r.breakpointSettings = []),
                                (r.cssTransitions = !1),
                                (r.hidden = "hidden"),
                                (r.paused = !1),
                                (r.positionProp = null),
                                (r.respondTo = null),
                                (r.shouldClick = !0),
                                (r.$slider = e(i)),
                                (r.$slidesCache = null),
                                (r.transformType = null),
                                (r.transitionType = null),
                                (r.visibilityChange = "visibilitychange"),
                                (r.windowWidth = 0),
                                (r.windowTimer = null),
                                (o = e(i).data("slick") || {}),
                                (r.options = e.extend({}, r.defaults, o, n)),
                                (r.currentSlide = r.options.initialSlide),
                                (r.originalSettings = r.options),
                                (s = r.options.responsive || null) && s.length > -1)
                            ) {
                                for (a in ((r.respondTo = r.options.respondTo || "window"), s)) s.hasOwnProperty(a) && (r.breakpoints.push(s[a].breakpoint), (r.breakpointSettings[s[a].breakpoint] = s[a].settings));
                                r.breakpoints.sort(function (e, t) {
                                    return !0 === r.options.mobileFirst ? e - t : t - e;
                                });
                            }
                            void 0 !== document.mozHidden
                                ? ((r.hidden = "mozHidden"), (r.visibilityChange = "mozvisibilitychange"))
                                : void 0 !== document.msHidden
                                ? ((r.hidden = "msHidden"), (r.visibilityChange = "msvisibilitychange"))
                                : void 0 !== document.webkitHidden && ((r.hidden = "webkitHidden"), (r.visibilityChange = "webkitvisibilitychange")),
                                (r.autoPlay = e.proxy(r.autoPlay, r)),
                                (r.autoPlayClear = e.proxy(r.autoPlayClear, r)),
                                (r.changeSlide = e.proxy(r.changeSlide, r)),
                                (r.clickHandler = e.proxy(r.clickHandler, r)),
                                (r.selectHandler = e.proxy(r.selectHandler, r)),
                                (r.setPosition = e.proxy(r.setPosition, r)),
                                (r.swipeHandler = e.proxy(r.swipeHandler, r)),
                                (r.dragHandler = e.proxy(r.dragHandler, r)),
                                (r.keyHandler = e.proxy(r.keyHandler, r)),
                                (r.autoPlayIterator = e.proxy(r.autoPlayIterator, r)),
                                (r.instanceUid = t++),
                                (r.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                                r.init(),
                                r.checkResponsive(!0);
                        };
                    })()).prototype.addSlide = t.prototype.slickAdd = function (t, i, n) {
                        var o = this;
                        if ("boolean" == typeof i) (n = i), (i = null);
                        else if (0 > i || i >= o.slideCount) return !1;
                        o.unload(),
                            "number" == typeof i
                                ? 0 === i && 0 === o.$slides.length
                                    ? e(t).appendTo(o.$slideTrack)
                                    : n
                                    ? e(t).insertBefore(o.$slides.eq(i))
                                    : e(t).insertAfter(o.$slides.eq(i))
                                : !0 === n
                                ? e(t).prependTo(o.$slideTrack)
                                : e(t).appendTo(o.$slideTrack),
                            (o.$slides = o.$slideTrack.children(this.options.slide)),
                            o.$slideTrack.children(this.options.slide).detach(),
                            o.$slideTrack.append(o.$slides),
                            o.$slides.each(function (t, i) {
                                e(i).attr("data-slick-index", t);
                            }),
                            (o.$slidesCache = o.$slides),
                            o.reinit();
                    }),
                        (t.prototype.animateHeight = function () {
                            var e = this;
                            if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
                                var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
                                e.$list.animate({ height: t }, e.options.speed);
                            }
                        }),
                        (t.prototype.animateSlide = function (t, i) {
                            var n = {},
                                o = this;
                            o.animateHeight(),
                                !0 === o.options.rtl && !1 === o.options.vertical && (t = -t),
                                !1 === o.transformsEnabled
                                    ? !1 === o.options.vertical
                                        ? o.$slideTrack.animate({ left: t }, o.options.speed, o.options.easing, i)
                                        : o.$slideTrack.animate({ top: t }, o.options.speed, o.options.easing, i)
                                    : !1 === o.cssTransitions
                                    ? (!0 === o.options.rtl && (o.currentLeft = -o.currentLeft),
                                      e({ animStart: o.currentLeft }).animate(
                                          { animStart: t },
                                          {
                                              duration: o.options.speed,
                                              easing: o.options.easing,
                                              step: function (e) {
                                                  (e = Math.ceil(e)),
                                                      !1 === o.options.vertical ? ((n[o.animType] = "translate(" + e + "px, 0px)"), o.$slideTrack.css(n)) : ((n[o.animType] = "translate(0px," + e + "px)"), o.$slideTrack.css(n));
                                              },
                                              complete: function () {
                                                  i && i.call();
                                              },
                                          }
                                      ))
                                    : (o.applyTransition(),
                                      (t = Math.ceil(t)),
                                      (n[o.animType] = !1 === o.options.vertical ? "translate3d(" + t + "px, 0px, 0px)" : "translate3d(0px," + t + "px, 0px)"),
                                      o.$slideTrack.css(n),
                                      i &&
                                          setTimeout(function () {
                                              o.disableTransition(), i.call();
                                          }, o.options.speed));
                        }),
                        (t.prototype.asNavFor = function (t) {
                            var i = null !== this.options.asNavFor ? e(this.options.asNavFor).slick("getSlick") : null;
                            null !== i && i.slideHandler(t, !0);
                        }),
                        (t.prototype.applyTransition = function (e) {
                            var t = this,
                                i = {};
                            (i[t.transitionType] = !1 === t.options.fade ? t.transformType + " " + t.options.speed + "ms " + t.options.cssEase : "opacity " + t.options.speed + "ms " + t.options.cssEase),
                                !1 === t.options.fade ? t.$slideTrack.css(i) : t.$slides.eq(e).css(i);
                        }),
                        (t.prototype.autoPlay = function () {
                            var e = this;
                            e.autoPlayTimer && clearInterval(e.autoPlayTimer), e.slideCount > e.options.slidesToShow && !0 !== e.paused && (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed));
                        }),
                        (t.prototype.autoPlayClear = function () {
                            this.autoPlayTimer && clearInterval(this.autoPlayTimer);
                        }),
                        (t.prototype.autoPlayIterator = function () {
                            var e = this;
                            !1 === e.options.infinite
                                ? 1 === e.direction
                                    ? (e.currentSlide + 1 === e.slideCount - 1 && (e.direction = 0), e.slideHandler(e.currentSlide + e.options.slidesToScroll))
                                    : (0 == e.currentSlide - 1 && (e.direction = 1), e.slideHandler(e.currentSlide - e.options.slidesToScroll))
                                : e.slideHandler(e.currentSlide + e.options.slidesToScroll);
                        }),
                        (t.prototype.buildArrows = function () {
                            var t = this;
                            !0 === t.options.arrows &&
                                t.slideCount > t.options.slidesToShow &&
                                ((t.$prevArrow = e(t.options.prevArrow)),
                                (t.$nextArrow = e(t.options.nextArrow)),
                                t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.appendTo(t.options.appendArrows),
                                t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.appendTo(t.options.appendArrows),
                                !0 !== t.options.infinite && t.$prevArrow.addClass("slick-disabled"));
                        }),
                        (t.prototype.buildDots = function () {
                            var t,
                                i,
                                n = this;
                            if (!0 === n.options.dots && n.slideCount > n.options.slidesToShow) {
                                for (i = '<ul class="' + n.options.dotsClass + '">', t = 0; t <= n.getDotCount(); t += 1) i += "<li>" + n.options.customPaging.call(this, n, t) + "</li>";
                                (i += "</ul>"), (n.$dots = e(i).appendTo(n.options.appendDots)), n.$dots.find("li").first().addClass("slick-active");
                            }
                        }),
                        (t.prototype.buildOut = function () {
                            var t = this;
                            (t.$slides = t.$slider.children(t.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
                                (t.slideCount = t.$slides.length),
                                t.$slides.each(function (t, i) {
                                    e(i).attr("data-slick-index", t);
                                }),
                                (t.$slidesCache = t.$slides),
                                t.$slider.addClass("slick-slider"),
                                (t.$slideTrack = 0 === t.slideCount ? e('<div class="slick-track"/>').appendTo(t.$slider) : t.$slides.wrapAll('<div class="slick-track"/>').parent()),
                                (t.$list = t.$slideTrack.wrap('<div class="slick-list"/>').parent()),
                                t.$slideTrack.css("opacity", 0),
                                (!0 === t.options.centerMode || !0 === t.options.swipeToSlide) && (t.options.slidesToScroll = 1),
                                e("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"),
                                t.setupInfinite(),
                                t.buildArrows(),
                                t.buildDots(),
                                t.updateDots(),
                                !0 === t.options.accessibility && t.$list.prop("tabIndex", 0),
                                t.setSlideClasses("number" == typeof this.currentSlide ? this.currentSlide : 0),
                                !0 === t.options.draggable && t.$list.addClass("draggable");
                        }),
                        (t.prototype.checkResponsive = function (t) {
                            var i,
                                n,
                                o,
                                s = this,
                                a = s.$slider.width(),
                                r = window.innerWidth || e(window).width();
                            if (
                                ("window" === s.respondTo ? (o = r) : "slider" === s.respondTo ? (o = a) : "min" === s.respondTo && (o = Math.min(r, a)),
                                s.originalSettings.responsive && s.originalSettings.responsive.length > -1 && null !== s.originalSettings.responsive)
                            ) {
                                for (i in ((n = null), s.breakpoints))
                                    s.breakpoints.hasOwnProperty(i) && (!1 === s.originalSettings.mobileFirst ? o < s.breakpoints[i] && (n = s.breakpoints[i]) : o > s.breakpoints[i] && (n = s.breakpoints[i]));
                                null !== n
                                    ? null !== s.activeBreakpoint
                                        ? n !== s.activeBreakpoint &&
                                          ((s.activeBreakpoint = n),
                                          "unslick" === s.breakpointSettings[n] ? s.unslick() : ((s.options = e.extend({}, s.originalSettings, s.breakpointSettings[n])), !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh()))
                                        : ((s.activeBreakpoint = n),
                                          "unslick" === s.breakpointSettings[n] ? s.unslick() : ((s.options = e.extend({}, s.originalSettings, s.breakpointSettings[n])), !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh()))
                                    : null !== s.activeBreakpoint && ((s.activeBreakpoint = null), (s.options = s.originalSettings), !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh());
                            }
                        }),
                        (t.prototype.changeSlide = function (t, i) {
                            var n,
                                o,
                                s = this;
                            switch ((e(t.target).is("a") && t.preventDefault(), (n = 0 != s.slideCount % s.options.slidesToScroll ? 0 : (s.slideCount - s.currentSlide) % s.options.slidesToScroll), t.data.message)) {
                                case "previous":
                                    (o = 0 === n ? s.options.slidesToScroll : s.options.slidesToShow - n), s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide - o, !1, i);
                                    break;
                                case "next":
                                    (o = 0 === n ? s.options.slidesToScroll : n), s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide + o, !1, i);
                                    break;
                                case "index":
                                    var a = 0 === t.data.index ? 0 : t.data.index || e(t.target).parent().index() * s.options.slidesToScroll;
                                    s.slideHandler(s.checkNavigable(a), !1, i);
                                    break;
                                default:
                                    return;
                            }
                        }),
                        (t.prototype.checkNavigable = function (e) {
                            var t, i;
                            if (((i = 0), e > (t = this.getNavigableIndexes())[t.length - 1])) e = t[t.length - 1];
                            else
                                for (var n in t) {
                                    if (e < t[n]) {
                                        e = i;
                                        break;
                                    }
                                    i = t[n];
                                }
                            return e;
                        }),
                        (t.prototype.clickHandler = function (e) {
                            !1 === this.shouldClick && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault());
                        }),
                        (t.prototype.destroy = function () {
                            var t = this;
                            t.autoPlayClear(),
                                (t.touchObject = {}),
                                e(".slick-cloned", t.$slider).remove(),
                                t.$dots && t.$dots.remove(),
                                t.$prevArrow && "object" != typeof t.options.prevArrow && t.$prevArrow.remove(),
                                t.$nextArrow && "object" != typeof t.options.nextArrow && t.$nextArrow.remove(),
                                t.$slides.removeClass("slick-slide slick-active slick-center slick-visible").removeAttr("data-slick-index").css({ position: "", left: "", top: "", zIndex: "", opacity: "", width: "" }),
                                t.$slider.removeClass("slick-slider"),
                                t.$slider.removeClass("slick-initialized"),
                                t.$list.off(".slick"),
                                e(window).off(".slick-" + t.instanceUid),
                                e(document).off(".slick-" + t.instanceUid),
                                t.$slider.html(t.$slides);
                        }),
                        (t.prototype.disableTransition = function (e) {
                            var t = this,
                                i = {};
                            (i[t.transitionType] = ""), !1 === t.options.fade ? t.$slideTrack.css(i) : t.$slides.eq(e).css(i);
                        }),
                        (t.prototype.fadeSlide = function (e, t) {
                            var i = this;
                            !1 === i.cssTransitions
                                ? (i.$slides.eq(e).css({ zIndex: 1e3 }), i.$slides.eq(e).animate({ opacity: 1 }, i.options.speed, i.options.easing, t))
                                : (i.applyTransition(e),
                                  i.$slides.eq(e).css({ opacity: 1, zIndex: 1e3 }),
                                  t &&
                                      setTimeout(function () {
                                          i.disableTransition(e), t.call();
                                      }, i.options.speed));
                        }),
                        (t.prototype.filterSlides = t.prototype.slickFilter = function (e) {
                            var t = this;
                            null !== e && (t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.filter(e).appendTo(t.$slideTrack), t.reinit());
                        }),
                        (t.prototype.getCurrent = t.prototype.slickCurrentSlide = function () {
                            return this.currentSlide;
                        }),
                        (t.prototype.getDotCount = function () {
                            var e = this,
                                t = 0,
                                i = 0,
                                n = 0;
                            if (!0 === e.options.infinite) n = Math.ceil(e.slideCount / e.options.slidesToScroll);
                            else if (!0 === e.options.centerMode) n = e.slideCount;
                            else for (; t < e.slideCount; ) ++n, (t = i + e.options.slidesToShow), (i += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                            return n - 1;
                        }),
                        (t.prototype.getLeft = function (e) {
                            var t,
                                i,
                                n,
                                o = this,
                                s = 0;
                            return (
                                (o.slideOffset = 0),
                                (i = o.$slides.first().outerHeight()),
                                !0 === o.options.infinite
                                    ? (o.slideCount > o.options.slidesToShow && ((o.slideOffset = -1 * o.slideWidth * o.options.slidesToShow), (s = -1 * i * o.options.slidesToShow)),
                                      0 != o.slideCount % o.options.slidesToScroll &&
                                          e + o.options.slidesToScroll > o.slideCount &&
                                          o.slideCount > o.options.slidesToShow &&
                                          (e > o.slideCount
                                              ? ((o.slideOffset = -1 * (o.options.slidesToShow - (e - o.slideCount)) * o.slideWidth), (s = -1 * (o.options.slidesToShow - (e - o.slideCount)) * i))
                                              : ((o.slideOffset = ((-1 * o.slideCount) % o.options.slidesToScroll) * o.slideWidth), (s = ((-1 * o.slideCount) % o.options.slidesToScroll) * i))))
                                    : e + o.options.slidesToShow > o.slideCount && ((o.slideOffset = (e + o.options.slidesToShow - o.slideCount) * o.slideWidth), (s = (e + o.options.slidesToShow - o.slideCount) * i)),
                                o.slideCount <= o.options.slidesToShow && ((o.slideOffset = 0), (s = 0)),
                                !0 === o.options.centerMode && !0 === o.options.infinite
                                    ? (o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth)
                                    : !0 === o.options.centerMode && ((o.slideOffset = 0), (o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2))),
                                (t = !1 === o.options.vertical ? -1 * e * o.slideWidth + o.slideOffset : -1 * e * i + s),
                                !0 === o.options.variableWidth &&
                                    ((t = (n = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow))[0]
                                        ? -1 * n[0].offsetLeft
                                        : 0),
                                    !0 === o.options.centerMode &&
                                        ((t = (n = !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow + 1))[0] ? -1 * n[0].offsetLeft : 0),
                                        (t += (o.$list.width() - n.outerWidth()) / 2))),
                                t
                            );
                        }),
                        (t.prototype.getOption = t.prototype.slickGetOption = function (e) {
                            return this.options[e];
                        }),
                        (t.prototype.getNavigableIndexes = function () {
                            var e,
                                t = this,
                                i = 0,
                                n = 0,
                                o = [];
                            for (
                                !1 === t.options.infinite ? ((e = t.slideCount - t.options.slidesToShow + 1), !0 === t.options.centerMode && (e = t.slideCount)) : ((i = -1 * t.slideCount), (n = -1 * t.slideCount), (e = 2 * t.slideCount));
                                e > i;

                            )
                                o.push(i), (i = n + t.options.slidesToScroll), (n += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow);
                            return o;
                        }),
                        (t.prototype.getSlick = function () {
                            return this;
                        }),
                        (t.prototype.getSlideCount = function () {
                            var t,
                                i,
                                n = this;
                            return (
                                (i = !0 === n.options.centerMode ? n.slideWidth * Math.floor(n.options.slidesToShow / 2) : 0),
                                !0 === n.options.swipeToSlide
                                    ? (n.$slideTrack.find(".slick-slide").each(function (o, s) {
                                          return s.offsetLeft - i + e(s).outerWidth() / 2 > -1 * n.swipeLeft ? ((t = s), !1) : void 0;
                                      }),
                                      Math.abs(e(t).attr("data-slick-index") - n.currentSlide) || 1)
                                    : n.options.slidesToScroll
                            );
                        }),
                        (t.prototype.goTo = t.prototype.slickGoTo = function (e, t) {
                            this.changeSlide({ data: { message: "index", index: parseInt(e) } }, t);
                        }),
                        (t.prototype.init = function () {
                            var t = this;
                            e(t.$slider).hasClass("slick-initialized") || (e(t.$slider).addClass("slick-initialized"), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots()),
                                t.$slider.trigger("init", [t]);
                        }),
                        (t.prototype.initArrowEvents = function () {
                            var e = this;
                            !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.on("click.slick", { message: "previous" }, e.changeSlide), e.$nextArrow.on("click.slick", { message: "next" }, e.changeSlide));
                        }),
                        (t.prototype.initDotEvents = function () {
                            var t = this;
                            !0 === t.options.dots && t.slideCount > t.options.slidesToShow && e("li", t.$dots).on("click.slick", { message: "index" }, t.changeSlide),
                                !0 === t.options.dots &&
                                    !0 === t.options.pauseOnDotsHover &&
                                    !0 === t.options.autoplay &&
                                    e("li", t.$dots)
                                        .on("mouseenter.slick", function () {
                                            (t.paused = !0), t.autoPlayClear();
                                        })
                                        .on("mouseleave.slick", function () {
                                            (t.paused = !1), t.autoPlay();
                                        });
                        }),
                        (t.prototype.initializeEvents = function () {
                            var t = this;
                            t.initArrowEvents(),
                                t.initDotEvents(),
                                t.$list.on("touchstart.slick mousedown.slick", { action: "start" }, t.swipeHandler),
                                t.$list.on("touchmove.slick mousemove.slick", { action: "move" }, t.swipeHandler),
                                t.$list.on("touchend.slick mouseup.slick", { action: "end" }, t.swipeHandler),
                                t.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, t.swipeHandler),
                                t.$list.on("click.slick", t.clickHandler),
                                !0 === t.options.autoplay &&
                                    (e(document).on(t.visibilityChange, function () {
                                        t.visibility();
                                    }),
                                    !0 === t.options.pauseOnHover &&
                                        (t.$list.on("mouseenter.slick", function () {
                                            (t.paused = !0), t.autoPlayClear();
                                        }),
                                        t.$list.on("mouseleave.slick", function () {
                                            (t.paused = !1), t.autoPlay();
                                        }))),
                                !0 === t.options.accessibility && t.$list.on("keydown.slick", t.keyHandler),
                                !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler),
                                e(window).on("orientationchange.slick.slick-" + t.instanceUid, function () {
                                    t.checkResponsive(), t.setPosition();
                                }),
                                e(window).on("resize.slick.slick-" + t.instanceUid, function () {
                                    e(window).width() !== t.windowWidth &&
                                        (clearTimeout(t.windowDelay),
                                        (t.windowDelay = window.setTimeout(function () {
                                            (t.windowWidth = e(window).width()), t.checkResponsive(), t.setPosition();
                                        }, 50)));
                                }),
                                e("*[draggable!=true]", t.$slideTrack).on("dragstart", function (e) {
                                    e.preventDefault();
                                }),
                                e(window).on("load.slick.slick-" + t.instanceUid, t.setPosition),
                                e(document).on("ready.slick.slick-" + t.instanceUid, t.setPosition);
                        }),
                        (t.prototype.initUI = function () {
                            var e = this;
                            !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.show(), e.$nextArrow.show()),
                                !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.show(),
                                !0 === e.options.autoplay && e.autoPlay();
                        }),
                        (t.prototype.keyHandler = function (e) {
                            var t = this;
                            37 === e.keyCode && !0 === t.options.accessibility ? t.changeSlide({ data: { message: "previous" } }) : 39 === e.keyCode && !0 === t.options.accessibility && t.changeSlide({ data: { message: "next" } });
                        }),
                        (t.prototype.lazyLoad = function () {
                            function t(t) {
                                e("img[data-lazy]", t).each(function () {
                                    var t = e(this),
                                        i = e(this).attr("data-lazy");
                                    t.load(function () {
                                        t.animate({ opacity: 1 }, 200);
                                    })
                                        .css({ opacity: 0 })
                                        .attr("src", i)
                                        .removeAttr("data-lazy")
                                        .removeClass("slick-loading");
                                });
                            }
                            var i,
                                n,
                                o = this;
                            !0 === o.options.centerMode
                                ? !0 === o.options.infinite
                                    ? (n = (i = o.currentSlide + (o.options.slidesToShow / 2 + 1)) + o.options.slidesToShow + 2)
                                    : ((i = Math.max(0, o.currentSlide - (o.options.slidesToShow / 2 + 1))), (n = o.options.slidesToShow / 2 + 1 + 2 + o.currentSlide))
                                : ((n = (i = o.options.infinite ? o.options.slidesToShow + o.currentSlide : o.currentSlide) + o.options.slidesToShow), !0 === o.options.fade && (i > 0 && i--, n <= o.slideCount && n++)),
                                t(o.$slider.find(".slick-slide").slice(i, n)),
                                o.slideCount <= o.options.slidesToShow
                                    ? t(o.$slider.find(".slick-slide"))
                                    : o.currentSlide >= o.slideCount - o.options.slidesToShow
                                    ? t(o.$slider.find(".slick-cloned").slice(0, o.options.slidesToShow))
                                    : 0 === o.currentSlide && t(o.$slider.find(".slick-cloned").slice(-1 * o.options.slidesToShow));
                        }),
                        (t.prototype.loadSlider = function () {
                            var e = this;
                            e.setPosition(), e.$slideTrack.css({ opacity: 1 }), e.$slider.removeClass("slick-loading"), e.initUI(), "progressive" === e.options.lazyLoad && e.progressiveLazyLoad();
                        }),
                        (t.prototype.next = t.prototype.slickNext = function () {
                            this.changeSlide({ data: { message: "next" } });
                        }),
                        (t.prototype.pause = t.prototype.slickPause = function () {
                            this.autoPlayClear(), (this.paused = !0);
                        }),
                        (t.prototype.play = t.prototype.slickPlay = function () {
                            (this.paused = !1), this.autoPlay();
                        }),
                        (t.prototype.postSlide = function (e) {
                            var t = this;
                            t.$slider.trigger("afterChange", [t, e]), (t.animating = !1), t.setPosition(), (t.swipeLeft = null), !0 === t.options.autoplay && !1 === t.paused && t.autoPlay();
                        }),
                        (t.prototype.prev = t.prototype.slickPrev = function () {
                            this.changeSlide({ data: { message: "previous" } });
                        }),
                        (t.prototype.progressiveLazyLoad = function () {
                            var t,
                                i = this;
                            e("img[data-lazy]", i.$slider).length > 0 &&
                                (t = e("img[data-lazy]", i.$slider).first())
                                    .attr("src", t.attr("data-lazy"))
                                    .removeClass("slick-loading")
                                    .load(function () {
                                        t.removeAttr("data-lazy"), i.progressiveLazyLoad();
                                    })
                                    .error(function () {
                                        t.removeAttr("data-lazy"), i.progressiveLazyLoad();
                                    });
                        }),
                        (t.prototype.refresh = function () {
                            var t = this,
                                i = t.currentSlide;
                            t.destroy(), e.extend(t, t.initials), t.init(), t.changeSlide({ data: { message: "index", index: i } }, !0);
                        }),
                        (t.prototype.reinit = function () {
                            var t = this;
                            (t.$slides = t.$slideTrack.children(t.options.slide).addClass("slick-slide")),
                                (t.slideCount = t.$slides.length),
                                t.currentSlide >= t.slideCount && 0 !== t.currentSlide && (t.currentSlide = t.currentSlide - t.options.slidesToScroll),
                                t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
                                t.setProps(),
                                t.setupInfinite(),
                                t.buildArrows(),
                                t.updateArrows(),
                                t.initArrowEvents(),
                                t.buildDots(),
                                t.updateDots(),
                                t.initDotEvents(),
                                !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler),
                                t.setSlideClasses(0),
                                t.setPosition(),
                                t.$slider.trigger("reInit", [t]);
                        }),
                        (t.prototype.removeSlide = t.prototype.slickRemove = function (e, t, i) {
                            var n = this;
                            return (
                                "boolean" == typeof e ? (e = !0 === (t = e) ? 0 : n.slideCount - 1) : (e = !0 === t ? --e : e),
                                !(n.slideCount < 1 || 0 > e || e > n.slideCount - 1) &&
                                    (n.unload(),
                                    !0 === i ? n.$slideTrack.children().remove() : n.$slideTrack.children(this.options.slide).eq(e).remove(),
                                    (n.$slides = n.$slideTrack.children(this.options.slide)),
                                    n.$slideTrack.children(this.options.slide).detach(),
                                    n.$slideTrack.append(n.$slides),
                                    (n.$slidesCache = n.$slides),
                                    void n.reinit())
                            );
                        }),
                        (t.prototype.setCSS = function (e) {
                            var t,
                                i,
                                n = this,
                                o = {};
                            !0 === n.options.rtl && (e = -e),
                                (t = "left" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
                                (i = "top" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
                                (o[n.positionProp] = e),
                                !1 === n.transformsEnabled
                                    ? n.$slideTrack.css(o)
                                    : ((o = {}), !1 === n.cssTransitions ? ((o[n.animType] = "translate(" + t + ", " + i + ")"), n.$slideTrack.css(o)) : ((o[n.animType] = "translate3d(" + t + ", " + i + ", 0px)"), n.$slideTrack.css(o)));
                        }),
                        (t.prototype.setDimensions = function () {
                            var e = this;
                            if (
                                (!1 === e.options.vertical
                                    ? !0 === e.options.centerMode && e.$list.css({ padding: "0px " + e.options.centerPadding })
                                    : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow), !0 === e.options.centerMode && e.$list.css({ padding: e.options.centerPadding + " 0px" })),
                                (e.listWidth = e.$list.width()),
                                (e.listHeight = e.$list.height()),
                                !1 === e.options.vertical && !1 === e.options.variableWidth)
                            )
                                (e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow)), e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length));
                            else if (!0 === e.options.variableWidth) {
                                var t = 0;
                                (e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow)),
                                    e.$slideTrack.children(".slick-slide").each(function () {
                                        t += e.listWidth;
                                    }),
                                    e.$slideTrack.width(Math.ceil(t) + 1);
                            } else (e.slideWidth = Math.ceil(e.listWidth)), e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length));
                            var i = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
                            !1 === e.options.variableWidth && e.$slideTrack.children(".slick-slide").width(e.slideWidth - i);
                        }),
                        (t.prototype.setFade = function () {
                            var t,
                                i = this;
                            i.$slides.each(function (n, o) {
                                (t = -1 * i.slideWidth * n),
                                    !0 === i.options.rtl ? e(o).css({ position: "relative", right: t, top: 0, zIndex: 800, opacity: 0 }) : e(o).css({ position: "relative", left: t, top: 0, zIndex: 800, opacity: 0 });
                            }),
                                i.$slides.eq(i.currentSlide).css({ zIndex: 900, opacity: 1 });
                        }),
                        (t.prototype.setHeight = function () {
                            var e = this;
                            if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
                                var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
                                e.$list.css("height", t);
                            }
                        }),
                        (t.prototype.setOption = t.prototype.slickSetOption = function (e, t, i) {
                            var n = this;
                            (n.options[e] = t), !0 === i && (n.unload(), n.reinit());
                        }),
                        (t.prototype.setPosition = function () {
                            var e = this;
                            e.setDimensions(), e.setHeight(), !1 === e.options.fade ? e.setCSS(e.getLeft(e.currentSlide)) : e.setFade(), e.$slider.trigger("setPosition", [e]);
                        }),
                        (t.prototype.setProps = function () {
                            var e = this,
                                t = document.body.style;
                            (e.positionProp = !0 === e.options.vertical ? "top" : "left"),
                                "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"),
                                (void 0 !== t.WebkitTransition || void 0 !== t.MozTransition || void 0 !== t.msTransition) && !0 === e.options.useCSS && (e.cssTransitions = !0),
                                void 0 !== t.OTransform &&
                                    ((e.animType = "OTransform"), (e.transformType = "-o-transform"), (e.transitionType = "OTransition"), void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
                                void 0 !== t.MozTransform &&
                                    ((e.animType = "MozTransform"), (e.transformType = "-moz-transform"), (e.transitionType = "MozTransition"), void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)),
                                void 0 !== t.webkitTransform &&
                                    ((e.animType = "webkitTransform"),
                                    (e.transformType = "-webkit-transform"),
                                    (e.transitionType = "webkitTransition"),
                                    void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
                                void 0 !== t.msTransform && ((e.animType = "msTransform"), (e.transformType = "-ms-transform"), (e.transitionType = "msTransition"), void 0 === t.msTransform && (e.animType = !1)),
                                void 0 !== t.transform && !1 !== e.animType && ((e.animType = "transform"), (e.transformType = "transform"), (e.transitionType = "transition")),
                                (e.transformsEnabled = null !== e.animType && !1 !== e.animType);
                        }),
                        (t.prototype.setSlideClasses = function (e) {
                            var t,
                                i,
                                n,
                                o,
                                s = this;
                            s.$slider.find(".slick-slide").removeClass("slick-active").removeClass("slick-center"),
                                (i = s.$slider.find(".slick-slide")),
                                !0 === s.options.centerMode
                                    ? ((t = Math.floor(s.options.slidesToShow / 2)),
                                      !0 === s.options.infinite &&
                                          (e >= t && e <= s.slideCount - 1 - t ? s.$slides.slice(e - t, e + t + 1).addClass("slick-active") : ((n = s.options.slidesToShow + e), i.slice(n - t + 1, n + t + 2).addClass("slick-active")),
                                          0 === e ? i.eq(i.length - 1 - s.options.slidesToShow).addClass("slick-center") : e === s.slideCount - 1 && i.eq(s.options.slidesToShow).addClass("slick-center")),
                                      s.$slides.eq(e).addClass("slick-center"))
                                    : e >= 0 && e <= s.slideCount - s.options.slidesToShow
                                    ? s.$slides.slice(e, e + s.options.slidesToShow).addClass("slick-active")
                                    : i.length <= s.options.slidesToShow
                                    ? i.addClass("slick-active")
                                    : ((o = s.slideCount % s.options.slidesToShow),
                                      (n = !0 === s.options.infinite ? s.options.slidesToShow + e : e),
                                      s.options.slidesToShow == s.options.slidesToScroll && s.slideCount - e < s.options.slidesToShow
                                          ? i.slice(n - (s.options.slidesToShow - o), n + o).addClass("slick-active")
                                          : i.slice(n, n + s.options.slidesToShow).addClass("slick-active")),
                                "ondemand" === s.options.lazyLoad && s.lazyLoad();
                        }),
                        (t.prototype.setupInfinite = function () {
                            var t,
                                i,
                                n,
                                o = this;
                            if ((!0 === o.options.fade && (o.options.centerMode = !1), !0 === o.options.infinite && !1 === o.options.fade && ((i = null), o.slideCount > o.options.slidesToShow))) {
                                for (n = !0 === o.options.centerMode ? o.options.slidesToShow + 1 : o.options.slidesToShow, t = o.slideCount; t > o.slideCount - n; t -= 1)
                                    (i = t - 1),
                                        e(o.$slides[i])
                                            .clone(!0)
                                            .attr("id", "")
                                            .attr("data-slick-index", i - o.slideCount)
                                            .prependTo(o.$slideTrack)
                                            .addClass("slick-cloned");
                                for (t = 0; n > t; t += 1)
                                    (i = t),
                                        e(o.$slides[i])
                                            .clone(!0)
                                            .attr("id", "")
                                            .attr("data-slick-index", i + o.slideCount)
                                            .appendTo(o.$slideTrack)
                                            .addClass("slick-cloned");
                                o.$slideTrack
                                    .find(".slick-cloned")
                                    .find("[id]")
                                    .each(function () {
                                        e(this).attr("id", "");
                                    });
                            }
                        }),
                        (t.prototype.selectHandler = function (t) {
                            var i = this,
                                n = parseInt(e(t.target).parents(".slick-slide").attr("data-slick-index"));
                            return (
                                n || (n = 0),
                                i.slideCount <= i.options.slidesToShow
                                    ? (i.$slider.find(".slick-slide").removeClass("slick-active"),
                                      i.$slides.eq(n).addClass("slick-active"),
                                      !0 === i.options.centerMode && (i.$slider.find(".slick-slide").removeClass("slick-center"), i.$slides.eq(n).addClass("slick-center")),
                                      void i.asNavFor(n))
                                    : void i.slideHandler(n)
                            );
                        }),
                        (t.prototype.slideHandler = function (e, t, i) {
                            var n,
                                o,
                                s,
                                a = null,
                                r = this;
                            return (
                                (t = t || !1),
                                (!0 === r.animating && !0 === r.options.waitForAnimate) || (!0 === r.options.fade && r.currentSlide === e) || r.slideCount <= r.options.slidesToShow
                                    ? void 0
                                    : (!1 === t && r.asNavFor(e),
                                      (n = e),
                                      (a = r.getLeft(n)),
                                      (s = r.getLeft(r.currentSlide)),
                                      (r.currentLeft = null === r.swipeLeft ? s : r.swipeLeft),
                                      !1 === r.options.infinite && !1 === r.options.centerMode && (0 > e || e > r.getDotCount() * r.options.slidesToScroll)
                                          ? void (
                                                !1 === r.options.fade &&
                                                ((n = r.currentSlide),
                                                !0 !== i
                                                    ? r.animateSlide(s, function () {
                                                          r.postSlide(n);
                                                      })
                                                    : r.postSlide(n))
                                            )
                                          : !1 === r.options.infinite && !0 === r.options.centerMode && (0 > e || e > r.slideCount - r.options.slidesToScroll)
                                          ? void (
                                                !1 === r.options.fade &&
                                                ((n = r.currentSlide),
                                                !0 !== i
                                                    ? r.animateSlide(s, function () {
                                                          r.postSlide(n);
                                                      })
                                                    : r.postSlide(n))
                                            )
                                          : (!0 === r.options.autoplay && clearInterval(r.autoPlayTimer),
                                            (o =
                                                0 > n
                                                    ? 0 != r.slideCount % r.options.slidesToScroll
                                                        ? r.slideCount - (r.slideCount % r.options.slidesToScroll)
                                                        : r.slideCount + n
                                                    : n >= r.slideCount
                                                    ? 0 != r.slideCount % r.options.slidesToScroll
                                                        ? 0
                                                        : n - r.slideCount
                                                    : n),
                                            (r.animating = !0),
                                            r.$slider.trigger("beforeChange", [r, r.currentSlide, o]),
                                            r.currentSlide,
                                            (r.currentSlide = o),
                                            r.setSlideClasses(r.currentSlide),
                                            r.updateDots(),
                                            r.updateArrows(),
                                            !0 === r.options.fade
                                                ? (!0 !== i
                                                      ? r.fadeSlide(o, function () {
                                                            r.postSlide(o);
                                                        })
                                                      : r.postSlide(o),
                                                  void r.animateHeight())
                                                : void (!0 !== i
                                                      ? r.animateSlide(a, function () {
                                                            r.postSlide(o);
                                                        })
                                                      : r.postSlide(o))))
                            );
                        }),
                        (t.prototype.startLoad = function () {
                            var e = this;
                            !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(), e.$nextArrow.hide()),
                                !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.hide(),
                                e.$slider.addClass("slick-loading");
                        }),
                        (t.prototype.swipeDirection = function () {
                            var e,
                                t,
                                i,
                                n,
                                o = this;
                            return (
                                (e = o.touchObject.startX - o.touchObject.curX),
                                (t = o.touchObject.startY - o.touchObject.curY),
                                (i = Math.atan2(t, e)),
                                0 > (n = Math.round((180 * i) / Math.PI)) && (n = 360 - Math.abs(n)),
                                45 >= n && n >= 0 ? (!1 === o.options.rtl ? "left" : "right") : 360 >= n && n >= 315 ? (!1 === o.options.rtl ? "left" : "right") : n >= 135 && 225 >= n ? (!1 === o.options.rtl ? "right" : "left") : "vertical"
                            );
                        }),
                        (t.prototype.swipeEnd = function () {
                            var e,
                                t = this;
                            if (((t.dragging = !1), (t.shouldClick = !(t.touchObject.swipeLength > 10)), void 0 === t.touchObject.curX)) return !1;
                            if ((!0 === t.touchObject.edgeHit && t.$slider.trigger("edge", [t, t.swipeDirection()]), t.touchObject.swipeLength >= t.touchObject.minSwipe))
                                switch (t.swipeDirection()) {
                                    case "left":
                                        (e = t.options.swipeToSlide ? t.checkNavigable(t.currentSlide + t.getSlideCount()) : t.currentSlide + t.getSlideCount()),
                                            t.slideHandler(e),
                                            (t.currentDirection = 0),
                                            (t.touchObject = {}),
                                            t.$slider.trigger("swipe", [t, "left"]);
                                        break;
                                    case "right":
                                        (e = t.options.swipeToSlide ? t.checkNavigable(t.currentSlide - t.getSlideCount()) : t.currentSlide - t.getSlideCount()),
                                            t.slideHandler(e),
                                            (t.currentDirection = 1),
                                            (t.touchObject = {}),
                                            t.$slider.trigger("swipe", [t, "right"]);
                                }
                            else t.touchObject.startX !== t.touchObject.curX && (t.slideHandler(t.currentSlide), (t.touchObject = {}));
                        }),
                        (t.prototype.swipeHandler = function (e) {
                            var t = this;
                            if (!(!1 === t.options.swipe || ("ontouchend" in document && !1 === t.options.swipe) || (!1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))))
                                switch (
                                    ((t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1), (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold), e.data.action)
                                ) {
                                    case "start":
                                        t.swipeStart(e);
                                        break;
                                    case "move":
                                        t.swipeMove(e);
                                        break;
                                    case "end":
                                        t.swipeEnd(e);
                                }
                        }),
                        (t.prototype.swipeMove = function (e) {
                            var t,
                                i,
                                n,
                                o,
                                s,
                                a = this;
                            return (
                                (s = void 0 !== e.originalEvent ? e.originalEvent.touches : null),
                                !(!a.dragging || (s && 1 !== s.length)) &&
                                    ((t = a.getLeft(a.currentSlide)),
                                    (a.touchObject.curX = void 0 !== s ? s[0].pageX : e.clientX),
                                    (a.touchObject.curY = void 0 !== s ? s[0].pageY : e.clientY),
                                    (a.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(a.touchObject.curX - a.touchObject.startX, 2)))),
                                    "vertical" !== (i = a.swipeDirection())
                                        ? (void 0 !== e.originalEvent && a.touchObject.swipeLength > 4 && e.preventDefault(),
                                          (o = (!1 === a.options.rtl ? 1 : -1) * (a.touchObject.curX > a.touchObject.startX ? 1 : -1)),
                                          (n = a.touchObject.swipeLength),
                                          (a.touchObject.edgeHit = !1),
                                          !1 === a.options.infinite &&
                                              ((0 === a.currentSlide && "right" === i) || (a.currentSlide >= a.getDotCount() && "left" === i)) &&
                                              ((n = a.touchObject.swipeLength * a.options.edgeFriction), (a.touchObject.edgeHit = !0)),
                                          (a.swipeLeft = !1 === a.options.vertical ? t + n * o : t + n * (a.$list.height() / a.listWidth) * o),
                                          !0 !== a.options.fade && !1 !== a.options.touchMove && (!0 === a.animating ? ((a.swipeLeft = null), !1) : void a.setCSS(a.swipeLeft)))
                                        : void 0)
                            );
                        }),
                        (t.prototype.swipeStart = function (e) {
                            var t,
                                i = this;
                            return 1 !== i.touchObject.fingerCount || i.slideCount <= i.options.slidesToShow
                                ? ((i.touchObject = {}), !1)
                                : (void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]),
                                  (i.touchObject.startX = i.touchObject.curX = void 0 !== t ? t.pageX : e.clientX),
                                  (i.touchObject.startY = i.touchObject.curY = void 0 !== t ? t.pageY : e.clientY),
                                  void (i.dragging = !0));
                        }),
                        (t.prototype.unfilterSlides = t.prototype.slickUnfilter = function () {
                            var e = this;
                            null !== e.$slidesCache && (e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.appendTo(e.$slideTrack), e.reinit());
                        }),
                        (t.prototype.unload = function () {
                            var t = this;
                            e(".slick-cloned", t.$slider).remove(),
                                t.$dots && t.$dots.remove(),
                                t.$prevArrow && "object" != typeof t.options.prevArrow && t.$prevArrow.remove(),
                                t.$nextArrow && "object" != typeof t.options.nextArrow && t.$nextArrow.remove(),
                                t.$slides.removeClass("slick-slide slick-active slick-visible").css("width", "");
                        }),
                        (t.prototype.unslick = function () {
                            this.destroy();
                        }),
                        (t.prototype.updateArrows = function () {
                            var e = this;
                            Math.floor(e.options.slidesToShow / 2),
                                !0 === e.options.arrows &&
                                    !0 !== e.options.infinite &&
                                    e.slideCount > e.options.slidesToShow &&
                                    (e.$prevArrow.removeClass("slick-disabled"),
                                    e.$nextArrow.removeClass("slick-disabled"),
                                    0 === e.currentSlide
                                        ? (e.$prevArrow.addClass("slick-disabled"), e.$nextArrow.removeClass("slick-disabled"))
                                        : e.currentSlide >= e.slideCount - e.options.slidesToShow && !1 === e.options.centerMode
                                        ? (e.$nextArrow.addClass("slick-disabled"), e.$prevArrow.removeClass("slick-disabled"))
                                        : e.currentSlide >= e.slideCount - 1 && !0 === e.options.centerMode && (e.$nextArrow.addClass("slick-disabled"), e.$prevArrow.removeClass("slick-disabled")));
                        }),
                        (t.prototype.updateDots = function () {
                            var e = this;
                            null !== e.$dots &&
                                (e.$dots.find("li").removeClass("slick-active"),
                                e.$dots
                                    .find("li")
                                    .eq(Math.floor(e.currentSlide / e.options.slidesToScroll))
                                    .addClass("slick-active"));
                        }),
                        (t.prototype.visibility = function () {
                            var e = this;
                            document[e.hidden] ? ((e.paused = !0), e.autoPlayClear()) : ((e.paused = !1), e.autoPlay());
                        }),
                        (e.fn.slick = function () {
                            for (var e, i = this, n = arguments[0], o = Array.prototype.slice.call(arguments, 1), s = i.length, a = 0; s > a; a++)
                                if (("object" == typeof n || void 0 === n ? (i[a].slick = new t(i[a], n)) : (e = i[a].slick[n].apply(i[a].slick, o)), void 0 !== e)) return e;
                            return i;
                        }),
                        e(function () {
                            e("[data-slick]").slick();
                        });
                }),
            1 == HawkSearch.loadPlugins.numeric &&
                (function (e) {
                    (e.fn.numeric = function (t, i) {
                        "boolean" == typeof t && (t = { decimal: t }), void 0 === (t = t || {}).negative && (t.negative = !0);
                        var n = !1 === t.decimal ? "" : t.decimal || ".",
                            o = !0 === t.negative;
                        i = "function" == typeof i ? i : function () {};
                        return this.data("numeric.decimal", n).data("numeric.negative", o).data("numeric.callback", i).keypress(e.fn.numeric.keypress).keyup(e.fn.numeric.keyup).blur(e.fn.numeric.blur);
                    }),
                        (e.fn.numeric.keypress = function (t) {
                            var i = e.data(this, "numeric.decimal"),
                                n = e.data(this, "numeric.negative"),
                                o = t.charCode ? t.charCode : t.keyCode ? t.keyCode : 0;
                            if (13 == o && "input" == this.nodeName.toLowerCase()) return !0;
                            if (13 == o) return !1;
                            var s = !1;
                            if ((t.ctrlKey && 97 == o) || (t.ctrlKey && 65 == o)) return !0;
                            if ((t.ctrlKey && 120 == o) || (t.ctrlKey && 88 == o)) return !0;
                            if ((t.ctrlKey && 99 == o) || (t.ctrlKey && 67 == o)) return !0;
                            if ((t.ctrlKey && 122 == o) || (t.ctrlKey && 90 == o)) return !0;
                            if ((t.ctrlKey && 118 == o) || (t.ctrlKey && 86 == o) || (t.shiftKey && 45 == o)) return !0;
                            if (o < 48 || o > 57) {
                                if (0 != this.value.indexOf("-") && n && 45 == o && (0 == this.value.length || 0 == e.fn.getSelectionStart(this))) return !0;
                                i && o == i.charCodeAt(0) && -1 != this.value.indexOf(i) && (s = !1),
                                    8 != o && 9 != o && 13 != o && 35 != o && 36 != o && 37 != o && 39 != o && 46 != o
                                        ? (s = !1)
                                        : void 0 !== t.charCode && (t.keyCode == t.which && 0 != t.which ? ((s = !0), 46 == t.which && (s = !1)) : 0 != t.keyCode && 0 == t.charCode && 0 == t.which && (s = !0)),
                                    i && o == i.charCodeAt(0) && (s = -1 == this.value.indexOf(i));
                            } else s = !0;
                            return s;
                        }),
                        (e.fn.numeric.keyup = function (t) {
                            var i = this.value;
                            if (i.length > 0) {
                                var n = e.fn.getSelectionStart(this),
                                    o = e.data(this, "numeric.decimal"),
                                    s = e.data(this, "numeric.negative");
                                if ("" != o) {
                                    var a = i.indexOf(o);
                                    0 == a && (this.value = "0" + i), 1 == a && "-" == i.charAt(0) && (this.value = "-0" + i.substring(1)), (i = this.value);
                                }
                                for (var r = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, "-", o], l = i.length, c = l - 1; c >= 0; c--) {
                                    var h = i.charAt(c);
                                    0 != c && "-" == h ? (i = i.substring(0, c) + i.substring(c + 1)) : 0 != c || s || "-" != h || (i = i.substring(1));
                                    for (var d = !1, u = 0; u < r.length; u++)
                                        if (h == r[u]) {
                                            d = !0;
                                            break;
                                        }
                                    (d && " " != h) || (i = i.substring(0, c) + i.substring(c + 1));
                                }
                                var p = i.indexOf(o);
                                if (p > 0)
                                    for (c = l - 1; c > p; c--) {
                                        (h = i.charAt(c)) == o && (i = i.substring(0, c) + i.substring(c + 1));
                                    }
                                (this.value = i), e.fn.setSelection(this, n);
                            }
                        }),
                        (e.fn.numeric.blur = function () {
                            var t = e.data(this, "numeric.decimal"),
                                i = e.data(this, "numeric.callback"),
                                n = this.value;
                            "" != n && (new RegExp("^\\d+$|\\d*" + t + "\\d+").exec(n) || i.apply(this));
                        }),
                        (e.fn.removeNumeric = function () {
                            return this.data("numeric.decimal", null).data("numeric.negative", null).data("numeric.callback", null).unbind("keypress", e.fn.numeric.keypress).unbind("blur", e.fn.numeric.blur);
                        }),
                        (e.fn.getSelectionStart = function (e) {
                            if (e.createTextRange) {
                                var t = document.selection.createRange().duplicate();
                                return t.moveEnd("character", e.value.length), "" == t.text ? e.value.length : e.value.lastIndexOf(t.text);
                            }
                            return e.selectionStart;
                        }),
                        (e.fn.setSelection = function (e, t) {
                            if (("number" == typeof t && (t = [t, t]), t && t.constructor == Array && 2 == t.length))
                                if (e.createTextRange) {
                                    var i = e.createTextRange();
                                    i.collapse(!0), i.moveStart("character", t[0]), i.moveEnd("character", t[1]), i.select();
                                } else e.setSelectionRange && (e.focus(), e.setSelectionRange(t[0], t[1]));
                        });
                })(jQuery),
            1 == HawkSearch.loadPlugins.alertify &&
                (function (e) {
                    "use strict";
                    function t(e, t) {
                        e.className += " " + t;
                    }
                    function i(e, t) {
                        for (var i = e.className.split(" "), n = t.split(" "), o = 0; o < n.length; o += 1) {
                            var s = i.indexOf(n[o]);
                            s > -1 && i.splice(s, 1);
                        }
                        e.className = i.join(" ");
                    }
                    function n() {
                        return "rtl" === e.getComputedStyle(document.body).direction;
                    }
                    function o() {
                        return (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
                    }
                    function s() {
                        return (document.documentElement && document.documentElement.scrollLeft) || document.body.scrollLeft;
                    }
                    function r(e) {
                        for (; e.lastChild; ) e.removeChild(e.lastChild);
                    }
                    function l(e) {
                        if (null === e) return e;
                        var t;
                        if (Array.isArray(e)) {
                            t = [];
                            for (var i = 0; i < e.length; i += 1) t.push(l(e[i]));
                            return t;
                        }
                        if (e instanceof Date) return new Date(e.getTime());
                        if (e instanceof RegExp) return ((t = new RegExp(e.source)).global = e.global), (t.ignoreCase = e.ignoreCase), (t.multiline = e.multiline), (t.lastIndex = e.lastIndex), t;
                        if ("object" == typeof e) {
                            for (var n in ((t = {}), e)) e.hasOwnProperty(n) && (t[n] = l(e[n]));
                            return t;
                        }
                        return e;
                    }
                    function c(e, t) {
                        var i = e.elements.root;
                        i.parentNode.removeChild(i), delete e.elements, (e.settings = l(e.__settings)), (e.__init = t), delete e.__internal;
                    }
                    function h(e, t) {
                        return function () {
                            if (arguments.length > 0) {
                                for (var i = [], n = 0; n < arguments.length; n += 1) i.push(arguments[n]);
                                return i.push(e), t.apply(e, i);
                            }
                            return t.apply(e, [null, e]);
                        };
                    }
                    function d(e, t) {
                        return { index: e, button: t, cancel: !1 };
                    }
                    function u(e, t) {
                        "function" == typeof t.get(e) && t.get(e).call(t);
                    }
                    var p = { ENTER: 13, ESC: 27, F1: 112, F12: 123, LEFT: 37, RIGHT: 39 },
                        f = {
                            autoReset: !0,
                            basic: !1,
                            closable: !0,
                            closableByDimmer: !0,
                            frameless: !1,
                            maintainFocus: !0,
                            maximizable: !0,
                            modal: !0,
                            movable: !0,
                            moveBounded: !1,
                            overflow: !0,
                            padding: !0,
                            pinnable: !0,
                            pinned: !0,
                            preventBodyShift: !1,
                            resizable: !0,
                            startMaximized: !1,
                            transition: "pulse",
                            notifier: { delay: 5, position: "bottom-right" },
                            glossary: { title: "AlertifyJS", ok: "OK", cancel: "Cancel", acccpt: "Accept", deny: "Deny", confirm: "Confirm", decline: "Decline", close: "Close", maximize: "Maximize", restore: "Restore" },
                            theme: { input: "ajs-input", ok: "ajs-ok", cancel: "ajs-cancel" },
                        },
                        m = [],
                        g = document.addEventListener
                            ? function (e, t, i, n) {
                                  e.addEventListener(t, i, !0 === n);
                              }
                            : document.attachEvent
                            ? function (e, t, i) {
                                  e.attachEvent("on" + t, i);
                              }
                            : void 0,
                        v = document.removeEventListener
                            ? function (e, t, i, n) {
                                  e.removeEventListener(t, i, !0 === n);
                              }
                            : document.detachEvent
                            ? function (e, t, i) {
                                  e.detachEvent("on" + t, i);
                              }
                            : void 0,
                        w = (function () {
                            var e,
                                t,
                                i = !1,
                                n = { animation: "animationend", OAnimation: "oAnimationEnd oanimationend", msAnimation: "MSAnimationEnd", MozAnimation: "animationend", WebkitAnimation: "webkitAnimationEnd" };
                            for (e in n)
                                if (void 0 !== document.documentElement.style[e]) {
                                    (t = n[e]), (i = !0);
                                    break;
                                }
                            return { type: t, supported: i };
                        })(),
                        k = (function () {
                            function a(e) {
                                if (!e.__internal) {
                                    var i;
                                    delete e.__init,
                                        e.__settings || (e.__settings = l(e.settings)),
                                        null === ue && document.body.setAttribute("tabindex", "0"),
                                        "function" == typeof e.setup ? (((i = e.setup()).options = i.options || {}), (i.focus = i.focus || {})) : (i = { buttons: [], focus: { element: null, select: !1 }, options: {} }),
                                        "object" != typeof e.hooks && (e.hooks = {});
                                    var n = [];
                                    if (Array.isArray(i.buttons))
                                        for (var o = 0; o < i.buttons.length; o += 1) {
                                            var s = i.buttons[o],
                                                a = {};
                                            for (var r in s) s.hasOwnProperty(r) && (a[r] = s[r]);
                                            n.push(a);
                                        }
                                    var c = (e.__internal = {
                                            isOpen: !1,
                                            activeElement: document.body,
                                            timerIn: void 0,
                                            timerOut: void 0,
                                            buttons: n,
                                            focus: i.focus,
                                            options: {
                                                title: void 0,
                                                modal: void 0,
                                                basic: void 0,
                                                frameless: void 0,
                                                pinned: void 0,
                                                movable: void 0,
                                                moveBounded: void 0,
                                                resizable: void 0,
                                                autoReset: void 0,
                                                closable: void 0,
                                                closableByDimmer: void 0,
                                                maximizable: void 0,
                                                startMaximized: void 0,
                                                pinnable: void 0,
                                                transition: void 0,
                                                padding: void 0,
                                                overflow: void 0,
                                                onshow: void 0,
                                                onclose: void 0,
                                                onfocus: void 0,
                                                onmove: void 0,
                                                onmoved: void 0,
                                                onresize: void 0,
                                                onresized: void 0,
                                                onmaximize: void 0,
                                                onmaximized: void 0,
                                                onrestore: void 0,
                                                onrestored: void 0,
                                            },
                                            resetHandler: void 0,
                                            beginMoveHandler: void 0,
                                            beginResizeHandler: void 0,
                                            bringToFrontHandler: void 0,
                                            modalClickHandler: void 0,
                                            buttonsClickHandler: void 0,
                                            commandsClickHandler: void 0,
                                            transitionInHandler: void 0,
                                            transitionOutHandler: void 0,
                                            destroy: void 0,
                                        }),
                                        d = {};
                                    (d.root = document.createElement("div")),
                                        (d.root.className = me.base + " " + me.hidden + " "),
                                        (d.root.innerHTML = fe.dimmer + fe.modal),
                                        (d.dimmer = d.root.firstChild),
                                        (d.modal = d.root.lastChild),
                                        (d.modal.innerHTML = fe.dialog),
                                        (d.dialog = d.modal.firstChild),
                                        (d.dialog.innerHTML = fe.reset + fe.commands + fe.header + fe.body + fe.footer + fe.resizeHandle + fe.reset),
                                        (d.reset = []),
                                        d.reset.push(d.dialog.firstChild),
                                        d.reset.push(d.dialog.lastChild),
                                        (d.commands = {}),
                                        (d.commands.container = d.reset[0].nextSibling),
                                        (d.commands.pin = d.commands.container.firstChild),
                                        (d.commands.maximize = d.commands.pin.nextSibling),
                                        (d.commands.close = d.commands.maximize.nextSibling),
                                        (d.header = d.commands.container.nextSibling),
                                        (d.body = d.header.nextSibling),
                                        (d.body.innerHTML = fe.content),
                                        (d.content = d.body.firstChild),
                                        (d.footer = d.body.nextSibling),
                                        (d.footer.innerHTML = fe.buttons.auxiliary + fe.buttons.primary),
                                        (d.resizeHandle = d.footer.nextSibling),
                                        (d.buttons = {}),
                                        (d.buttons.auxiliary = d.footer.firstChild),
                                        (d.buttons.primary = d.buttons.auxiliary.nextSibling),
                                        (d.buttons.primary.innerHTML = fe.button),
                                        (d.buttonTemplate = d.buttons.primary.firstChild),
                                        d.buttons.primary.removeChild(d.buttonTemplate);
                                    for (var u = 0; u < e.__internal.buttons.length; u += 1) {
                                        var p = e.__internal.buttons[u];
                                        for (var f in (de.indexOf(p.key) < 0 && de.push(p.key),
                                        (p.element = d.buttonTemplate.cloneNode()),
                                        (p.element.innerHTML = p.text),
                                        "string" == typeof p.className && "" !== p.className && t(p.element, p.className),
                                        p.attrs))
                                            "className" !== f && p.attrs.hasOwnProperty(f) && p.element.setAttribute(f, p.attrs[f]);
                                        "auxiliary" === p.scope ? d.buttons.auxiliary.appendChild(p.element) : d.buttons.primary.appendChild(p.element);
                                    }
                                    for (var m in ((e.elements = d),
                                    (c.resetHandler = h(e, z)),
                                    (c.beginMoveHandler = h(e, G)),
                                    (c.beginResizeHandler = h(e, K)),
                                    (c.bringToFrontHandler = h(e, _)),
                                    (c.modalClickHandler = h(e, M)),
                                    (c.buttonsClickHandler = h(e, $)),
                                    (c.commandsClickHandler = h(e, I)),
                                    (c.transitionInHandler = h(e, q)),
                                    (c.transitionOutHandler = h(e, F)),
                                    c.options))
                                        void 0 !== i.options[m] ? e.set(m, i.options[m]) : b.defaults.hasOwnProperty(m) ? e.set(m, b.defaults[m]) : "title" === m && e.set(m, b.defaults.glossary[m]);
                                    "function" == typeof e.build && e.build();
                                }
                                document.body.appendChild(e.elements.root);
                            }
                            function f() {
                                (ce = s()), (he = o());
                            }
                            function k() {
                                e.scrollTo(ce, he);
                            }
                            function y() {
                                for (var e = 0, n = 0; n < m.length; n += 1) {
                                    var o = m[n];
                                    (o.isModal() || o.isMaximized()) && (e += 1);
                                }
                                0 === e && document.body.className.indexOf(me.noOverflow) >= 0
                                    ? (i(document.body, me.noOverflow), S(!1))
                                    : e > 0 && document.body.className.indexOf(me.noOverflow) < 0 && (S(!0), t(document.body, me.noOverflow));
                            }
                            function S(n) {
                                b.defaults.preventBodyShift &&
                                    document.documentElement.scrollHeight > document.documentElement.clientHeight &&
                                    (n
                                        ? ((ve = he), (ge = e.getComputedStyle(document.body).top), t(document.body, me.fixed), (document.body.style.top = -he + "px"))
                                        : ((he = ve), (document.body.style.top = ge), i(document.body, me.fixed), k()));
                            }
                            function C(e, n, o) {
                                "string" == typeof o && i(e.elements.root, me.prefix + o), t(e.elements.root, me.prefix + n), (ue = e.elements.root.offsetWidth);
                            }
                            function _(e, t) {
                                for (var i = m.indexOf(t) + 1; i < m.length; i += 1) if (m[i].isModal()) return;
                                return document.body.lastChild !== t.elements.root && (document.body.appendChild(t.elements.root), m.splice(m.indexOf(t), 1), m.push(t), D(t)), !1;
                            }
                            function x(e, n, o, s) {
                                switch (n) {
                                    case "title":
                                        e.setHeader(s);
                                        break;
                                    case "modal":
                                        !(function (e) {
                                            e.get("modal") ? (i(e.elements.root, me.modeless), e.isOpen() && (oe(e), U(e), y())) : (t(e.elements.root, me.modeless), e.isOpen() && (ne(e), U(e), y()));
                                        })(e);
                                        break;
                                    case "basic":
                                        !(function (e) {
                                            e.get("basic") ? t(e.elements.root, me.basic) : i(e.elements.root, me.basic);
                                        })(e);
                                        break;
                                    case "frameless":
                                        !(function (e) {
                                            e.get("frameless") ? t(e.elements.root, me.frameless) : i(e.elements.root, me.frameless);
                                        })(e);
                                        break;
                                    case "pinned":
                                        !(function (e) {
                                            e.get("pinned") ? (i(e.elements.root, me.unpinned), e.isOpen() && N(e)) : (t(e.elements.root, me.unpinned), e.isOpen() && !e.isModal() && L(e));
                                        })(e);
                                        break;
                                    case "closable":
                                        !(function (e) {
                                            e.get("closable")
                                                ? (t(e.elements.root, me.closable),
                                                  (function (e) {
                                                      g(e.elements.modal, "click", e.__internal.modalClickHandler);
                                                  })(e))
                                                : (i(e.elements.root, me.closable),
                                                  (function (e) {
                                                      v(e.elements.modal, "click", e.__internal.modalClickHandler);
                                                  })(e));
                                        })(e);
                                        break;
                                    case "maximizable":
                                        !(function (e) {
                                            e.get("maximizable") ? t(e.elements.root, me.maximizable) : i(e.elements.root, me.maximizable);
                                        })(e);
                                        break;
                                    case "pinnable":
                                        !(function (e) {
                                            e.get("pinnable") ? t(e.elements.root, me.pinnable) : i(e.elements.root, me.pinnable);
                                        })(e);
                                        break;
                                    case "movable":
                                        !(function (e) {
                                            e.get("movable") ? (t(e.elements.root, me.movable), e.isOpen() && se(e)) : (Y(e), i(e.elements.root, me.movable), e.isOpen() && ae(e));
                                        })(e);
                                        break;
                                    case "resizable":
                                        !(function (e) {
                                            e.get("resizable") ? (t(e.elements.root, me.resizable), e.isOpen() && re(e)) : (ee(e), i(e.elements.root, me.resizable), e.isOpen() && le(e));
                                        })(e);
                                        break;
                                    case "transition":
                                        C(e, s, o);
                                        break;
                                    case "padding":
                                        s ? i(e.elements.root, me.noPadding) : e.elements.root.className.indexOf(me.noPadding) < 0 && t(e.elements.root, me.noPadding);
                                        break;
                                    case "overflow":
                                        s ? i(e.elements.root, me.noOverflow) : e.elements.root.className.indexOf(me.noOverflow) < 0 && t(e.elements.root, me.noOverflow);
                                        break;
                                    case "transition":
                                        C(e, s, o);
                                }
                                "function" == typeof e.hooks.onupdate && e.hooks.onupdate.call(e, n, o, s);
                            }
                            function T(e, t, i, n, o) {
                                var s,
                                    a = { op: void 0, items: [] };
                                if (void 0 === o && "string" == typeof n) (a.op = "get"), t.hasOwnProperty(n) ? ((a.found = !0), (a.value = t[n])) : ((a.found = !1), (a.value = void 0));
                                else if (((a.op = "set"), "object" == typeof n)) {
                                    var r = n;
                                    for (var l in r)
                                        t.hasOwnProperty(l) ? (t[l] !== r[l] && ((s = t[l]), (t[l] = r[l]), i.call(e, l, s, r[l])), a.items.push({ key: l, value: r[l], found: !0 })) : a.items.push({ key: l, value: r[l], found: !1 });
                                } else {
                                    if ("string" != typeof n) throw new Error("args must be a string or object");
                                    t.hasOwnProperty(n) ? (t[n] !== o && ((s = t[n]), (t[n] = o), i.call(e, n, s, o)), a.items.push({ key: n, value: o, found: !0 })) : a.items.push({ key: n, value: o, found: !1 });
                                }
                                return a;
                            }
                            function H(e) {
                                var t;
                                j(e, function (e) {
                                    return (t = !0 === e.invokeOnClose);
                                }),
                                    !t && e.isOpen() && e.close();
                            }
                            function I(e, t) {
                                switch (e.srcElement || e.target) {
                                    case t.elements.commands.pin:
                                        t.isPinned() ? E(t) : P(t);
                                        break;
                                    case t.elements.commands.maximize:
                                        t.isMaximized() ? A(t) : O(t);
                                        break;
                                    case t.elements.commands.close:
                                        H(t);
                                }
                                return !1;
                            }
                            function P(e) {
                                e.set("pinned", !0);
                            }
                            function E(e) {
                                e.set("pinned", !1);
                            }
                            function O(e) {
                                u("onmaximize", e), t(e.elements.root, me.maximized), e.isOpen() && y(), u("onmaximized", e);
                            }
                            function A(e) {
                                u("onrestore", e), i(e.elements.root, me.maximized), e.isOpen() && y(), u("onrestored", e);
                            }
                            function L(e) {
                                var t = s();
                                (e.elements.modal.style.marginTop = o() + "px"), (e.elements.modal.style.marginLeft = t + "px"), (e.elements.modal.style.marginRight = -t + "px");
                            }
                            function N(e) {
                                var t = parseInt(e.elements.modal.style.marginTop, 10),
                                    i = parseInt(e.elements.modal.style.marginLeft, 10);
                                if (((e.elements.modal.style.marginTop = ""), (e.elements.modal.style.marginLeft = ""), (e.elements.modal.style.marginRight = ""), e.isOpen())) {
                                    var n = 0,
                                        a = 0;
                                    "" !== e.elements.dialog.style.top && (n = parseInt(e.elements.dialog.style.top, 10)),
                                        (e.elements.dialog.style.top = n + (t - o()) + "px"),
                                        "" !== e.elements.dialog.style.left && (a = parseInt(e.elements.dialog.style.left, 10)),
                                        (e.elements.dialog.style.left = a + (i - s()) + "px");
                                }
                            }
                            function U(e) {
                                e.get("modal") || e.get("pinned") ? N(e) : L(e);
                            }
                            function M(e, t) {
                                var i = e.srcElement || e.target;
                                return we || i !== t.elements.modal || !0 !== t.get("closableByDimmer") || H(t), (we = !1), !1;
                            }
                            function j(e, t) {
                                for (var i = 0; i < e.__internal.buttons.length; i += 1) {
                                    var n = e.__internal.buttons[i];
                                    if (!n.element.disabled && t(n)) {
                                        var o = d(i, n);
                                        "function" == typeof e.callback && e.callback.apply(e, [o]), !1 === o.cancel && e.close();
                                        break;
                                    }
                                }
                            }
                            function $(e, t) {
                                var i = e.srcElement || e.target;
                                j(t, function (e) {
                                    return e.element === i && (ke = !0);
                                });
                            }
                            function B(e) {
                                if (!ke) {
                                    var t = m[m.length - 1],
                                        i = e.keyCode;
                                    return 0 === t.__internal.buttons.length && i === p.ESC && !0 === t.get("closable")
                                        ? (H(t), !1)
                                        : de.indexOf(i) > -1
                                        ? (j(t, function (e) {
                                              return e.key === i;
                                          }),
                                          !1)
                                        : void 0;
                                }
                                ke = !1;
                            }
                            function R(e) {
                                var t = m[m.length - 1],
                                    i = e.keyCode;
                                if (i === p.LEFT || i === p.RIGHT) {
                                    for (var n = t.__internal.buttons, o = 0; o < n.length; o += 1)
                                        if (document.activeElement === n[o].element)
                                            switch (i) {
                                                case p.LEFT:
                                                    return void n[(o || n.length) - 1].element.focus();
                                                case p.RIGHT:
                                                    return void n[(o + 1) % n.length].element.focus();
                                            }
                                } else if (i < p.F12 + 1 && i > p.F1 - 1 && de.indexOf(i) > -1)
                                    return (
                                        e.preventDefault(),
                                        e.stopPropagation(),
                                        j(t, function (e) {
                                            return e.key === i;
                                        }),
                                        !1
                                    );
                            }
                            function D(e, t) {
                                if (t) t.focus();
                                else {
                                    var i = e.__internal.focus,
                                        n = i.element;
                                    switch (typeof i.element) {
                                        case "number":
                                            e.__internal.buttons.length > i.element && (n = !0 === e.get("basic") ? e.elements.reset[0] : e.__internal.buttons[i.element].element);
                                            break;
                                        case "string":
                                            n = e.elements.body.querySelector(i.element);
                                            break;
                                        case "function":
                                            n = i.element.call(e);
                                    }
                                    null != n || 0 !== e.__internal.buttons.length || (n = e.elements.reset[0]), n && n.focus && (n.focus(), i.select && n.select && n.select());
                                }
                            }
                            function z(e, t) {
                                if (!t)
                                    for (var i = m.length - 1; i > -1; i -= 1)
                                        if (m[i].isModal()) {
                                            t = m[i];
                                            break;
                                        }
                                if (t && t.isModal()) {
                                    var n,
                                        o = e.srcElement || e.target,
                                        s = o === t.elements.reset[1] || (0 === t.__internal.buttons.length && o === document.body);
                                    s && (t.get("maximizable") ? (n = t.elements.commands.maximize) : t.get("closable") && (n = t.elements.commands.close)),
                                        void 0 === n &&
                                            ("number" == typeof t.__internal.focus.element
                                                ? o === t.elements.reset[0]
                                                    ? (n = t.elements.buttons.auxiliary.firstChild || t.elements.buttons.primary.firstChild)
                                                    : s && (n = t.elements.reset[0])
                                                : o === t.elements.reset[0] && (n = t.elements.buttons.primary.lastChild || t.elements.buttons.auxiliary.lastChild)),
                                        D(t, n);
                                }
                            }
                            function q(e, t) {
                                clearTimeout(t.__internal.timerIn), D(t), k(), (ke = !1), u("onfocus", t), v(t.elements.dialog, w.type, t.__internal.transitionInHandler), i(t.elements.root, me.animationIn);
                            }
                            function F(e, t) {
                                clearTimeout(t.__internal.timerOut),
                                    v(t.elements.dialog, w.type, t.__internal.transitionOutHandler),
                                    Y(t),
                                    ee(t),
                                    t.isMaximized() && !t.get("startMaximized") && A(t),
                                    b.defaults.maintainFocus && t.__internal.activeElement && (t.__internal.activeElement.focus(), (t.__internal.activeElement = null)),
                                    "function" == typeof t.__internal.destroy && t.__internal.destroy.apply(t);
                            }
                            function V(e, t) {
                                var i = e[Ce] - be,
                                    n = e[_e] - Se;
                                Te && (n -= document.body.scrollTop), (t.style.left = i + "px"), (t.style.top = n + "px");
                            }
                            function W(e, t) {
                                var i = e[Ce] - be,
                                    n = e[_e] - Se;
                                Te && (n -= document.body.scrollTop),
                                    (t.style.left = Math.min(xe.maxLeft, Math.max(xe.minLeft, i)) + "px"),
                                    (t.style.top = Te ? Math.min(xe.maxTop, Math.max(xe.minTop, n)) + "px" : Math.max(xe.minTop, n) + "px");
                            }
                            function G(e, i) {
                                if (null === Ie && !i.isMaximized() && i.get("movable")) {
                                    var n,
                                        o = 0,
                                        s = 0;
                                    if (("touchstart" === e.type ? (e.preventDefault(), (n = e.targetTouches[0]), (Ce = "clientX"), (_e = "clientY")) : 0 === e.button && (n = e), n)) {
                                        var a = i.elements.dialog;
                                        if (
                                            (t(a, me.capture),
                                            a.style.left && (o = parseInt(a.style.left, 10)),
                                            a.style.top && (s = parseInt(a.style.top, 10)),
                                            (be = n[Ce] - o),
                                            (Se = n[_e] - s),
                                            i.isModal() ? (Se += i.elements.modal.scrollTop) : i.isPinned() && (Se -= document.body.scrollTop),
                                            i.get("moveBounded"))
                                        ) {
                                            var r = a,
                                                l = -o,
                                                c = -s;
                                            do {
                                                (l += r.offsetLeft), (c += r.offsetTop);
                                            } while ((r = r.offsetParent));
                                            (xe = { maxLeft: l, minLeft: -l, maxTop: document.documentElement.clientHeight - a.clientHeight - c, minTop: -c }), (He = W);
                                        } else (xe = null), (He = V);
                                        return u("onmove", i), (Te = !i.isModal() && i.isPinned()), (ye = i), He(n, a), t(document.body, me.noSelection), !1;
                                    }
                                }
                            }
                            function Q(e) {
                                var t;
                                ye && ("touchmove" === e.type ? (e.preventDefault(), (t = e.targetTouches[0])) : 0 === e.button && (t = e), t && He(t, ye.elements.dialog));
                            }
                            function X() {
                                if (ye) {
                                    var e = ye;
                                    (ye = xe = null), i(document.body, me.noSelection), i(e.elements.dialog, me.capture), u("onmoved", e);
                                }
                            }
                            function Y(e) {
                                ye = null;
                                var t = e.elements.dialog;
                                t.style.left = t.style.top = "";
                            }
                            function K(e, i) {
                                var n;
                                if (!i.isMaximized() && ("touchstart" === e.type ? (e.preventDefault(), (n = e.targetTouches[0])) : 0 === e.button && (n = e), n)) {
                                    u("onresize", i), (Ie = i), (Ae = i.elements.resizeHandle.offsetHeight / 2);
                                    var o = i.elements.dialog;
                                    return (
                                        t(o, me.capture),
                                        (Pe = parseInt(o.style.left, 10)),
                                        (o.style.height = o.offsetHeight + "px"),
                                        (o.style.minHeight = i.elements.header.offsetHeight + i.elements.footer.offsetHeight + "px"),
                                        (o.style.width = (Ee = o.offsetWidth) + "px"),
                                        "none" !== o.style.maxWidth && (o.style.minWidth = (Oe = o.offsetWidth) + "px"),
                                        (o.style.maxWidth = "none"),
                                        t(document.body, me.noSelection),
                                        !1
                                    );
                                }
                            }
                            function J(e) {
                                var t;
                                Ie &&
                                    ("touchmove" === e.type ? (e.preventDefault(), (t = e.targetTouches[0])) : 0 === e.button && (t = e),
                                    t &&
                                        (function (e, t, i) {
                                            var o,
                                                s,
                                                a = t,
                                                r = 0,
                                                l = 0;
                                            do {
                                                (r += a.offsetLeft), (l += a.offsetTop);
                                            } while ((a = a.offsetParent));
                                            !0 === i ? ((o = e.pageX), (s = e.pageY)) : ((o = e.clientX), (s = e.clientY));
                                            var c = n();
                                            if (
                                                (c && ((o = document.body.offsetWidth - o), isNaN(Pe) || (r = document.body.offsetWidth - r - t.offsetWidth)),
                                                (t.style.height = s - l + Ae + "px"),
                                                (t.style.width = o - r + Ae + "px"),
                                                !isNaN(Pe))
                                            ) {
                                                var h = 0.5 * Math.abs(t.offsetWidth - Ee);
                                                c && (h *= -1), t.offsetWidth > Ee ? (t.style.left = Pe + h + "px") : t.offsetWidth >= Oe && (t.style.left = Pe - h + "px");
                                            }
                                        })(t, Ie.elements.dialog, !Ie.get("modal") && !Ie.get("pinned")));
                            }
                            function Z() {
                                if (Ie) {
                                    var e = Ie;
                                    (Ie = null), i(document.body, me.noSelection), i(e.elements.dialog, me.capture), (we = !0), u("onresized", e);
                                }
                            }
                            function ee(e) {
                                Ie = null;
                                var t = e.elements.dialog;
                                "none" === t.style.maxWidth && ((t.style.maxWidth = t.style.minWidth = t.style.width = t.style.height = t.style.minHeight = t.style.left = ""), (Pe = Number.Nan), (Ee = Oe = Ae = 0));
                            }
                            function te() {
                                for (var e = 0; e < m.length; e += 1) {
                                    var t = m[e];
                                    t.get("autoReset") && (Y(t), ee(t));
                                }
                            }
                            function ie(t) {
                                1 === m.length &&
                                    (g(e, "resize", te),
                                    g(document.body, "keyup", B),
                                    g(document.body, "keydown", R),
                                    g(document.body, "focus", z),
                                    g(document.documentElement, "mousemove", Q),
                                    g(document.documentElement, "touchmove", Q),
                                    g(document.documentElement, "mouseup", X),
                                    g(document.documentElement, "touchend", X),
                                    g(document.documentElement, "mousemove", J),
                                    g(document.documentElement, "touchmove", J),
                                    g(document.documentElement, "mouseup", Z),
                                    g(document.documentElement, "touchend", Z)),
                                    g(t.elements.commands.container, "click", t.__internal.commandsClickHandler),
                                    g(t.elements.footer, "click", t.__internal.buttonsClickHandler),
                                    g(t.elements.reset[0], "focus", t.__internal.resetHandler),
                                    g(t.elements.reset[1], "focus", t.__internal.resetHandler),
                                    (ke = !0),
                                    g(t.elements.dialog, w.type, t.__internal.transitionInHandler),
                                    t.get("modal") || ne(t),
                                    t.get("resizable") && re(t),
                                    t.get("movable") && se(t);
                            }
                            function ne(e) {
                                g(e.elements.dialog, "focus", e.__internal.bringToFrontHandler, !0);
                            }
                            function oe(e) {
                                v(e.elements.dialog, "focus", e.__internal.bringToFrontHandler, !0);
                            }
                            function se(e) {
                                g(e.elements.header, "mousedown", e.__internal.beginMoveHandler), g(e.elements.header, "touchstart", e.__internal.beginMoveHandler);
                            }
                            function ae(e) {
                                v(e.elements.header, "mousedown", e.__internal.beginMoveHandler), v(e.elements.header, "touchstart", e.__internal.beginMoveHandler);
                            }
                            function re(e) {
                                g(e.elements.resizeHandle, "mousedown", e.__internal.beginResizeHandler), g(e.elements.resizeHandle, "touchstart", e.__internal.beginResizeHandler);
                            }
                            function le(e) {
                                v(e.elements.resizeHandle, "mousedown", e.__internal.beginResizeHandler), v(e.elements.resizeHandle, "touchstart", e.__internal.beginResizeHandler);
                            }
                            var ce,
                                he,
                                de = [],
                                ue = null,
                                pe = e.navigator.userAgent.indexOf("Safari") > -1 && e.navigator.userAgent.indexOf("Chrome") < 0,
                                fe = {
                                    dimmer: '<div class="ajs-dimmer"></div>',
                                    modal: '<div class="ajs-modal" tabindex="0"></div>',
                                    dialog: '<div class="ajs-dialog" tabindex="0"></div>',
                                    reset: '<button class="ajs-reset"></button>',
                                    commands: '<div class="ajs-commands"><button class="ajs-pin"></button><button class="ajs-maximize"></button><button class="ajs-close"></button></div>',
                                    header: '<div class="ajs-header"></div>',
                                    body: '<div class="ajs-body"></div>',
                                    content: '<div class="ajs-content"></div>',
                                    footer: '<div class="ajs-footer"></div>',
                                    buttons: { primary: '<div class="ajs-primary ajs-buttons"></div>', auxiliary: '<div class="ajs-auxiliary ajs-buttons"></div>' },
                                    button: '<button class="ajs-button"></button>',
                                    resizeHandle: '<div class="ajs-handle"></div>',
                                },
                                me = {
                                    animationIn: "ajs-in",
                                    animationOut: "ajs-out",
                                    base: "alertify",
                                    basic: "ajs-basic",
                                    capture: "ajs-capture",
                                    closable: "ajs-closable",
                                    fixed: "ajs-fixed",
                                    frameless: "ajs-frameless",
                                    hidden: "ajs-hidden",
                                    maximize: "ajs-maximize",
                                    maximized: "ajs-maximized",
                                    maximizable: "ajs-maximizable",
                                    modeless: "ajs-modeless",
                                    movable: "ajs-movable",
                                    noSelection: "ajs-no-selection",
                                    noOverflow: "ajs-no-overflow",
                                    noPadding: "ajs-no-padding",
                                    pin: "ajs-pin",
                                    pinnable: "ajs-pinnable",
                                    prefix: "ajs-",
                                    resizable: "ajs-resizable",
                                    restore: "ajs-restore",
                                    shake: "ajs-shake",
                                    unpinned: "ajs-unpinned",
                                },
                                ge = "",
                                ve = 0,
                                we = !1,
                                ke = !1,
                                ye = null,
                                be = 0,
                                Se = 0,
                                Ce = "pageX",
                                _e = "pageY",
                                xe = null,
                                Te = !1,
                                He = null,
                                Ie = null,
                                Pe = Number.Nan,
                                Ee = 0,
                                Oe = 0,
                                Ae = 0;
                            return {
                                __init: a,
                                isOpen: function () {
                                    return this.__internal.isOpen;
                                },
                                isModal: function () {
                                    return this.elements.root.className.indexOf(me.modeless) < 0;
                                },
                                isMaximized: function () {
                                    return this.elements.root.className.indexOf(me.maximized) > -1;
                                },
                                isPinned: function () {
                                    return this.elements.root.className.indexOf(me.unpinned) < 0;
                                },
                                maximize: function () {
                                    return this.isMaximized() || O(this), this;
                                },
                                restore: function () {
                                    return this.isMaximized() && A(this), this;
                                },
                                pin: function () {
                                    return this.isPinned() || P(this), this;
                                },
                                unpin: function () {
                                    return this.isPinned() && E(this), this;
                                },
                                bringToFront: function () {
                                    return _(0, this), this;
                                },
                                moveTo: function (e, t) {
                                    if (!isNaN(e) && !isNaN(t)) {
                                        u("onmove", this);
                                        var i = this.elements.dialog,
                                            o = i,
                                            s = 0,
                                            a = 0;
                                        i.style.left && (s -= parseInt(i.style.left, 10)), i.style.top && (a -= parseInt(i.style.top, 10));
                                        do {
                                            (s += o.offsetLeft), (a += o.offsetTop);
                                        } while ((o = o.offsetParent));
                                        var r = e - s,
                                            l = t - a;
                                        n() && (r *= -1), (i.style.left = r + "px"), (i.style.top = l + "px"), u("onmoved", this);
                                    }
                                    return this;
                                },
                                resizeTo: function (e, t) {
                                    var i = parseFloat(e),
                                        n = parseFloat(t),
                                        o = /(\d*\.\d+|\d+)%/;
                                    if (!isNaN(i) && !isNaN(n) && !0 === this.get("resizable")) {
                                        u("onresize", this), ("" + e).match(o) && (i = (i / 100) * document.documentElement.clientWidth), ("" + t).match(o) && (n = (n / 100) * document.documentElement.clientHeight);
                                        var s = this.elements.dialog;
                                        "none" !== s.style.maxWidth && (s.style.minWidth = (Oe = s.offsetWidth) + "px"),
                                            (s.style.maxWidth = "none"),
                                            (s.style.minHeight = this.elements.header.offsetHeight + this.elements.footer.offsetHeight + "px"),
                                            (s.style.width = i + "px"),
                                            (s.style.height = n + "px"),
                                            u("onresized", this);
                                    }
                                    return this;
                                },
                                setting: function (e, t) {
                                    var i = this,
                                        n = T(
                                            this,
                                            this.__internal.options,
                                            function (e, t, n) {
                                                x(i, e, t, n);
                                            },
                                            e,
                                            t
                                        );
                                    if ("get" === n.op) return n.found ? n.value : void 0 !== this.settings ? T(this, this.settings, this.settingUpdated || function () {}, e, t).value : void 0;
                                    if ("set" === n.op) {
                                        if (n.items.length > 0)
                                            for (var o = this.settingUpdated || function () {}, s = 0; s < n.items.length; s += 1) {
                                                var a = n.items[s];
                                                a.found || void 0 === this.settings || T(this, this.settings, o, a.key, a.value);
                                            }
                                        return this;
                                    }
                                },
                                set: function (e, t) {
                                    return this.setting(e, t), this;
                                },
                                get: function (e) {
                                    return this.setting(e);
                                },
                                setHeader: function (t) {
                                    return (
                                        "string" == typeof t
                                            ? (r(this.elements.header), (this.elements.header.innerHTML = t))
                                            : t instanceof e.HTMLElement && this.elements.header.firstChild !== t && (r(this.elements.header), this.elements.header.appendChild(t)),
                                        this
                                    );
                                },
                                setContent: function (t) {
                                    return (
                                        "string" == typeof t
                                            ? (r(this.elements.content), (this.elements.content.innerHTML = t))
                                            : t instanceof e.HTMLElement && this.elements.content.firstChild !== t && (r(this.elements.content), this.elements.content.appendChild(t)),
                                        this
                                    );
                                },
                                showModal: function (e) {
                                    return this.show(!0, e);
                                },
                                show: function (e, n) {
                                    if ((a(this), this.__internal.isOpen)) {
                                        Y(this), ee(this), t(this.elements.dialog, me.shake);
                                        var o = this;
                                        setTimeout(function () {
                                            i(o.elements.dialog, me.shake);
                                        }, 200);
                                    } else {
                                        if (
                                            ((this.__internal.isOpen = !0),
                                            m.push(this),
                                            b.defaults.maintainFocus && (this.__internal.activeElement = document.activeElement),
                                            "function" == typeof this.prepare && this.prepare(),
                                            ie(this),
                                            void 0 !== e && this.set("modal", e),
                                            f(),
                                            y(),
                                            "string" == typeof n && "" !== n && ((this.__internal.className = n), t(this.elements.root, n)),
                                            this.get("startMaximized") ? this.maximize() : this.isMaximized() && A(this),
                                            U(this),
                                            i(this.elements.root, me.animationOut),
                                            t(this.elements.root, me.animationIn),
                                            clearTimeout(this.__internal.timerIn),
                                            (this.__internal.timerIn = setTimeout(this.__internal.transitionInHandler, w.supported ? 1e3 : 100)),
                                            pe)
                                        ) {
                                            var s = this.elements.root;
                                            (s.style.display = "none"),
                                                setTimeout(function () {
                                                    s.style.display = "block";
                                                }, 0);
                                        }
                                        (ue = this.elements.root.offsetWidth), i(this.elements.root, me.hidden), "function" == typeof this.hooks.onshow && this.hooks.onshow.call(this), u("onshow", this);
                                    }
                                    return this;
                                },
                                close: function () {
                                    return (
                                        this.__internal.isOpen &&
                                            ((function (t) {
                                                1 === m.length &&
                                                    (v(e, "resize", te),
                                                    v(document.body, "keyup", B),
                                                    v(document.body, "keydown", R),
                                                    v(document.body, "focus", z),
                                                    v(document.documentElement, "mousemove", Q),
                                                    v(document.documentElement, "mouseup", X),
                                                    v(document.documentElement, "mousemove", J),
                                                    v(document.documentElement, "mouseup", Z)),
                                                    v(t.elements.commands.container, "click", t.__internal.commandsClickHandler),
                                                    v(t.elements.footer, "click", t.__internal.buttonsClickHandler),
                                                    v(t.elements.reset[0], "focus", t.__internal.resetHandler),
                                                    v(t.elements.reset[1], "focus", t.__internal.resetHandler),
                                                    g(t.elements.dialog, w.type, t.__internal.transitionOutHandler),
                                                    t.get("modal") || oe(t),
                                                    t.get("movable") && ae(t),
                                                    t.get("resizable") && le(t);
                                            })(this),
                                            i(this.elements.root, me.animationIn),
                                            t(this.elements.root, me.animationOut),
                                            clearTimeout(this.__internal.timerOut),
                                            (this.__internal.timerOut = setTimeout(this.__internal.transitionOutHandler, w.supported ? 1e3 : 100)),
                                            t(this.elements.root, me.hidden),
                                            (ue = this.elements.modal.offsetWidth),
                                            void 0 !== this.__internal.className && "" !== this.__internal.className && i(this.elements.root, this.__internal.className),
                                            "function" == typeof this.hooks.onclose && this.hooks.onclose.call(this),
                                            u("onclose", this),
                                            m.splice(m.indexOf(this), 1),
                                            (this.__internal.isOpen = !1),
                                            y()),
                                        this
                                    );
                                },
                                closeOthers: function () {
                                    return b.closeAll(this), this;
                                },
                                destroy: function () {
                                    return (
                                        this.__internal.isOpen
                                            ? ((this.__internal.destroy = function () {
                                                  c(this, a);
                                              }),
                                              this.close())
                                            : c(this, a),
                                        this
                                    );
                                },
                            };
                        })(),
                        y = (function () {
                            function n(e) {
                                e.__internal || ((e.__internal = { position: b.defaults.notifier.position, delay: b.defaults.notifier.delay }), (c = document.createElement("DIV")), a(e)),
                                    c.parentNode !== document.body && document.body.appendChild(c);
                            }
                            function o(e) {
                                (e.__internal.pushed = !0), d.push(e);
                            }
                            function s(e) {
                                d.splice(d.indexOf(e), 1), (e.__internal.pushed = !1);
                            }
                            function a(e) {
                                switch (((c.className = u.base), e.__internal.position)) {
                                    case "top-right":
                                        t(c, u.top + " " + u.right);
                                        break;
                                    case "top-left":
                                        t(c, u.top + " " + u.left);
                                        break;
                                    case "bottom-left":
                                        t(c, u.bottom + " " + u.left);
                                        break;
                                    default:
                                    case "bottom-right":
                                        t(c, u.bottom + " " + u.right);
                                }
                            }
                            function l(n, a) {
                                function l(e, t) {
                                    t.dismiss(!0);
                                }
                                function d(e, t) {
                                    v(t.element, w.type, d), c.removeChild(t.element);
                                }
                                function p(e) {
                                    clearTimeout(e.__internal.timer), clearTimeout(e.__internal.transitionTimeout);
                                }
                                return (function (e) {
                                    return (
                                        e.__internal ||
                                            ((e.__internal = { pushed: !1, delay: void 0, timer: void 0, clickHandler: void 0, transitionEndHandler: void 0, transitionTimeout: void 0 }),
                                            (e.__internal.clickHandler = h(e, l)),
                                            (e.__internal.transitionEndHandler = h(e, d))),
                                        e
                                    );
                                })({
                                    element: n,
                                    push: function (e, i) {
                                        if (!this.__internal.pushed) {
                                            var n, s;
                                            switch ((o(this), p(this), arguments.length)) {
                                                case 0:
                                                    s = this.__internal.delay;
                                                    break;
                                                case 1:
                                                    "number" == typeof e ? (s = e) : ((n = e), (s = this.__internal.delay));
                                                    break;
                                                case 2:
                                                    (n = e), (s = i);
                                            }
                                            return (
                                                void 0 !== n && this.setContent(n),
                                                y.__internal.position.indexOf("top") < 0 ? c.appendChild(this.element) : c.insertBefore(this.element, c.firstChild),
                                                this.element.offsetWidth,
                                                t(this.element, u.visible),
                                                g(this.element, "click", this.__internal.clickHandler),
                                                this.delay(s)
                                            );
                                        }
                                        return this;
                                    },
                                    ondismiss: function () {},
                                    callback: a,
                                    dismiss: function (e) {
                                        return (
                                            this.__internal.pushed &&
                                                (p(this),
                                                ("function" != typeof this.ondismiss || !1 !== this.ondismiss.call(this)) &&
                                                    (v(this.element, "click", this.__internal.clickHandler),
                                                    void 0 !== this.element &&
                                                        this.element.parentNode === c &&
                                                        ((this.__internal.transitionTimeout = setTimeout(this.__internal.transitionEndHandler, w.supported ? 1e3 : 100)),
                                                        i(this.element, u.visible),
                                                        "function" == typeof this.callback && this.callback.call(this, e)),
                                                    s(this))),
                                            this
                                        );
                                    },
                                    delay: function (e) {
                                        if ((p(this), (this.__internal.delay = void 0 === e || isNaN(+e) ? y.__internal.delay : +e), this.__internal.delay > 0)) {
                                            var t = this;
                                            this.__internal.timer = setTimeout(function () {
                                                t.dismiss();
                                            }, 1e3 * this.__internal.delay);
                                        }
                                        return this;
                                    },
                                    setContent: function (t) {
                                        return "string" == typeof t ? (r(this.element), (this.element.innerHTML = t)) : t instanceof e.HTMLElement && this.element.firstChild !== t && (r(this.element), this.element.appendChild(t)), this;
                                    },
                                    dismissOthers: function () {
                                        return y.dismissAll(this), this;
                                    },
                                });
                            }
                            var c,
                                d = [],
                                u = { base: "alertify-notifier", message: "ajs-message", top: "ajs-top", right: "ajs-right", bottom: "ajs-bottom", left: "ajs-left", visible: "ajs-visible", hidden: "ajs-hidden" };
                            return {
                                setting: function (e, t) {
                                    if ((n(this), void 0 === t)) return this.__internal[e];
                                    switch (e) {
                                        case "position":
                                            (this.__internal.position = t), a(this);
                                            break;
                                        case "delay":
                                            this.__internal.delay = t;
                                    }
                                    return this;
                                },
                                set: function (e, t) {
                                    return this.setting(e, t), this;
                                },
                                get: function (e) {
                                    return this.setting(e);
                                },
                                create: function (e, t) {
                                    n(this);
                                    var i = document.createElement("div");
                                    return (i.className = u.message + ("string" == typeof e && "" !== e ? " ajs-" + e : "")), l(i, t);
                                },
                                dismissAll: function (e) {
                                    for (var t = d.slice(0), i = 0; i < t.length; i += 1) {
                                        var n = t[i];
                                        (void 0 === e || e !== n) && n.dismiss();
                                    }
                                },
                            };
                        })(),
                        b = new (function () {
                            function e(e, t) {
                                for (var i in t) t.hasOwnProperty(i) && (e[i] = t[i]);
                                return e;
                            }
                            function t(e) {
                                var t = n[e].dialog;
                                return t && "function" == typeof t.__init && t.__init(t), t;
                            }
                            function i(t, i, o, s) {
                                var a = { dialog: null, factory: i };
                                return (
                                    void 0 !== s &&
                                        (a.factory = function () {
                                            return e(new n[s].factory(), new i());
                                        }),
                                    o || (a.dialog = e(new a.factory(), k)),
                                    (n[t] = a)
                                );
                            }
                            var n = {};
                            return {
                                defaults: f,
                                dialog: function (n, o, s, a) {
                                    if ("function" != typeof o) return t(n);
                                    if (this.hasOwnProperty(n)) throw new Error("alertify.dialog: name already exists");
                                    var r = i(n, o, s, a);
                                    this[n] = s
                                        ? function () {
                                              if (0 === arguments.length) return r.dialog;
                                              var t = e(new r.factory(), k);
                                              return t && "function" == typeof t.__init && t.__init(t), t.main.apply(t, arguments), t.show.apply(t);
                                          }
                                        : function () {
                                              if ((r.dialog && "function" == typeof r.dialog.__init && r.dialog.__init(r.dialog), 0 === arguments.length)) return r.dialog;
                                              var e = r.dialog;
                                              return e.main.apply(r.dialog, arguments), e.show.apply(r.dialog);
                                          };
                                },
                                closeAll: function (e) {
                                    for (var t = m.slice(0), i = 0; i < t.length; i += 1) {
                                        var n = t[i];
                                        (void 0 === e || e !== n) && n.close();
                                    }
                                },
                                setting: function (e, i, n) {
                                    if ("notifier" === e) return y.setting(i, n);
                                    var o = t(e);
                                    return o ? o.setting(i, n) : void 0;
                                },
                                set: function (e, t, i) {
                                    return this.setting(e, t, i);
                                },
                                get: function (e, t) {
                                    return this.setting(e, t);
                                },
                                notify: function (e, t, i, n) {
                                    return y.create(t, n).push(e, i);
                                },
                                message: function (e, t, i) {
                                    return y.create(null, i).push(e, t);
                                },
                                success: function (e, t, i) {
                                    return y.create("success", i).push(e, t);
                                },
                                error: function (e, t, i) {
                                    return y.create("error", i).push(e, t);
                                },
                                warning: function (e, t, i) {
                                    return y.create("warning", i).push(e, t);
                                },
                                dismissAll: function () {
                                    y.dismissAll();
                                },
                            };
                        })();
                    b.dialog("alert", function () {
                        return {
                            main: function (e, t, i) {
                                var n, o, s;
                                switch (arguments.length) {
                                    case 1:
                                        o = e;
                                        break;
                                    case 2:
                                        "function" == typeof t ? ((o = e), (s = t)) : ((n = e), (o = t));
                                        break;
                                    case 3:
                                        (n = e), (o = t), (s = i);
                                }
                                return this.set("title", n), this.set("message", o), this.set("onok", s), this;
                            },
                            setup: function () {
                                return { buttons: [{ text: b.defaults.glossary.ok, key: p.ESC, invokeOnClose: !0, className: b.defaults.theme.ok }], focus: { element: 0, select: !1 }, options: { maximizable: !1, resizable: !1 } };
                            },
                            build: function () {},
                            prepare: function () {},
                            setMessage: function (e) {
                                this.setContent(e);
                            },
                            settings: { message: void 0, onok: void 0, label: void 0 },
                            settingUpdated: function (e, t, i) {
                                switch (e) {
                                    case "message":
                                        this.setMessage(i);
                                        break;
                                    case "label":
                                        this.__internal.buttons[0].element && (this.__internal.buttons[0].element.innerHTML = i);
                                }
                            },
                            callback: function (e) {
                                if ("function" == typeof this.get("onok")) {
                                    var t = this.get("onok").call(this, e);
                                    void 0 !== t && (e.cancel = !t);
                                }
                            },
                        };
                    }),
                        b.dialog("confirm", function () {
                            function e(e) {
                                null !== i.timer && (clearInterval(i.timer), (i.timer = null), (e.__internal.buttons[i.index].element.innerHTML = i.text));
                            }
                            function t(t, n, o) {
                                e(t), (i.duration = o), (i.index = n), (i.text = t.__internal.buttons[n].element.innerHTML), (i.timer = setInterval(h(t, i.task), 1e3)), i.task(null, t);
                            }
                            var i = {
                                timer: null,
                                index: null,
                                text: null,
                                duration: null,
                                task: function (t, n) {
                                    if (n.isOpen()) {
                                        if (((n.__internal.buttons[i.index].element.innerHTML = i.text + " (&#8207;" + i.duration + "&#8207;) "), (i.duration -= 1), -1 === i.duration)) {
                                            e(n);
                                            var o = n.__internal.buttons[i.index],
                                                s = d(i.index, o);
                                            "function" == typeof n.callback && n.callback.apply(n, [s]), !1 !== s.close && n.close();
                                        }
                                    } else e(n);
                                },
                            };
                            return {
                                main: function (e, t, i, n) {
                                    var o, s, a, r;
                                    switch (arguments.length) {
                                        case 1:
                                            s = e;
                                            break;
                                        case 2:
                                            (s = e), (a = t);
                                            break;
                                        case 3:
                                            (s = e), (a = t), (r = i);
                                            break;
                                        case 4:
                                            (o = e), (s = t), (a = i), (r = n);
                                    }
                                    return this.set("title", o), this.set("message", s), this.set("onok", a), this.set("oncancel", r), this;
                                },
                                setup: function () {
                                    return {
                                        buttons: [
                                            { text: b.defaults.glossary.ok, key: p.ENTER, className: b.defaults.theme.ok },
                                            { text: b.defaults.glossary.cancel, key: p.ESC, invokeOnClose: !0, className: b.defaults.theme.cancel },
                                        ],
                                        focus: { element: 0, select: !1 },
                                        options: { maximizable: !1, resizable: !1 },
                                    };
                                },
                                build: function () {},
                                prepare: function () {},
                                setMessage: function (e) {
                                    this.setContent(e);
                                },
                                settings: { message: null, labels: null, onok: null, oncancel: null, defaultFocus: null, reverseButtons: null },
                                settingUpdated: function (e, t, i) {
                                    switch (e) {
                                        case "message":
                                            this.setMessage(i);
                                            break;
                                        case "labels":
                                            "ok" in i && this.__internal.buttons[0].element && ((this.__internal.buttons[0].text = i.ok), (this.__internal.buttons[0].element.innerHTML = i.ok)),
                                                "cancel" in i && this.__internal.buttons[1].element && ((this.__internal.buttons[1].text = i.cancel), (this.__internal.buttons[1].element.innerHTML = i.cancel));
                                            break;
                                        case "reverseButtons":
                                            !0 === i ? this.elements.buttons.primary.appendChild(this.__internal.buttons[0].element) : this.elements.buttons.primary.appendChild(this.__internal.buttons[1].element);
                                            break;
                                        case "defaultFocus":
                                            this.__internal.focus.element = "ok" === i ? 0 : 1;
                                    }
                                },
                                callback: function (t) {
                                    var i;
                                    switch ((e(this), t.index)) {
                                        case 0:
                                            "function" == typeof this.get("onok") && void 0 !== (i = this.get("onok").call(this, t)) && (t.cancel = !i);
                                            break;
                                        case 1:
                                            "function" == typeof this.get("oncancel") && void 0 !== (i = this.get("oncancel").call(this, t)) && (t.cancel = !i);
                                    }
                                },
                                autoOk: function (e) {
                                    return t(this, 0, e), this;
                                },
                                autoCancel: function (e) {
                                    return t(this, 1, e), this;
                                },
                            };
                        }),
                        b.dialog("prompt", function () {
                            var t = document.createElement("INPUT"),
                                i = document.createElement("P");
                            return {
                                main: function (e, t, i, n, o) {
                                    var s, a, r, l, c;
                                    switch (arguments.length) {
                                        case 1:
                                            a = e;
                                            break;
                                        case 2:
                                            (a = e), (r = t);
                                            break;
                                        case 3:
                                            (a = e), (r = t), (l = i);
                                            break;
                                        case 4:
                                            (a = e), (r = t), (l = i), (c = n);
                                            break;
                                        case 5:
                                            (s = e), (a = t), (r = i), (l = n), (c = o);
                                    }
                                    return this.set("title", s), this.set("message", a), this.set("value", r), this.set("onok", l), this.set("oncancel", c), this;
                                },
                                setup: function () {
                                    return {
                                        buttons: [
                                            { text: b.defaults.glossary.ok, key: p.ENTER, className: b.defaults.theme.ok },
                                            { text: b.defaults.glossary.cancel, key: p.ESC, invokeOnClose: !0, className: b.defaults.theme.cancel },
                                        ],
                                        focus: { element: t, select: !0 },
                                        options: { maximizable: !1, resizable: !1 },
                                    };
                                },
                                build: function () {
                                    (t.className = b.defaults.theme.input), t.setAttribute("type", "text"), (t.value = this.get("value")), this.elements.content.appendChild(i), this.elements.content.appendChild(t);
                                },
                                prepare: function () {},
                                setMessage: function (t) {
                                    "string" == typeof t ? (r(i), (i.innerHTML = t)) : t instanceof e.HTMLElement && i.firstChild !== t && (r(i), i.appendChild(t));
                                },
                                settings: { message: void 0, labels: void 0, onok: void 0, oncancel: void 0, value: "", type: "text", reverseButtons: void 0 },
                                settingUpdated: function (e, i, n) {
                                    switch (e) {
                                        case "message":
                                            this.setMessage(n);
                                            break;
                                        case "value":
                                            t.value = n;
                                            break;
                                        case "type":
                                            switch (n) {
                                                case "text":
                                                case "color":
                                                case "date":
                                                case "datetime-local":
                                                case "email":
                                                case "month":
                                                case "number":
                                                case "password":
                                                case "search":
                                                case "tel":
                                                case "time":
                                                case "week":
                                                    t.type = n;
                                                    break;
                                                default:
                                                    t.type = "text";
                                            }
                                            break;
                                        case "labels":
                                            n.ok && this.__internal.buttons[0].element && (this.__internal.buttons[0].element.innerHTML = n.ok),
                                                n.cancel && this.__internal.buttons[1].element && (this.__internal.buttons[1].element.innerHTML = n.cancel);
                                            break;
                                        case "reverseButtons":
                                            !0 === n ? this.elements.buttons.primary.appendChild(this.__internal.buttons[0].element) : this.elements.buttons.primary.appendChild(this.__internal.buttons[1].element);
                                    }
                                },
                                callback: function (e) {
                                    var i;
                                    switch (e.index) {
                                        case 0:
                                            (this.settings.value = t.value), "function" == typeof this.get("onok") && void 0 !== (i = this.get("onok").call(this, e, this.settings.value)) && (e.cancel = !i);
                                            break;
                                        case 1:
                                            "function" == typeof this.get("oncancel") && void 0 !== (i = this.get("oncancel").call(this, e)) && (e.cancel = !i), e.cancel || (t.value = this.settings.value);
                                    }
                                },
                            };
                        }),
                        "object" == typeof module && "object" == typeof module.exports
                            ? (module.exports = b)
                            : "function" == typeof a && a.amd
                            ? a([], function () {
                                  return b;
                              })
                            : e.alertify || (e.alertify = b);
                })("undefined" != typeof window ? window : this);
    }
})((window.HawkSearchLoader = window.HawkSearchLoader || {})),
    (HawkSearch.Dictionary = (function () {
        function e() {
            if (!(this instanceof e)) return new e();
        }
        return (
            (e.prototype.count = function () {
                var e,
                    t = 0;
                for (e in this) this.hasOwnProperty(e) && (t += 1);
                return t;
            }),
            (e.prototype.keys = function () {
                var e,
                    t = [];
                for (e in this) this.hasOwnProperty(e) && t.push(e);
                return t;
            }),
            (e.prototype.values = function () {
                var e,
                    t = [];
                for (e in this) this.hasOwnProperty(e) && t.push(this[e]);
                return t;
            }),
            (e.prototype.keyValuePairs = function () {
                var e,
                    t = [];
                for (e in this) this.hasOwnProperty(e) && t.push({ Key: e, Value: this[e] });
                return t;
            }),
            (e.prototype.add = function (e, t) {
                this[e] = t;
            }),
            (e.prototype.clear = function () {
                var e;
                for (e in this) this.hasOwnProperty(e) && delete this[e];
            }),
            (e.prototype.containsKey = function (e) {
                return this.hasOwnProperty(e);
            }),
            (e.prototype.containsValue = function (e) {
                var t;
                for (t in this) if (this.hasOwnProperty(t) && this[t] === e) return !0;
                return !1;
            }),
            (e.prototype.remove = function (e) {
                return !!this.hasOwnProperty(e) && (delete this[e], !0);
            }),
            e
        );
    })()),
    (HawkSearch.ContextObj = function () {}),
    (HawkSearch.ContextObj.prototype = new HawkSearch.Dictionary()),
    (HawkSearch.ContextObj.prototype.Custom = new HawkSearch.Dictionary()),
    (HawkSearch.Context = new HawkSearch.ContextObj());